// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./styles/fonts/SomarSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./styles/fonts/SomarSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./styles/fonts/SomarSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./components/client/actions/info.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Start Font Import */
@font-face {
  font-family: "Somar";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: bold;
}
@font-face {
  font-family: "Somar";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
}
@font-face {
  font-family: "Somar";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 600;
}
/* End Font Import */
/* Start Main Rules */
:root {
  --main-color: #f8b34f;
  --dark-color: #1f2034;
}

html {
  height: -webkit-fill-available;
}

body[lang=ar] {
  font-family: "Somar", sans-serif;
  direction: rtl;
  scroll-behavior: smooth;
  margin: 0;
  padding: 0;
  background-color: #cfd3d6;
  height: 100dvh;
  width: 100%;
  overflow-x: hidden;
}
body[lang=ar] input,
body[lang=ar] select,
body[lang=ar] textarea {
  font-family: "Somar", sans-serif !important;
}
body[lang=ar] .Toastify * {
  z-index: 5656565656;
  font-family: "Somar", sans-serif !important;
}

/* End Main Rules */
.service-info {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 8888;
  top: 0;
  opacity: 1;
  left: 0;
}
.service-info .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
}
.service-info .container {
  width: 500px;
  height: 700px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.service-info .container .section {
  position: relative;
  overflow: hidden;
  border-radius: 20px;
}
.service-info .container .section:hover .image img {
  filter: grayscale(0%);
  transition: 0.5s;
}
.service-info .container .section:hover .data {
  left: 0;
  opacity: 1;
  transition: opacity 0.5s;
}
.service-info .container .section .data.active {
  left: 0;
  opacity: 1;
  transition: opacity 0.5s;
}
.service-info .container .section .image.active img {
  filter: grayscale(0%);
  transition: 0.5s;
}
.service-info .container .section .image {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
}
.service-info .container .section .image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(100%);
  transition: 0.5s;
}
.service-info .container .section .data {
  position: absolute;
  top: 0;
  opacity: 0;
  transition: opacity 0.5s;
  height: calc(100% - 20px);
  width: calc(100% - 20px);
  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  padding: 10px;
  border-radius: 20px;
  color: #fff;
  left: -100%;
}
.service-info .container .section .data .title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
}
.service-info .container .section .data .title::before {
  content: "";
  width: 100%;
  height: 1px;
  background-color: #fff;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -10px;
}
.service-info .container .section .data .desc {
  font-size: 14px;
  text-align: center;
}

.image-info {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 8888;
  top: 0;
  opacity: 0;
  opacity: 1;
  left: 0;
}
.image-info .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
}
.image-info .container {
  width: 90%;
  height: 70%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.image-info .container .section {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
}
.image-info .container .section:hover .image img {
  filter: grayscale(0%);
  transition: 0.5s;
}
.image-info .container .section:hover .data {
  left: 0;
  opacity: 1;
  transition: opacity 0.5s;
}
.image-info .container .section .image {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
}
.image-info .container .section .image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(100%);
  transition: 0.5s;
}
.image-info .container .section .data {
  position: absolute;
  top: 0;
  opacity: 0;
  transition: opacity 0.5s;
  height: calc(100% - 20px);
  width: calc(100% - 20px);
  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: start;
  padding: 10px;
  border-radius: 20px;
  color: #fff;
  left: -100%;
}
.image-info .container .section .data .title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
  margin-right: 30px;
}

.video-info {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 8888;
  top: 0;
  opacity: 0;
  opacity: 1;
  left: 0;
}
.video-info .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
}
.video-info .container {
  width: 90%;
  height: 70%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.video-info .container .section {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
}
.video-info .container .section:hover .image img {
  filter: grayscale(0%);
  transition: 0.5s;
}
.video-info .container .section:hover .data {
  left: 0;
  opacity: 1;
  transition: opacity 0.5s;
}
.video-info .container .section .image {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
}
.video-info .container .section .image video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.5s;
}
.video-info .container .section .data {
  position: absolute;
  top: 0;
  opacity: 0;
  transition: opacity 0.5s;
  height: calc(100% - 20px);
  width: calc(100% - 20px);
  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: start;
  padding: 10px;
  border-radius: 20px;
  color: #fff;
  left: -100%;
}
.video-info .container .section .data .title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
  margin-right: 30px;
}

.cases-info {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 8888;
  top: 0;
  opacity: 0;
  opacity: 1;
  left: 0;
}
.cases-info .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
}
.cases-info .container {
  width: 90%;
  max-width: 600px;
  height: 85%;
  position: absolute;
  left: 50%;
  top: 50%;
  max-height: 85%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  flex-direction: column;
  background-color: #f6f1ea;
  border-radius: 20px;
}
.cases-info .container .image {
  width: 90%;
  height: 220px !important;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  margin: 20px auto 0;
}
.cases-info .container .image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.5s;
}
.cases-info .container .image .title {
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);
  color: #fff;
  font-weight: bold;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: end;
  padding-bottom: 10px;
}
.cases-info .container .texts {
  height: calc(100% - 260px);
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: scroll;
  margin: 20px auto 0;
  padding-bottom: 20px;
  width: calc(100% - 60px);
  gap: 10px;
}
.cases-info .container .texts .text {
  width: 100%;
  color: #413634;
  font-size: 12px;
  font-weight: bold;
  position: relative;
  padding-right: 30px;
  width: calc(100% - 29px);
}
.cases-info .container .texts .text::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  position: absolute;
  top: 13px;
  right: 0;
  transform: translateY(-50%);
  width: 18px; /* Width of your SVG */
  height: 18px; /* Height of your SVG */
}

@media (max-width: 768px) {
  .service-info .container {
    width: 300px;
    height: 500px;
  }
}
.header {
  width: 100%;
  height: 60px;
  background-color: #413634;
  position: fixed;
  z-index: 6666;
  top: 0;
  left: 0;
  color: #c7c7c7;
  display: flex;
  justify-content: space-evenly;
  gap: 10px;
}
.header .link {
  width: max-content;
  height: 100%;
  display: flex;
  justify-content: center;
  color: #c7c7c7;
  align-items: center;
  text-decoration: none;
  font-size: 18px;
  transition: 0.5s;
}
.header .link.active, .header .link:hover {
  transition: 0.5s;
  color: #fff;
}

@media (max-width: 768px) {
  .header {
    width: 100%;
  }
  .header .link {
    font-size: 12px;
  }
}
.footer {
  width: 100%;
  height: 400px;
  background-color: #413634;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
.footer .head-title {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0;
  color: #fff;
}
.footer .container {
  width: 100%;
  height: calc(100% - 60px);
  display: flex;
  justify-content: space-between;
}
.footer .container .group {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 30%;
  height: 100%;
  align-items: center;
  gap: 20px;
  position: relative;
}
.footer .container .group:not(:last-of-type)::after {
  content: "";
  left: -20px;
  position: absolute;
  top: 50%;
  border-radius: 10px;
  width: 2px;
  height: 80%;
  background-color: #707070;
  transform: translateY(-50%);
  transition: 0.1s;
}
.footer .container .group .logo {
  width: 150px;
  height: 150px;
}
.footer .container .group .logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.footer .container .group .grouping {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.footer .container .group .grouping .title {
  font-size: 32px;
  font-weight: bold;
}
.footer .container .group .grouping .name {
  font-size: 22px;
  font-weight: 600;
}
.footer .container .group .section {
  width: 100%;
  display: flex;
  gap: 10px;
  height: max-content;
  justify-content: space-between;
  align-items: center;
}
.footer .container .group .section .icon {
  height: 30px;
  width: 30px;
}
.footer .container .group .section .section-grouping {
  display: flex;
  flex-direction: column;
  color: #fff;
  height: 100%;
  width: calc(98% - 40px);
}
.footer .container .group .section .section-grouping .value {
  font-weight: bold;
  font-size: 12px;
}
.footer .container .group .copyright {
  width: 105%;
  height: 60px;
  background-color: #fff;
  border: 1px solid #000;
  position: relative;
  left: -15%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  direction: ltr;
  gap: 20px;
}
.footer .container .group .copyright .grouping2 {
  display: flex;
  flex-direction: column;
}
.footer .container .group .copyright .title {
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer .container .group .copyright .value {
  font-weight: bold;
}

@media (max-width: 768px) {
  .footer .container .group {
    gap: 40px;
    padding: 0 10px;
    width: calc(100% - 20px);
  }
  .footer .container .group:first-of-type {
    display: none;
  }
  .footer .container .group:last-of-type {
    display: none;
  }
}
.certificate-add-action {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 88888;
  top: 0;
  opacity: 0;
  opacity: 1;
  left: 0;
}
.certificate-add-action .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
  left: 0;
  top: 0;
}
.certificate-add-action .container {
  width: 90%;
  max-width: 600px;
  height: max-content !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  flex-direction: column;
  background-color: #f6f1ea;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
}
.certificate-add-action .container .title {
  font-size: 24px;
  font-weight: bold;
}
.certificate-add-action .container .image {
  width: 90%;
  height: 320px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.certificate-add-action .container .image.none {
  width: 100px;
  height: 100px;
  cursor: pointer;
}
.certificate-add-action .container .image.none img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.5s;
}
.certificate-add-action .container .image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: 0.5s;
}
.certificate-add-action .container .image .title {
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);
  color: #fff;
  font-weight: bold;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: end;
  padding-bottom: 10px;
}
.certificate-add-action .container .text {
  width: 95%;
  height: max-content;
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  padding-bottom: 10px;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.certificate-add-action .container .text input {
  width: 90%;
  color: #413634;
  font-size: 15px;
  height: 40px;
  border-radius: 10px;
  outline: none;
  border: 1px solid #413634;
  font-weight: bold;
  position: relative;
  padding-right: 30px;
}
.certificate-add-action .container .add-btn {
  width: 90%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 10px;
  margin-bottom: 10px;
  background-color: #2ecc71;
}

.direction-add-action {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 88888;
  top: 0;
  opacity: 0;
  opacity: 1;
  left: 0;
}
.direction-add-action .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
  left: 0;
  top: 0;
}
.direction-add-action .container {
  width: 90%;
  max-width: 600px;
  height: max-content !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  flex-direction: column;
  background-color: #f6f1ea;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
}
.direction-add-action .container .title {
  font-size: 24px;
  font-weight: bold;
}
.direction-add-action .container .group {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 320px;
  margin-bottom: 20px;
}
.direction-add-action .container .group .image {
  width: 48%;
  min-height: 320px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  margin: 20px auto 0;
  display: flex;
  align-items: center;
  gap: 50px;
  flex-direction: column;
}
.direction-add-action .container .group .image label {
  width: 100%;
  height: 320px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.direction-add-action .container .group .image label img {
  width: 270px;
  height: 270px;
  object-fit: contain;
  transition: 0.5s;
}
.direction-add-action .container .group .image label img.none {
  width: 120px;
  height: 120px;
  object-fit: contain;
}
.direction-add-action .container .group .image label .title {
  position: relative;
  left: 0;
  top: 0;
  color: #000;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: end;
}
.direction-add-action .container .text {
  width: 95%;
  height: max-content;
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  padding-bottom: 10px;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.direction-add-action .container .text input,
.direction-add-action .container .text textarea {
  resize: none;
  width: 90%;
  color: #413634;
  font-size: 15px;
  height: 40px;
  border-radius: 10px;
  outline: none;
  border: 1px solid #413634;
  font-weight: bold;
  position: relative;
  padding-right: 30px;
}
.direction-add-action .container .text textarea {
  height: 150px;
}
.direction-add-action .container .add-btn {
  width: 90%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 10px;
  margin-bottom: 10px;
  background-color: #2ecc71;
}

.direction-edit-action {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 88888;
  top: 0;
  opacity: 0;
  opacity: 1;
  left: 0;
}
.direction-edit-action .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
  left: 0;
  top: 0;
}
.direction-edit-action .container {
  width: 90%;
  max-width: 600px;
  height: max-content !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  flex-direction: column;
  background-color: #f6f1ea;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
}
.direction-edit-action .container .title {
  font-size: 24px;
  font-weight: bold;
}
.direction-edit-action .container .group {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 320px;
  margin-bottom: 20px;
}
.direction-edit-action .container .group .image {
  width: 48%;
  min-height: 320px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  margin: 20px auto 0;
  display: flex;
  align-items: center;
  gap: 50px;
  flex-direction: column;
}
.direction-edit-action .container .group .image label {
  width: 100%;
  height: 320px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.direction-edit-action .container .group .image label img {
  width: 270px;
  height: 270px;
  object-fit: contain;
  transition: 0.5s;
}
.direction-edit-action .container .group .image label img.none {
  width: 120px;
  height: 120px;
  object-fit: contain;
}
.direction-edit-action .container .group .image label .title {
  position: relative;
  left: 0;
  top: 0;
  color: #000;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: end;
}
.direction-edit-action .container .text {
  width: 95%;
  height: max-content;
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  padding-bottom: 10px;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.direction-edit-action .container .text input,
.direction-edit-action .container .text textarea {
  resize: none;
  width: 90%;
  color: #413634;
  font-size: 15px;
  height: 40px;
  border-radius: 10px;
  outline: none;
  border: 1px solid #413634;
  font-weight: bold;
  position: relative;
  padding-right: 30px;
}
.direction-edit-action .container .text textarea {
  height: 150px;
}
.direction-edit-action .container .add-btn {
  width: 90%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 10px;
  margin-bottom: 10px;
  background-color: #2ecc71;
}

.service-add-action {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 88888;
  top: 0;
  opacity: 0;
  opacity: 1;
  left: 0;
}
.service-add-action .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
  left: 0;
  top: 0;
}
.service-add-action .container {
  width: 90%;
  max-width: 600px;
  height: max-content !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  flex-direction: column;
  background-color: #f6f1ea;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
}
.service-add-action .container .title {
  font-size: 24px;
  font-weight: bold;
}
.service-add-action .container .text {
  width: 95%;
  height: max-content;
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  padding-bottom: 10px;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.service-add-action .container .text input,
.service-add-action .container .text textarea {
  resize: none;
  width: 90%;
  color: #413634;
  font-size: 15px;
  height: 40px;
  border-radius: 10px;
  outline: none;
  border: 1px solid #413634;
  font-weight: bold;
  position: relative;
  padding-right: 30px;
}
.service-add-action .container .text textarea {
  height: 150px;
}
.service-add-action .container .add-btn {
  width: 90%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 10px;
  margin-bottom: 10px;
  background-color: #2ecc71;
}

.service-edit-action {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 88888;
  top: 0;
  opacity: 0;
  opacity: 1;
  left: 0;
}
.service-edit-action .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
  left: 0;
  top: 0;
}
.service-edit-action .container {
  width: 90%;
  max-width: 600px;
  height: max-content !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  flex-direction: column;
  background-color: #f6f1ea;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
}
.service-edit-action .container .title {
  font-size: 24px;
  font-weight: bold;
}
.service-edit-action .container .text {
  width: 95%;
  height: max-content;
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  padding-bottom: 10px;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.service-edit-action .container .text input,
.service-edit-action .container .text textarea {
  resize: none;
  width: 90%;
  color: #413634;
  font-size: 15px;
  height: 40px;
  border-radius: 10px;
  outline: none;
  border: 1px solid #413634;
  font-weight: bold;
  position: relative;
  padding-right: 30px;
}
.service-edit-action .container .text textarea {
  height: 150px;
}
.service-edit-action .container .add-btn {
  width: 90%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 10px;
  margin-bottom: 10px;
  background-color: #2ecc71;
}

.service-info-admin {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 8888;
  top: 0;
  opacity: 1;
  left: 0;
}
.service-info-admin .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
}
.service-info-admin .add-icon {
  position: fixed;
  top: 7%;
  left: 31%;
  background-color: rgb(255, 255, 255);
  z-index: 8899;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: -11px;
}
.service-info-admin .add-icon:hover .img {
  transition: 0.5s;
  opacity: 1;
}
.service-info-admin .container {
  width: 500px;
  height: 700px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.service-info-admin .container .section {
  position: relative;
  overflow: hidden;
  border-radius: 20px;
}
.service-info-admin .container .section:hover .image img {
  filter: grayscale(0%);
  transition: 0.5s;
}
.service-info-admin .container .section:hover .data {
  left: 0;
  opacity: 1;
  transition: opacity 0.5s;
}
.service-info-admin .container .section .data.active {
  left: 0;
  opacity: 1;
  transition: opacity 0.5s;
}
.service-info-admin .container .section .image.active img {
  filter: grayscale(0%);
  transition: 0.5s;
}
.service-info-admin .container .section .image {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
}
.service-info-admin .container .section .image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(100%);
  transition: 0.5s;
}
.service-info-admin .container .section .data {
  position: absolute;
  top: 0;
  opacity: 0;
  transition: opacity 0.5s;
  height: calc(100% - 20px);
  width: calc(100% - 20px);
  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  padding: 10px;
  border-radius: 20px;
  color: #fff;
  left: -100%;
}
.service-info-admin .container .section .data .title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
}
.service-info-admin .container .section .data .title::before {
  content: "";
  width: 100%;
  height: 1px;
  background-color: #fff;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -10px;
}
.service-info-admin .container .section .data .desc {
  font-size: 14px;
  text-align: center;
}
.service-info-admin .container .del-icon {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #d0d0d0;
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: 10px 0 0 0;
}
.service-info-admin .container .edit-icon,
.service-info-admin .container .save-icon {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #d0d0d0;
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: 10px 0 0 0;
}

.service-images-add-action {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 8888;
  top: 0;
  opacity: 1;
  left: 0;
}
.service-images-add-action .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
}
.service-images-add-action .add-icon {
  position: absolute;
  top: 0%;
  left: 0;
  background-color: rgb(255, 255, 255);
  z-index: 8899;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: -11px;
}
.service-images-add-action .add-icon:hover .img {
  transition: 0.5s;
  opacity: 1;
}
.service-images-add-action .container {
  width: 90%;
  max-width: 600px;
  height: max-content !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  flex-direction: column;
  background-color: #f6f1ea;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
}
.service-images-add-action .container .title {
  font-size: 24px;
  font-weight: bold;
}
.service-images-add-action .container .image {
  width: 90%;
  height: 320px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.service-images-add-action .container .image.none {
  width: 100px;
  height: 100px;
  cursor: pointer;
}
.service-images-add-action .container .image.none img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.5s;
}
.service-images-add-action .container .image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: 0.5s;
}
.service-images-add-action .container .image .title {
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);
  color: #fff;
  font-weight: bold;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: end;
  padding-bottom: 10px;
}
.service-images-add-action .container .text {
  width: 95%;
  height: max-content;
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  padding-bottom: 10px;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.service-images-add-action .container .text textarea {
  width: 90%;
  color: #413634;
  font-size: 15px;
  height: 200px;
  border-radius: 10px;
  outline: none;
  border: 1px solid #413634;
  font-weight: bold;
  position: relative;
  padding-right: 30px;
  resize: none;
}
.service-images-add-action .container .add-btn {
  width: 90%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 10px;
  margin-bottom: 10px;
  background-color: #2ecc71;
}

.service-images-edit-action {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 8888;
  top: 0;
  opacity: 1;
  left: 0;
}
.service-images-edit-action .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
}
.service-images-edit-action .add-icon {
  position: absolute;
  top: 0%;
  left: 0;
  background-color: rgb(255, 255, 255);
  z-index: 8899;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: -11px;
}
.service-images-edit-action .add-icon:hover .img {
  transition: 0.5s;
  opacity: 1;
}
.service-images-edit-action .container {
  width: 90%;
  max-width: 600px;
  height: max-content !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  flex-direction: column;
  background-color: #f6f1ea;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
}
.service-images-edit-action .container .title {
  font-size: 24px;
  font-weight: bold;
}
.service-images-edit-action .container .image {
  width: 90%;
  height: 320px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.service-images-edit-action .container .image.none {
  width: 100px;
  height: 100px;
  cursor: pointer;
}
.service-images-edit-action .container .image.none img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.5s;
}
.service-images-edit-action .container .image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: 0.5s;
}
.service-images-edit-action .container .image .title {
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);
  color: #fff;
  font-weight: bold;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: end;
  padding-bottom: 10px;
}
.service-images-edit-action .container .text {
  width: 95%;
  height: max-content;
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  padding-bottom: 10px;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.service-images-edit-action .container .text textarea {
  width: 90%;
  color: #413634;
  font-size: 15px;
  height: 200px;
  border-radius: 10px;
  outline: none;
  border: 1px solid #413634;
  font-weight: bold;
  position: relative;
  padding-right: 30px;
  resize: none;
}
.service-images-edit-action .container .add-btn {
  width: 90%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 10px;
  margin-bottom: 10px;
  background-color: #2ecc71;
}

.image-info-admin {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 8888;
  top: 0;
  opacity: 0;
  opacity: 1;
  left: 0;
}
.image-info-admin .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
}
.image-info-admin .add-icon {
  position: absolute;
  top: 5%;
  left: 5%;
  background-color: rgb(255, 255, 255);
  z-index: 8899;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: -11px;
}
.image-info-admin .add-icon:hover .img {
  transition: 0.5s;
  opacity: 1;
}
.image-info-admin .container {
  width: 90%;
  height: 70%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.image-info-admin .container .section {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
}
.image-info-admin .container .section:hover .image img {
  filter: grayscale(0%);
  transition: 0.5s;
}
.image-info-admin .container .section:hover .data {
  left: 0;
  opacity: 1;
  transition: opacity 0.5s;
}
.image-info-admin .container .section .del-icon {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #d0d0d0;
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: 10px 0 0 0;
}
.image-info-admin .container .section .image {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
}
.image-info-admin .container .section .image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(100%);
  transition: 0.5s;
}
.image-info-admin .container .section .data {
  position: absolute;
  top: 0;
  opacity: 0;
  transition: opacity 0.5s;
  height: calc(100% - 20px);
  width: calc(100% - 20px);
  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: start;
  padding: 10px;
  border-radius: 20px;
  color: #fff;
  left: -100%;
}
.image-info-admin .container .section .data .title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
  margin-right: 30px;
}

.images-add-action {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 8888;
  top: 0;
  opacity: 1;
  left: 0;
}
.images-add-action .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
}
.images-add-action .add-icon {
  position: absolute;
  top: 0%;
  left: 0;
  background-color: rgb(255, 255, 255);
  z-index: 8899;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: -11px;
}
.images-add-action .add-icon:hover .img {
  transition: 0.5s;
  opacity: 1;
}
.images-add-action .container {
  width: 90%;
  max-width: 600px;
  height: max-content !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  flex-direction: column;
  background-color: #f6f1ea;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
}
.images-add-action .container .title {
  font-size: 24px;
  font-weight: bold;
}
.images-add-action .container .image {
  width: 90%;
  height: 320px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.images-add-action .container .image.none {
  width: 100px;
  height: 100px;
  cursor: pointer;
}
.images-add-action .container .image.none img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.5s;
}
.images-add-action .container .image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: 0.5s;
}
.images-add-action .container .image .title {
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);
  color: #fff;
  font-weight: bold;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: end;
  padding-bottom: 10px;
}
.images-add-action .container .text {
  width: 95%;
  height: max-content;
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  padding-bottom: 10px;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.images-add-action .container .text input {
  width: 90%;
  color: #413634;
  font-size: 15px;
  height: 50px;
  border-radius: 10px;
  outline: none;
  border: 1px solid #413634;
  font-weight: bold;
  position: relative;
  padding-right: 30px;
  resize: none;
}
.images-add-action .container .add-btn {
  width: 90%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 10px;
  margin-bottom: 10px;
  background-color: #2ecc71;
}

.video-info-admin {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 8888;
  top: 0;
  opacity: 0;
  opacity: 1;
  left: 0;
}
.video-info-admin .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
}
.video-info-admin .add-icon {
  position: absolute;
  top: 5%;
  left: 5%;
  background-color: rgb(255, 255, 255);
  z-index: 8899;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: -11px;
}
.video-info-admin .add-icon:hover .img {
  transition: 0.5s;
  opacity: 1;
}
.video-info-admin .container {
  width: 90%;
  height: 70%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.video-info-admin .container .section {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
}
.video-info-admin .container .section:hover .image img {
  filter: grayscale(0%);
  transition: 0.5s;
}
.video-info-admin .container .section:hover .data {
  left: 0;
  opacity: 1;
  transition: opacity 0.5s;
}
.video-info-admin .container .section .del-icon {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #d0d0d0;
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: 10px 0 0 0;
}
.video-info-admin .container .section .image {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
}
.video-info-admin .container .section .image img,
.video-info-admin .container .section .image video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(100%);
  transition: 0.5s;
}
.video-info-admin .container .section .data {
  position: absolute;
  top: 0;
  opacity: 0;
  transition: opacity 0.5s;
  height: calc(100% - 20px);
  width: calc(100% - 20px);
  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: start;
  padding: 10px;
  border-radius: 20px;
  color: #fff;
  left: -100%;
}
.video-info-admin .container .section .data .title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
  margin-right: 30px;
}

.video-add-action {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 8888;
  top: 0;
  opacity: 1;
  left: 0;
}
.video-add-action .content-layout {
  height: 100%;
  width: 100%;
  background-color: #413634;
  opacity: 0.67;
  z-index: 8889;
}
.video-add-action .add-icon {
  position: absolute;
  top: 0%;
  left: 0;
  background-color: rgb(255, 255, 255);
  z-index: 8899;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: -11px;
}
.video-add-action .add-icon:hover .img {
  transition: 0.5s;
  opacity: 1;
}
.video-add-action .container {
  width: 90%;
  max-width: 600px;
  height: max-content !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 8899;
  display: flex;
  flex-direction: column;
  background-color: #f6f1ea;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
}
.video-add-action .container .title {
  font-size: 24px;
  font-weight: bold;
}
.video-add-action .container .image {
  width: 90%;
  height: 320px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video-add-action .container .image.none {
  width: 100px;
  height: 100px;
  cursor: pointer;
}
.video-add-action .container .image.none img,
.video-add-action .container .image.none video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.5s;
}
.video-add-action .container .image img,
.video-add-action .container .image video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: 0.5s;
}
.video-add-action .container .image .title {
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);
  color: #fff;
  font-weight: bold;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: end;
  padding-bottom: 10px;
}
.video-add-action .container .text {
  width: 95%;
  height: max-content;
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  padding-bottom: 10px;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.video-add-action .container .text input {
  width: 90%;
  color: #413634;
  font-size: 15px;
  height: 50px;
  border-radius: 10px;
  outline: none;
  border: 1px solid #413634;
  font-weight: bold;
  position: relative;
  padding-right: 30px;
  resize: none;
}
.video-add-action .container .add-btn {
  width: 90%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 10px;
  margin-bottom: 10px;
  background-color: #2ecc71;
}

.home {
  background-color: #fdf8f2;
  height: 100%;
  width: 100%;
  min-height: 100dvh;
  height: 100%;
  padding-top: 50px;
  overflow-x: hidden;
  overflow-y: hidden;
}
.home .landing-home {
  width: 100%;
  height: 600px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  padding-top: 50px;
}
.home .landing-home.activeAnm .data .data-background img {
  transition: 1s;
  transform: scale(1.1);
}
.home .landing-home.activeAnm .data .back-box {
  top: -20px;
  transition: 1s;
}
.home .landing-home.activeAnm .data .content .logo {
  margin-bottom: 0;
  margin-right: 30px;
}
.home .landing-home.activeAnm .data .content .grouping {
  transition: 1s;
  top: -31px;
}
.home .landing-home.activeAnm .effects {
  width: 450px;
  transition: 1s;
}
.home .landing-home.activeAnm .about-clinic span {
  width: 250px;
  transition: 1s;
}
.home .landing-home.activeAnm .about-clinic .arrow {
  opacity: 1;
}
.home .landing-home.activeAnm .about-clinic .arrow #Path_7 {
  animation: dashrev 2s linear forwards;
}
.home .landing-home.activeAnm .about-clinic .arrow #Path_8 {
  opacity: 1;
  transition: 4s;
}
.home .landing-home .background {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.1;
  background: #fdf8f2;
}
.home .landing-home .background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.home .landing-home .data {
  position: relative;
  width: 80%;
  height: 80%;
  background: #413634;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 21px;
  position: relative;
}
.home .landing-home .data .data-background {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.3;
  background: #413634;
  border-radius: 10px;
  z-index: 1;
  overflow: hidden;
}
.home .landing-home .data .data-background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  transition: 1s;
}
.home .landing-home .data .back-box {
  position: absolute;
  top: -40px;
  width: 90%;
  height: 90%;
  left: 50%;
  transform: translateX(-50%);
  transition: 1s;
  background-color: #413634;
}
.home .landing-home .data .content {
  width: 100%;
  height: 64%;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;
}
.home .landing-home .data .content .logo {
  width: 300px;
  height: 300px;
  margin-right: 60px;
  margin-bottom: 20px;
  transition: 1s;
}
.home .landing-home .data .content .logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.home .landing-home .data .content .grouping {
  font-size: 35px;
  color: #fff;
  position: relative;
  top: 50px;
  transition: 1s;
}
.home .landing-home .data .content .grouping .title {
  font-weight: bold;
  font-size: 50px;
}
.home .landing-home .effects {
  position: absolute;
  left: 0;
  bottom: 112px;
  z-index: 2;
  width: 350px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: 1s;
}
.home .landing-home .effects .effect {
  height: 20px;
  width: 100%;
  background-color: #fcf2ec;
  position: relative;
  left: 0;
}
.home .landing-home .effects .effect.one {
  width: 70%;
  left: -30%;
}
.home .landing-home .effects .effect.two {
  width: 90%;
  left: -10%;
}
.home .landing-home .effects .effect.three {
  width: 100%;
}
.home .landing-home .about-clinic {
  width: 75%;
  height: 60px;
  z-index: 2;
  position: relative;
  margin-top: 10px;
  cursor: pointer;
}
.home .landing-home .about-clinic a {
  background-color: #413634;
  border-radius: 30px;
  color: #fff;
  font-weight: bold;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  transition: 1s;
  text-decoration: none;
  color: #fff;
}
.home .landing-home .about-clinic .arrow {
  position: absolute;
  top: 50%;
  right: 270px;
  opacity: 0;
  transition: 1s;
}
.home .landing-home .about-clinic .arrow #Path_7 {
  stroke-dasharray: 10;
  stroke-dashoffset: 0;
}
@keyframes dashrev {
  0% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: -80;
  }
}
.home .landing-home .about-clinic .arrow #Path_8 {
  opacity: 0;
}
@media (max-width: 768px) {
  .home .landing-home {
    height: 400px;
  }
  .home .landing-home .content {
    width: 100%;
    height: 92%;
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
    gap: 10px;
    align-items: center;
    flex-direction: column;
  }
  .home .landing-home .content .logo {
    width: 115px !important;
    height: 115px !important;
    margin-left: 30px;
    margin-bottom: 10px;
  }
  .home .landing-home .content .grouping {
    font-size: 20px !important;
    top: 0 !important;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .home .landing-home .content .grouping .title {
    font-weight: bold;
    font-size: 32px !important;
  }
  .home .landing-home .about-clinic .arrow {
    width: 111px;
    height: 124px;
    position: relative;
    right: 196px;
    opacity: 1;
    top: -55px;
    transform: rotate(320deg);
  }
  .home .landing-home .about-clinic svg {
    width: 100%;
    height: 100%;
  }
  .home .landing-home.activeAnm .effects {
    display: none !important;
  }
  .home .landing-home .effects {
    bottom: 80px !important;
    width: 100px !important;
  }
}
.home .about-clinic-home {
  width: calc(100% - 60px);
  padding: 0 30px;
  height: 800px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: start;
  flex-direction: column;
  overflow: hidden;
}
.home .about-clinic-home .container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 100%;
}
.home .about-clinic-home .container .right,
.home .about-clinic-home .container .left {
  width: 48%;
  height: calc(100% - 100px);
}
.home .about-clinic-home .head-title {
  font-size: 50px;
  font-weight: bold;
  width: max-content;
  position: relative;
  margin-top: 20px;
  margin-bottom: 20px;
}
.home .about-clinic-home .head-title span {
  position: relative;
  z-index: 2;
  color: #413634;
}
.home .about-clinic-home .head-title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 117%;
  z-index: 1;
  background-color: #ffdead;
  transform: translateX(-50%);
}
.home .about-clinic-home .right {
  display: flex;
  flex-direction: column;
}
.home .about-clinic-home .right .text {
  width: 100%;
  height: 100%;
  line-height: 2.5;
  font-size: 20px;
  font-weight: 600;
  color: #525252;
  position: relative;
}
.home .about-clinic-home .right .bottom {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}
.home .about-clinic-home .right .bottom .one {
  width: 80px;
  height: 4px;
  background-color: #413634;
  border-radius: 10px;
}
.home .about-clinic-home .right .bottom .two {
  width: 20px;
  height: 4px;
  background-color: #413634;
  border-radius: 10px;
}
.home .about-clinic-home .left {
  position: relative;
}
.home .about-clinic-home .left .images {
  position: relative;
  width: 100%;
  height: 100%;
}
.home .about-clinic-home .left .images .image {
  width: 45%;
  height: 55%;
  border-radius: 30px;
  position: absolute;
}
.home .about-clinic-home .left .images .image.one {
  top: 35%;
  left: 44%;
  z-index: 2;
  animation: dream 2s infinite alternate; /* Key part */
}
.home .about-clinic-home .left .images .image.two {
  bottom: 45%;
  right: 44%;
  z-index: 1;
  animation: dream2 2s infinite alternate; /* Key part */
}
.home .about-clinic-home .left .images .image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 30px;
}
.home .about-clinic-home .left .effects {
  position: absolute;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  bottom: 0;
}
.home .about-clinic-home .left .effects .effect {
  border-radius: 50%;
  background-color: #413634;
  position: absolute;
}
.home .about-clinic-home .left .effects .effect.one {
  width: 450px;
  height: 450px;
  left: -17%;
  bottom: -15%;
}
.home .about-clinic-home .left .effects .effect.two {
  width: 100px;
  height: 100px;
  top: 29%;
  right: 0%;
}
.home .about-clinic-home .left .effects .effect.thee {
  top: 22%;
  right: 15%;
  width: 40px;
  height: 40px;
}
@keyframes dream {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(20px);
  }
}
@keyframes dream2 {
  0% {
    transform: translateY(20px);
  }
  100% {
    transform: translateY(0);
  }
}
@media (max-width: 768px) {
  .home .about-clinic-home {
    flex-direction: column;
    height: max-content;
    width: calc(100% - 60px);
    padding-bottom: 0;
  }
  .home .about-clinic-home .head-title {
    margin: 0 auto;
    margin-top: 30px;
  }
  .home .about-clinic-home .container {
    flex-direction: column-reverse;
  }
  .home .about-clinic-home .container .right,
  .home .about-clinic-home .container .left {
    width: 100%;
    height: max-content;
  }
  .home .about-clinic-home .right {
    margin-bottom: 0;
  }
  .home .about-clinic-home .right .text {
    line-height: 2.3;
    font-size: 16px;
  }
  .home .about-clinic-home .left {
    height: 500px !important;
    margin-bottom: 100px;
  }
  .home .about-clinic-home .left .images .image {
    width: 200px;
  }
  .home .about-clinic-home .left .effects {
    width: 100%;
  }
  .home .about-clinic-home .left .effects .effect.one {
    width: 350px;
    height: 350px;
    left: 3px !important;
  }
  .home .about-clinic-home .left .images {
    margin-top: 37px;
  }
}
.home .about-dr-home {
  width: calc(100% - 60px);
  padding: 0 30px;
  height: 600px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.home .about-dr-home .background {
  width: 59%;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 1;
  background: #fdf8f2;
}
.home .about-dr-home .background img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.home .about-dr-home .right,
.home .about-dr-home .left {
  height: calc(100% - 100px);
  position: relative;
  z-index: 2;
}
.home .about-dr-home .right {
  position: relative;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home .about-dr-home .right .image {
  width: max-content;
  height: 100%;
  border-radius: 30px;
  animation: dream 2s infinite alternate; /* Key part */
  position: relative;
}
.home .about-dr-home .right .image:hover .data {
  opacity: 1;
  transition: opacity 0.5s;
  top: -12px;
  left: 7px;
  border-radius: 10px;
}
.home .about-dr-home .right .image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 30px;
}
.home .about-dr-home .right .image .data {
  position: absolute;
  z-index: 2;
  top: 1%;
  left: 200%;
  width: 97%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.5s;
}
.home .about-dr-home .right .image .data .layout {
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0) 70%, #413634 98%);
  border-radius: 30px;
}
.home .about-dr-home .right .image .data .text {
  position: absolute;
  bottom: 25px;
  font-weight: bold;
  width: max-content;
  color: #fff;
  font-size: 18px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
  gap: 5px;
}
.home .about-dr-home .right .image .data .text .info {
  text-transform: uppercase;
}
.home .about-dr-home .left {
  display: flex;
  flex-direction: column;
  width: 55%;
}
.home .about-dr-home .left .head-title {
  font-size: 50px;
  font-weight: bold;
  width: max-content;
  position: relative;
  margin-bottom: 30px;
}
.home .about-dr-home .left .head-title .title {
  font-size: 50px;
  font-weight: bold;
  width: max-content;
  position: relative;
}
.home .about-dr-home .left .head-title .title span {
  position: relative;
  z-index: 2;
  color: #413634;
}
.home .about-dr-home .left .head-title .title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 117%;
  z-index: 1;
  background-color: #ffdead;
  transform: translateX(-50%);
}
.home .about-dr-home .left .head-title .info {
  font-size: 21px;
}
.home .about-dr-home .left .skills {
  width: 80%;
  height: max-content;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 30px;
  font-size: 24px;
  margin: 20px 0 50px;
  font-weight: bold;
}
.home .about-dr-home .left .skills .skill {
  color: #413634;
  position: relative;
  margin-right: 30px;
}
.home .about-dr-home .left .skills .skill::before {
  content: "";
  height: 20px;
  width: 20px;
  background-color: #ffdead;
  top: 50%;
  position: absolute;
  right: -30px;
  transform: translateY(-50%);
  border-radius: 50%;
}
.home .about-dr-home .left .locations {
  width: 100%;
  justify-content: space-between;
  display: flex;
  width: 60%;
}
.home .about-dr-home .left .locations .location {
  width: max-content;
  padding: 9px 14px;
  font-size: 14px;
  height: 40px;
  font-weight: bold;
  color: #000;
  border: 1px solid #413634;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes dream {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(20px);
  }
}
@media (max-width: 768px) {
  .home .about-dr-home {
    flex-direction: column-reverse;
    height: max-content;
    width: calc(100% - 60px);
  }
  .home .about-dr-home .head-title {
    margin: 0 auto;
    margin-top: 30px;
  }
  .home .about-dr-home .right,
  .home .about-dr-home .left {
    width: 100%;
    height: max-content;
    margin-bottom: 20px;
  }
  .home .about-dr-home .left .effects {
    width: 100%;
  }
  .home .about-dr-home .left .effects .effect.one {
    width: 350px;
    height: 350px;
    left: 3px !important;
  }
  .home .about-dr-home .left .skills {
    width: 100%;
  }
  .home .about-dr-home .left .skills .skill {
    width: 100%;
    font-size: 20px;
  }
  .home .about-dr-home .left .locations {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .home .about-dr-home .left .locations .location {
    width: calc(48% - 20px) !important;
    padding: 8px 10px;
    font-size: 11px !important;
  }
  .home .about-dr-home .left .images {
    margin-top: 37px;
  }
}
.home .certificates-home {
  width: 100%;
  padding: 0 0;
  min-height: 600px;
  height: max-content;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 50px;
  padding-bottom: 50px;
}
.home .certificates-home .background {
  width: 100%;
  height: 88%;
  position: absolute;
  left: 0;
  bottom: 0;
  opacity: 0.04;
  background: #fdf8f2;
}
.home .certificates-home .background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.home .certificates-home .head-title {
  font-size: 50px;
  font-weight: bold;
  width: 100%;
  position: relative;
  margin-bottom: 30px;
}
.home .certificates-home .head-title .title {
  font-size: 50px;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.home .certificates-home .head-title .title span {
  position: relative;
  z-index: 2;
  color: #413634;
  text-align: center;
}
.home .certificates-home .head-title .title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 80%;
  z-index: 1;
  background-color: #ffdead;
  transform: translateX(-50%);
}
.home .certificates-home .head-title .info {
  font-size: 21px;
}
.home .certificates-home .certificates {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  position: relative;
  z-index: 2;
}
.home .certificates-home .certificates.pc {
  display: flex;
  padding-bottom: 40px;
  overflow-x: scroll;
  overflow-y: hidden;
  justify-content: space-between;
}
.home .certificates-home .certificates.pc .certificate {
  width: 300px !important;
}
.home .certificates-home .certificates .mySwiper {
  width: 100%;
  height: max-content;
  padding-bottom: 50px;
}
.home .certificates-home .certificates .mySwiper .swiper-pagination {
  bottom: 30px;
}
.home .certificates-home .certificates .mySwiper .swiper-slide-prev,
.home .certificates-home .certificates .mySwiper .swiper-slide-next {
  opacity: 0.7;
  transition: 0.5s;
}
.home .certificates-home .certificates .certificate {
  width: 300px !important;
  height: 400px;
  transition: 0.5s;
  border-radius: 15px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  position: relative;
  margin-top: 30px;
  margin-left: 12px;
  margin-right: 12px;
}
.home .certificates-home .certificates .certificate .image {
  width: 300px;
  height: 100%;
  border-radius: 15px;
}
.home .certificates-home .certificates .certificate .image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 15px;
  transition: 0.5s;
}
.home .certificates-home .certificates .certificate .data {
  position: absolute;
  z-index: -2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.5s;
  border-radius: 15px;
}
.home .certificates-home .certificates .certificate .data .layout {
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0) 70%, #413634 98%);
  border-radius: 15px;
}
.home .certificates-home .certificates .certificate .data .text {
  position: absolute;
  bottom: 25px;
  font-weight: bold;
  width: max-content;
  color: #fff;
  font-size: 18px;
  left: 50%;
  transform: translateX(-50%);
}
.home .certificates-home .certificates .certificate:hover .image img {
  transition: 0.5s;
  transform: scale(1);
}
.home .certificates-home .certificates .certificate:hover .data {
  opacity: 1;
  transition: opacity 0.5s;
  top: 0;
  z-index: 2;
}
.home .certificates-home .effects {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
}
.home .certificates-home .effects .effect {
  position: absolute;
  z-index: 1;
  background-color: #ffdead;
  border-radius: 50%;
}
.home .certificates-home .effects .effect.middle {
  width: 400px;
  height: 400px;
  top: 56%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.home .certificates-home .effects .effect.two {
  width: 100px;
  height: 100px;
  bottom: -16%;
  right: -32%;
  transform: translateX(-50%) translateY(-50%);
}
.home .directions-home {
  width: calc(100% - 60px);
  padding: 0 30px;
  min-height: 650px;
  height: max-content;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 50px;
  padding-top: 20px;
}
.home .directions-home .background {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  opacity: 0.2;
  background: #fdf8f2;
}
.home .directions-home .background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.home .directions-home .head-title {
  font-size: 50px;
  font-weight: bold;
  width: 100%;
  position: relative;
  margin-bottom: 30px;
  z-index: 2;
}
.home .directions-home .head-title .title {
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.home .directions-home .head-title .title span {
  position: relative;
  z-index: 2;
  color: #413634;
  text-align: center;
}
.home .directions-home .head-title .title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 100%;
  z-index: 1;
  background-color: #ffdead;
  transform: translateX(-50%);
}
.home .directions-home .head-title .info {
  font-size: 21px;
}
.home .directions-home .box {
  position: relative;
  z-index: 2;
  width: 95%;
  height: max-content;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 40px;
  box-shadow: rgba(99, 99, 99, 0.39) 0px 2px 13px 3px;
}
.home .directions-home .box .direction {
  display: flex;
  flex-direction: column;
  width: 230px;
  height: 230px;
  margin: 10px;
  justify-content: center;
  gap: 20px;
  align-items: center;
  font-weight: bold;
  font-size: 17px;
  position: relative;
  transition: 0.5s;
  background-color: #fff;
  text-align: center;
}
.home .directions-home .box .direction:not(:last-of-type):after {
  content: "";
  left: 0;
  position: absolute;
  top: 50%;
  width: 1px;
  height: 80%;
  background-color: #413634;
  transform: translateY(-50%);
  transition: 0.1s;
}
.home .directions-home .box .direction:hover {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 10px 4px, rgba(60, 64, 67, 0.15) 0px 1px 9px 4px;
  transform: scale(1.05);
  transition: 0.5s;
  z-index: 3;
}
.home .directions-home .box .direction:hover::after {
  width: 0;
  height: 0;
  transition: 0.1s;
}
.home .directions-home .box .direction .image {
  width: 130px;
  height: 130px;
}
.home .directions-home .box .direction .image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
@media (max-width: 768px) {
  .home .directions-home {
    flex-direction: column;
    height: max-content;
    width: calc(100% - 60px);
  }
  .home .directions-home .head-title {
    margin: 0 auto;
    margin-top: 30px;
    font-size: 20px;
  }
  .home .directions-home .right,
  .home .directions-home .left {
    width: 100%;
    height: max-content;
  }
  .home .directions-home .left {
    height: 500px !important;
  }
  .home .directions-home .left .effects {
    width: 100%;
  }
  .home .directions-home .left .effects .effect.one {
    width: 350px;
    height: 350px;
    left: 3px !important;
  }
  .home .directions-home .left .images {
    margin-top: 37px;
  }
  .home .directions-home .box {
    width: 100%;
    justify-content: space-between;
    align-items: start;
  }
  .home .directions-home .box:first-of-type .direction:before {
    content: "";
    left: -10px;
    position: absolute;
    top: 50%;
    width: 1px;
    height: 80%;
    background-color: #413634;
    transform: translateY(-50%);
    transition: 0.1s;
  }
  .home .directions-home .box .direction {
    width: 48% !important;
    margin: 0;
    text-align: 14px;
  }
  .home .directions-home .box .direction::after {
    display: none;
  }
}

.social {
  background-color: #fdf8f2;
  height: 100%;
  width: 100%;
  min-height: 100dvh;
  padding-top: 50px;
  position: relative;
  overflow-x: hidden;
}
.social .background {
  width: 100%;
  height: 321px;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0.2;
  background: #fdf8f2;
  background-repeat: no-repeat;
  z-index: 0;
}
.social .background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.social .section {
  display: flex;
  width: 100%;
  height: 700px;
  position: relative;
  z-index: 2;
  flex-direction: column;
  color: #000;
  text-decoration: none;
}
.social .section.spic {
  background-color: #fcf2ec;
}
.social .section .head-title {
  font-size: 40px;
  font-weight: bold;
  width: max-content;
  position: relative;
  margin: 0 auto;
  margin-bottom: 40px;
  margin-top: 20px;
}
.social .section .head-title span {
  position: relative;
  z-index: 2;
  color: #413634;
}
.social .section .head-title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 104%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: #ffdead;
}
.social .section .section-container {
  width: 100%;
  display: flex;
  height: 100%;
  justify-content: space-between;
  color: #000;
  text-decoration: none;
}
.social .section .section-container .right {
  width: calc(40% - 40px);
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.social .section .section-container .right .anthor-title {
  font-weight: bold;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.social .section .section-container .right .anthor-title .title {
  font-size: 40px;
  position: relative;
  width: max-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 0 !important;
}
.social .section .section-container .right .anthor-title .title span {
  position: relative;
  z-index: 2;
  width: max-content;
  color: #413634;
}
.social .section .section-container .right .anthor-title .title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 104%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: #ffdead;
}
.social .section .section-container .right .anthor-title .info {
  color: #413634;
  font-weight: bold;
  margin: 5px 0;
  width: 83%;
  text-align: center;
}
.social .section .section-container .right .location {
  height: calc(100% - 100px);
  width: calc(100% - 40px);
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 20px;
}
.social .section .section-container .right .location .location {
  width: 80%;
  height: 80%;
}
.social .section .section-container .right .location .location img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.social .section .section-container .left {
  width: calc(55% - 40px);
  padding-left: 40px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  position: relative;
}
.social .section .section-container .left iframe {
  width: 100%;
  height: 80%;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;
}
.social .section .section-container .left .info {
  width: 30%;
  position: absolute;
  height: 50px;
  border-radius: 30px;
  bottom: 15%;
  left: 50%;
  transform: translateX(-45%);
  border: 1px solid #413634;
  background-color: #fcf2ec;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #000;
  text-decoration: none;
}
.social .section .section-container .left .info a {
  color: #000;
  text-decoration: none;
}
.social .section .section-container .left .info .icon {
  position: absolute;
  right: 10px;
  width: 30px;
  height: 30px;
  top: 50%;
  transform: translateY(-50%);
  color: #000;
  text-decoration: none;
}
.social .section .simple-title {
  font-size: 40px;
  font-weight: bold;
  width: max-content;
  position: relative;
  margin: 0 auto;
  margin-bottom: 40px;
  margin-top: 80px;
}
.social .section .simple-title span {
  position: relative;
  z-index: 2;
  color: #413634;
}
.social .section .simple-title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 104%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: #ffdead;
}
.social .section .container {
  display: flex;
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  color: #000;
  text-decoration: none;
}
.social .section .container .contact {
  width: 280px;
  height: 280px;
  display: flex;
  flex-direction: column;
  background-color: #fcf2ec;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-radius: 20px;
  border: 1px solid transparent;
  transition: 0.5s;
  transform: scale(1);
  color: #000;
  text-decoration: none;
}
.social .section .container .contact:hover {
  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;
  border: 1px solid #413634;
  transform: scale(1.1);
  transition: 0.5s;
}
.social .section .container .contact .icon {
  width: 100px;
  height: 100px;
  margin-top: 20px;
}
.social .section .container .contact .title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 40px;
  width: 90%;
  position: relative;
  margin: 0 auto;
  text-align: center;
  color: #000;
  text-decoration: none;
}
.social .section .container .contact .title::before {
  content: "";
  bottom: -20px;
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  border-radius: 10px;
  background-color: #413634;
}
.social .section .container .contact .value {
  font-weight: normal;
  font-size: 18px;
  margin: 0 auto;
  text-align: center;
  color: #000;
  text-decoration: none;
}

@media (max-width: 768px) {
  .social {
    height: max-content;
  }
  .social .background {
    width: 100%;
    height: 121px;
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0.2;
    background: #fdf8f2;
    background-repeat: no-repeat;
    z-index: 0;
  }
  .social .background img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .social .head-title {
    display: none;
    margin-bottom: 30px;
  }
  .social .head-title .title {
    margin-top: 10px;
    margin-bottom: 30px;
  }
  .social .right,
  .social .left {
    width: 100% !important;
    height: max-content !important;
  }
  .social .tower .group {
    margin-left: 30px;
  }
  .social .left {
    margin: 30px 0;
  }
  .social .left iframe {
    width: 100%;
    margin: 0 auto;
    height: 300px !important;
    width: 90% !important;
  }
  .social .left .info {
    width: 52% !important;
    position: absolute;
    height: 50px;
    border-radius: 30px;
    bottom: -7% !important;
    left: 50%;
    transform: translateX(-50%);
    border: 1px solid #413634;
    background-color: #fcf2ec;
    font-size: 20px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .social .section {
    height: max-content !important;
  }
  .social .section .section-container {
    width: 100%;
    display: flex;
    height: max-content !important;
    justify-content: space-between;
    flex-direction: column;
  }
  .social .section .section-container .anthor-title .title {
    margin-right: 40px;
    margin-top: 20px;
  }
  .social .section .section-container .anthor-title .info {
    width: max-content;
    font-size: 12px;
  }
  .social .section .section-container .location {
    width: 100%;
  }
  .social .section .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    flex-wrap: wrap;
    gap: 10px;
  }
  .social .section .container .contact {
    width: calc(48% - 20px);
    height: 185px;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  .social .section .container .contact .title {
    font-size: 18px !important;
  }
  .social .section .container .contact .title::before {
    display: none;
  }
  .social .section .container .contact .value {
    font-size: 16px !important;
  }
}
.services {
  background-color: #fdf8f2;
  height: 100%;
  width: 100%;
  min-height: 100dvh;
  padding-top: 50px;
  position: relative;
  padding-bottom: 50px;
}
.services .background {
  width: 100%;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0.1;
  background: #fdf8f2;
  background-repeat: no-repeat;
  z-index: 0;
}
.services .background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.services .head-title {
  font-size: 40px;
  font-weight: bold;
  width: max-content;
  position: relative;
  margin: 0 auto;
  margin-bottom: 40px;
  margin-top: 20px;
  z-index: 2;
}
.services .head-title span {
  position: relative;
  z-index: 2;
  color: #413634;
}
.services .head-title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 104%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: #ffdead;
}
.services .services-container {
  width: 90%;
  margin: 0 auto;
  height: calc(100% - 240px);
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px;
}
.services .services-container .service {
  display: flex;
  background-color: #fdf8f2;
  width: 350px;
  height: 520px;
  border-radius: 10px;
  flex-direction: column;
  align-items: center;
  transition: 0.5s;
  border: 1px solid transparent;
}
.services .services-container .service:hover {
  transition: 0.5s;
  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;
  border: 1px solid #413634;
}
.services .services-container .service .content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  flex-direction: column;
  margin-bottom: 40px;
  position: relative;
}
.services .services-container .service .content::before {
  content: "";
  bottom: -20px;
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  border-radius: 10px;
  background-color: #413634;
}
.services .services-container .service .content .icon {
  width: 140px;
  height: 140px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.services .services-container .service .content .title {
  font-size: 24px;
  margin-top: 10px;
  font-weight: bold;
  color: #413634;
}
.services .services-container .service .grouping {
  display: flex;
  width: 90%;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
}
.services .services-container .service .grouping .info {
  font-size: 16px;
  line-height: 2;
  text-align: center;
  color: #525252;
}
.services .services-container .service .grouping .images {
  width: 50px;
  height: 50px;
  cursor: pointer;
}
.services .services-container .service.spic {
  background-color: transparent;
}
.services .services-container .service.spic:hover {
  transition: 0.5s;
  box-shadow: none;
  border: 1px solid transparent;
}
.services .services-container .service.spic .content {
  height: 150px;
  background-color: #413634;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 10px;
}
.services .services-container .service.spic .content::before {
  display: none;
}
.services .services-container .service.spic .content .title {
  color: #fff;
  margin-bottom: 10px;
}
.services .services-container .service .service-container {
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 20px;
  height: calc(100% - 150px);
  width: 100%;
}
.services .services-container .service .service-container .service-d {
  width: 100%;
  background-color: #fdf8f2;
  border: 1px solid #413634;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  padding: 15px 0;
  color: #000;
  font-weight: bold;
  cursor: pointer;
  overflow: hidden;
  transition: 0.5s;
}
.services .services-container .service .service-container .service-d span {
  width: 100%;
  text-align: center;
}
.services .services-container .service .service-container .service-d .icon {
  width: 30px;
  height: 30px;
  position: relative;
  left: -100%;
  transition: 0.5s;
}
.services .services-container .service .service-container .service-d:hover {
  transition: 0.5s;
  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;
  border: 1px solid #413634;
  width: 100%;
}
.services .services-container .service .service-container .service-d:hover .icon {
  left: 20px;
  transition: 0.5s;
}

@media (max-width: 768px) {
  .services {
    height: max-content;
  }
  .services .background {
    width: 100%;
    height: 121px;
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0.2;
    background: #fdf8f2;
    background-repeat: no-repeat;
    z-index: 0;
  }
  .services .background img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .services .head-title {
    margin-bottom: 30px;
  }
  .services .head-title .title {
    margin-top: 10px;
    margin-bottom: 30px;
  }
  .services .services-container {
    height: max-content;
    width: 100%;
    flex-direction: column;
    padding-bottom: 50px;
    gap: 40px;
  }
  .services .service {
    width: 350px !important;
    height: 450px !important;
  }
  .services .service.spic .content {
    height: max-content;
  }
  .services .service.spic .content .icon {
    width: 70px;
    height: 70px;
  }
  .services .service .info {
    font-size: 13px !important;
  }
}
.cases {
  background-color: #fdf8f2;
  height: 100%;
  width: 100%;
  min-height: 600px;
  padding-top: 50px;
  position: relative;
}
.cases .head-title {
  font-size: 40px;
  font-weight: bold;
  width: max-content;
  position: relative;
  margin: 0 auto;
  margin-bottom: 40px;
  margin-top: 20px;
  z-index: 2;
}
.cases .head-title span {
  position: relative;
  z-index: 2;
  color: #413634;
}
.cases .head-title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 104%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: #ffdead;
}
.cases .boxes {
  width: 90%;
  margin: 0 auto;
  height: 100%;
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 100px;
}
.cases .boxes .box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fdf8f2;
  border: 1px solid transparent;
  border-radius: 10px;
  width: 300px;
  height: 300px;
  gap: 30px;
  cursor: pointer;
  transition: 0.5s;
  transform: scale(1);
}
.cases .boxes .box:hover {
  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;
  border: 1px solid #413634;
  transform: scale(1.1);
  transition: 0.5s;
}
.cases .boxes .box .icon {
  width: 150px;
  height: 150px;
}
.cases .boxes .box .title {
  font-size: 18px;
  font-weight: bold;
}

@media (max-width: 768px) {
  .cases {
    height: max-content;
  }
  .cases .background {
    width: 100%;
    height: 121px;
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0.2;
    background: #fdf8f2;
    background-repeat: no-repeat;
    z-index: 0;
  }
  .cases .background img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .cases .head-title {
    margin-bottom: 30px;
  }
  .cases .head-title .title {
    margin-top: 10px;
    margin-bottom: 30px;
  }
  .cases .boxes {
    height: max-content;
    width: 100%;
    flex-direction: column;
    padding-bottom: 50px;
    gap: 40px;
    align-items: center;
  }
  .cases .boxes .box {
    width: 250px;
    height: 250px;
  }
}
.home-admin {
  background-color: #fdf8f2;
  height: 100%;
  width: 100%;
  min-height: 100dvh;
  height: 100%;
  padding-top: 50px;
  overflow-x: hidden;
  overflow-y: hidden;
}
.home-admin .landing-home {
  width: 100%;
  height: 600px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  padding-top: 50px;
}
.home-admin .landing-home.activeAnm .data .data-background img {
  transition: 1s;
  transform: scale(1.1);
}
.home-admin .landing-home.activeAnm .data .back-box {
  top: -20px;
  transition: 1s;
}
.home-admin .landing-home.activeAnm .data .content .logo {
  margin-bottom: 0;
  margin-right: 30px;
}
.home-admin .landing-home.activeAnm .data .content .grouping {
  transition: 1s;
  top: -31px;
}
.home-admin .landing-home.activeAnm .effects {
  width: 450px;
  transition: 1s;
}
.home-admin .landing-home.activeAnm .about-clinic span {
  width: 250px;
  transition: 1s;
}
.home-admin .landing-home.activeAnm .about-clinic .arrow {
  opacity: 1;
}
.home-admin .landing-home.activeAnm .about-clinic .arrow #Path_7 {
  animation: dashrev 2s linear forwards;
}
.home-admin .landing-home.activeAnm .about-clinic .arrow #Path_8 {
  opacity: 1;
  transition: 4s;
}
.home-admin .landing-home .background {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.1;
  background: #fdf8f2;
}
.home-admin .landing-home .background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.home-admin .landing-home .data {
  position: relative;
  width: 80%;
  height: 80%;
  background: #413634;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 21px;
  position: relative;
}
.home-admin .landing-home .data .data-background {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 10px;
  z-index: 2;
  overflow: hidden;
}
.home-admin .landing-home .data .data-background .image {
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.3;
  background: #413634;
}
.home-admin .landing-home .data .data-background .image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  transition: 1s;
}
.home-admin .landing-home .data .data-background .add-icon {
  position: absolute;
  top: 0;
  left: 0;
  background-color: white;
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
}
.home-admin .landing-home .data .data-background .add-icon:hover .img {
  transition: 0.5s;
  opacity: 1;
}
.home-admin .landing-home .data .back-box {
  position: absolute;
  top: -40px;
  width: 90%;
  height: 90%;
  left: 50%;
  transform: translateX(-50%);
  transition: 1s;
  background-color: #413634;
}
.home-admin .landing-home .data .content {
  width: 100%;
  height: 64%;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;
}
.home-admin .landing-home .data .content .logo {
  width: 300px;
  height: 300px;
  margin-right: 60px;
  margin-bottom: 20px;
  transition: 1s;
}
.home-admin .landing-home .data .content .logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.home-admin .landing-home .data .content .grouping {
  font-size: 35px;
  color: #fff;
  position: relative;
  top: 50px;
  transition: 1s;
}
.home-admin .landing-home .data .content .grouping .title {
  font-weight: bold;
  font-size: 50px;
}
.home-admin .landing-home .effects {
  position: absolute;
  left: 0;
  bottom: 112px;
  z-index: 2;
  width: 350px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: 1s;
}
.home-admin .landing-home .effects .effect {
  height: 20px;
  width: 100%;
  background-color: #fcf2ec;
  position: relative;
  left: 0;
}
.home-admin .landing-home .effects .effect.one {
  width: 70%;
  left: -30%;
}
.home-admin .landing-home .effects .effect.two {
  width: 90%;
  left: -10%;
}
.home-admin .landing-home .effects .effect.three {
  width: 100%;
}
.home-admin .landing-home .about-clinic {
  width: 75%;
  height: 60px;
  z-index: 2;
  position: relative;
  margin-top: 10px;
  cursor: pointer;
}
.home-admin .landing-home .about-clinic a {
  background-color: #413634;
  border-radius: 30px;
  color: #fff;
  font-weight: bold;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  transition: 1s;
  text-decoration: none;
  color: #fff;
}
.home-admin .landing-home .about-clinic .arrow {
  position: absolute;
  top: 50%;
  right: 270px;
  opacity: 0;
  transition: 1s;
}
.home-admin .landing-home .about-clinic .arrow #Path_7 {
  stroke-dasharray: 10;
  stroke-dashoffset: 0;
}
@keyframes dashrev {
  0% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: -80;
  }
}
.home-admin .landing-home .about-clinic .arrow #Path_8 {
  opacity: 0;
}
@media (max-width: 768px) {
  .home-admin .landing-home {
    height: 400px;
  }
  .home-admin .landing-home .content {
    width: 100%;
    height: 92%;
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
    gap: 10px;
    align-items: center;
    flex-direction: column;
  }
  .home-admin .landing-home .content .logo {
    width: 115px !important;
    height: 115px !important;
    margin-left: 30px;
    margin-bottom: 10px;
  }
  .home-admin .landing-home .content .grouping {
    font-size: 20px !important;
    top: 0 !important;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .home-admin .landing-home .content .grouping .title {
    font-weight: bold;
    font-size: 32px !important;
  }
  .home-admin .landing-home .about-clinic .arrow {
    width: 111px;
    height: 124px;
    position: relative;
    right: 196px;
    opacity: 1;
    top: -55px;
    transform: rotate(320deg);
  }
  .home-admin .landing-home .about-clinic svg {
    width: 100%;
    height: 100%;
  }
  .home-admin .landing-home.activeAnm .effects {
    display: none;
  }
  .home-admin .landing-home .effects {
    bottom: 80px !important;
    width: 100px !important;
  }
}
.home-admin .about-clinic-home {
  width: calc(100% - 60px);
  padding: 0 30px;
  height: 800px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: start;
  flex-direction: column;
  overflow: hidden;
}
.home-admin .about-clinic-home .container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 100%;
}
.home-admin .about-clinic-home .container .right,
.home-admin .about-clinic-home .container .left {
  width: 48%;
  height: calc(100% - 100px);
}
.home-admin .about-clinic-home .head-title {
  font-size: 50px;
  font-weight: bold;
  width: max-content;
  position: relative;
  margin-top: 20px;
  margin-bottom: 20px;
}
.home-admin .about-clinic-home .head-title span {
  position: relative;
  z-index: 2;
  color: #413634;
}
.home-admin .about-clinic-home .head-title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 117%;
  z-index: 1;
  background-color: #ffdead;
  transform: translateX(-50%);
}
.home-admin .about-clinic-home .right {
  display: flex;
  flex-direction: column;
}
.home-admin .about-clinic-home .right .text {
  width: 100%;
  height: 100%;
  line-height: 2.5;
  font-size: 20px;
  font-weight: 600;
  color: #7a7a7a;
  position: relative;
}
.home-admin .about-clinic-home .right .text textarea {
  width: 100%;
  height: 100%;
  resize: none;
}
.home-admin .about-clinic-home .right .text .edit-icon,
.home-admin .about-clinic-home .right .text .save-icon {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #d0d0d0;
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
}
.home-admin .about-clinic-home .right .bottom {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}
.home-admin .about-clinic-home .right .bottom .one {
  width: 80px;
  height: 4px;
  background-color: #413634;
  border-radius: 10px;
}
.home-admin .about-clinic-home .right .bottom .two {
  width: 20px;
  height: 4px;
  background-color: #413634;
  border-radius: 10px;
}
.home-admin .about-clinic-home .left {
  position: relative;
}
.home-admin .about-clinic-home .left .images {
  position: relative;
  width: 100%;
  height: 100%;
}
.home-admin .about-clinic-home .left .images .image-container {
  width: 45%;
  height: 55%;
  border-radius: 30px;
  position: absolute;
}
.home-admin .about-clinic-home .left .images .image-container .image {
  height: 100%;
  width: 100%;
}
.home-admin .about-clinic-home .left .images .image-container.one {
  top: 35%;
  left: 44%;
  z-index: 2;
  animation: dream 2s infinite alternate; /* Key part */
}
.home-admin .about-clinic-home .left .images .image-container.two {
  bottom: 45%;
  right: 44%;
  z-index: 1;
  animation: dream2 2s infinite alternate; /* Key part */
}
.home-admin .about-clinic-home .left .images .image-container .add-icon {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #ededed;
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
}
.home-admin .about-clinic-home .left .images .image-container .add-icon:hover .img {
  transition: 0.5s;
  opacity: 1;
}
.home-admin .about-clinic-home .left .images .image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 30px;
}
.home-admin .about-clinic-home .left .effects {
  position: absolute;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  bottom: 0;
}
.home-admin .about-clinic-home .left .effects .effect {
  border-radius: 50%;
  background-color: #413634;
  position: absolute;
}
.home-admin .about-clinic-home .left .effects .effect.one {
  width: 450px;
  height: 450px;
  left: -17%;
  bottom: -15%;
}
.home-admin .about-clinic-home .left .effects .effect.two {
  width: 100px;
  height: 100px;
  top: 29%;
  right: 0%;
}
.home-admin .about-clinic-home .left .effects .effect.thee {
  top: 22%;
  right: 15%;
  width: 40px;
  height: 40px;
}
@keyframes dream {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(20px);
  }
}
@keyframes dream2 {
  0% {
    transform: translateY(20px);
  }
  100% {
    transform: translateY(0);
  }
}
@media (max-width: 768px) {
  .home-admin .about-clinic-home {
    flex-direction: column;
    height: max-content;
    width: calc(100% - 60px);
    padding-bottom: 0;
  }
  .home-admin .about-clinic-home .head-title {
    margin: 0 auto;
    margin-top: 30px;
  }
  .home-admin .about-clinic-home .container {
    flex-direction: column-reverse;
  }
  .home-admin .about-clinic-home .container .right,
  .home-admin .about-clinic-home .container .left {
    width: 100%;
    height: max-content;
  }
  .home-admin .about-clinic-home .right {
    margin-bottom: 0;
  }
  .home-admin .about-clinic-home .right .text {
    line-height: 2.3;
    font-size: 16px;
  }
  .home-admin .about-clinic-home .left {
    height: 500px !important;
    margin-bottom: 100px;
  }
  .home-admin .about-clinic-home .left .images .image {
    width: 200px;
  }
  .home-admin .about-clinic-home .left .effects {
    width: 100%;
  }
  .home-admin .about-clinic-home .left .effects .effect.one {
    width: 350px;
    height: 350px;
    left: 3px !important;
  }
  .home-admin .about-clinic-home .left .images {
    margin-top: 37px;
  }
}
.home-admin .about-dr-home {
  width: calc(100% - 60px);
  padding: 0 30px;
  height: 600px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.home-admin .about-dr-home .background {
  width: 59%;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 1;
  background: #fdf8f2;
}
.home-admin .about-dr-home .background img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.home-admin .about-dr-home .right,
.home-admin .about-dr-home .left {
  height: calc(100% - 100px);
  position: relative;
  z-index: 2;
}
.home-admin .about-dr-home .right {
  position: relative;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-admin .about-dr-home .right .image {
  width: max-content;
  height: 100%;
  border-radius: 30px;
  animation: dream 2s infinite alternate; /* Key part */
  position: relative;
}
.home-admin .about-dr-home .right .image:hover .data {
  opacity: 1;
  transition: opacity 0.5s;
  top: -12px;
  left: 7px;
  border-radius: 10px;
}
.home-admin .about-dr-home .right .image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 30px;
}
.home-admin .about-dr-home .right .image .add-icon {
  position: absolute;
  top: 0;
  left: 0;
  background-color: white;
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  z-index: 55555;
}
.home-admin .about-dr-home .right .image .add-icon:hover .img {
  transition: 0.5s;
  opacity: 1;
}
.home-admin .about-dr-home .right .image .data {
  position: absolute;
  z-index: 2;
  top: 1%;
  left: 200%;
  width: 97%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.5s;
}
.home-admin .about-dr-home .right .image .data .layout {
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0) 70%, #413634 98%);
  border-radius: 30px;
}
.home-admin .about-dr-home .right .image .data .text {
  position: absolute;
  bottom: 25px;
  font-weight: bold;
  width: max-content;
  color: #fff;
  font-size: 18px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
  gap: 5px;
}
.home-admin .about-dr-home .right .image .data .text .info {
  text-transform: uppercase;
}
.home-admin .about-dr-home .left {
  display: flex;
  flex-direction: column;
  width: 55%;
}
.home-admin .about-dr-home .left .head-title {
  font-size: 50px;
  font-weight: bold;
  width: max-content;
  position: relative;
  margin-bottom: 30px;
}
.home-admin .about-dr-home .left .head-title .title {
  font-size: 50px;
  font-weight: bold;
  width: max-content;
  position: relative;
}
.home-admin .about-dr-home .left .head-title .title span {
  position: relative;
  z-index: 2;
  color: #413634;
}
.home-admin .about-dr-home .left .head-title .title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 117%;
  z-index: 1;
  background-color: #ffdead;
  transform: translateX(-50%);
}
.home-admin .about-dr-home .left .head-title .info {
  font-size: 21px;
}
.home-admin .about-dr-home .left .skills {
  width: 80%;
  height: max-content;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 30px;
  font-size: 24px;
  margin: 20px 0 50px;
  font-weight: bold;
}
.home-admin .about-dr-home .left .skills .skill {
  color: #413634;
  position: relative;
  margin-right: 30px;
}
.home-admin .about-dr-home .left .skills .skill::before {
  content: "";
  height: 20px;
  width: 20px;
  background-color: #ffdead;
  top: 50%;
  position: absolute;
  right: -30px;
  transform: translateY(-50%);
  border-radius: 50%;
}
.home-admin .about-dr-home .left .locations {
  width: 100%;
  justify-content: space-between;
  display: flex;
  width: 60%;
}
.home-admin .about-dr-home .left .locations .location {
  width: max-content;
  padding: 9px 14px;
  font-size: 14px;
  height: 40px;
  font-weight: bold;
  color: #000;
  border: 1px solid #413634;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes dream {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(20px);
  }
}
@media (max-width: 768px) {
  .home-admin .about-dr-home {
    flex-direction: column-reverse;
    height: max-content;
    width: calc(100% - 60px);
  }
  .home-admin .about-dr-home .head-title {
    margin: 0 auto;
    margin-top: 30px;
  }
  .home-admin .about-dr-home .right,
  .home-admin .about-dr-home .left {
    width: 100%;
    height: max-content;
    margin-bottom: 20px;
  }
  .home-admin .about-dr-home .left .effects {
    width: 100%;
  }
  .home-admin .about-dr-home .left .effects .effect.one {
    width: 350px;
    height: 350px;
    left: 3px !important;
  }
  .home-admin .about-dr-home .left .skills {
    width: 100%;
  }
  .home-admin .about-dr-home .left .skills .skill {
    width: 100%;
    font-size: 20px;
  }
  .home-admin .about-dr-home .left .locations {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .home-admin .about-dr-home .left .locations .location {
    width: calc(48% - 20px) !important;
    padding: 8px 10px;
    font-size: 11px !important;
  }
  .home-admin .about-dr-home .left .images {
    margin-top: 37px;
  }
}
.home-admin .certificates-home {
  width: 100%;
  padding: 0 0;
  min-height: 600px;
  height: max-content;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 50px;
  padding-bottom: 50px;
}
.home-admin .certificates-home .background {
  width: 100%;
  height: 88%;
  position: absolute;
  left: 0;
  bottom: 0;
  opacity: 0.04;
  background: #fdf8f2;
}
.home-admin .certificates-home .background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.home-admin .certificates-home .head-title {
  font-size: 50px;
  font-weight: bold;
  width: 100%;
  position: relative;
  margin-bottom: 30px;
}
.home-admin .certificates-home .head-title .title {
  font-size: 50px;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.home-admin .certificates-home .head-title .title .add-icon {
  position: absolute;
  top: 22%;
  left: 10%;
  background-color: white;
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: -11px;
  z-index: 55555;
}
.home-admin .certificates-home .head-title .title .add-icon:hover .img {
  transition: 0.5s;
  opacity: 1;
}
.home-admin .certificates-home .head-title .title span {
  position: relative;
  z-index: 2;
  color: #413634;
  text-align: center;
}
.home-admin .certificates-home .head-title .title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 80%;
  z-index: 1;
  background-color: #ffdead;
  transform: translateX(-50%);
}
.home-admin .certificates-home .head-title .info {
  font-size: 21px;
}
.home-admin .certificates-home .certificates {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  position: relative;
  z-index: 2;
}
.home-admin .certificates-home .certificates.pc {
  display: flex;
  padding-bottom: 40px;
  overflow-x: scroll;
  overflow-y: hidden;
  justify-content: space-between;
}
.home-admin .certificates-home .certificates.pc .certificate {
  width: 300px !important;
}
.home-admin .certificates-home .certificates .mySwiper {
  width: 100%;
  height: max-content;
  padding-bottom: 50px;
}
.home-admin .certificates-home .certificates .mySwiper .swiper-pagination {
  bottom: 30px;
}
.home-admin .certificates-home .certificates .mySwiper .swiper-slide-prev,
.home-admin .certificates-home .certificates .mySwiper .swiper-slide-next {
  opacity: 0.7;
  transition: 0.5s;
}
.home-admin .certificates-home .certificates .certificate {
  width: 300px !important;
  height: 400px;
  transition: 0.5s;
  border-radius: 15px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  position: relative;
  margin-top: 30px;
  margin-left: 12px;
  margin-right: 12px;
}
.home-admin .certificates-home .certificates .certificate .del-icon {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #d0d0d0;
  z-index: 555;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: 10px 0 0 0;
}
.home-admin .certificates-home .certificates .certificate .image {
  width: 300px;
  height: 100%;
  border-radius: 15px;
}
.home-admin .certificates-home .certificates .certificate .image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 15px;
  transition: 0.5s;
}
.home-admin .certificates-home .certificates .certificate .data {
  position: absolute;
  z-index: -2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.5s;
  border-radius: 15px;
}
.home-admin .certificates-home .certificates .certificate .data .layout {
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0) 70%, #413634 98%);
  border-radius: 15px;
}
.home-admin .certificates-home .certificates .certificate .data .text {
  position: absolute;
  bottom: 25px;
  font-weight: bold;
  width: max-content;
  color: #fff;
  font-size: 18px;
  left: 50%;
  transform: translateX(-50%);
}
.home-admin .certificates-home .certificates .certificate:hover .image img {
  transition: 0.5s;
  transform: scale(1);
}
.home-admin .certificates-home .certificates .certificate:hover .data {
  opacity: 1;
  transition: opacity 0.5s;
  top: 0;
  z-index: 2;
}
.home-admin .certificates-home .effects {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
}
.home-admin .certificates-home .effects .effect {
  position: absolute;
  z-index: 1;
  background-color: #ffdead;
  border-radius: 50%;
}
.home-admin .certificates-home .effects .effect.middle {
  width: 400px;
  height: 400px;
  top: 56%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.home-admin .certificates-home .effects .effect.two {
  width: 100px;
  height: 100px;
  bottom: -16%;
  right: -32%;
  transform: translateX(-50%) translateY(-50%);
}
.home-admin .directions-home {
  width: calc(100% - 60px);
  padding: 0 30px;
  min-height: 650px;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 50px;
  padding-top: 20px;
}
.home-admin .directions-home .background {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  opacity: 0.2;
  background: #fdf8f2;
}
.home-admin .directions-home .background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.home-admin .directions-home .head-title {
  font-size: 50px;
  font-weight: bold;
  width: 100%;
  position: relative;
  margin-bottom: 30px;
  z-index: 2;
}
.home-admin .directions-home .head-title .title {
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.home-admin .directions-home .head-title .title span {
  position: relative;
  z-index: 2;
  color: #413634;
  text-align: center;
}
.home-admin .directions-home .head-title .title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 100%;
  z-index: 1;
  background-color: #ffdead;
  transform: translateX(-50%);
}
.home-admin .directions-home .head-title .add-icon {
  position: absolute;
  top: 22%;
  left: 10%;
  background-color: white;
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: -11px;
  z-index: 55555;
}
.home-admin .directions-home .head-title .add-icon:hover .img {
  transition: 0.5s;
  opacity: 1;
}
.home-admin .directions-home .head-title .info {
  font-size: 21px;
}
.home-admin .directions-home .box {
  position: relative;
  z-index: 2;
  width: 95%;
  height: 86%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 40px;
  box-shadow: rgba(99, 99, 99, 0.39) 0px 2px 13px 3px;
}
.home-admin .directions-home .box .direction {
  display: flex;
  flex-direction: column;
  width: 230px;
  height: 230px;
  margin: 10px;
  justify-content: center;
  gap: 20px;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  position: relative;
  transition: 0.5s;
  background-color: #fff;
}
.home-admin .directions-home .box .direction:not(:last-of-type):after {
  content: "";
  left: 0;
  position: absolute;
  top: 50%;
  width: 1px;
  height: 80%;
  background-color: #413634;
  transform: translateY(-50%);
  transition: 0.1s;
}
.home-admin .directions-home .box .direction:hover {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 10px 4px, rgba(60, 64, 67, 0.15) 0px 1px 9px 4px;
  transform: scale(1.05);
  transition: 0.5s;
  z-index: 3;
}
.home-admin .directions-home .box .direction:hover::after {
  width: 0;
  height: 0;
  transition: 0.1s;
}
.home-admin .directions-home .box .direction .edit-icon,
.home-admin .directions-home .box .direction .save-icon {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #d0d0d0;
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
}
.home-admin .directions-home .box .direction .image {
  width: 130px;
  height: 130px;
}
.home-admin .directions-home .box .direction .image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
@media (max-width: 768px) {
  .home-admin .directions-home {
    flex-direction: column;
    height: max-content;
    width: calc(100% - 60px);
  }
  .home-admin .directions-home .head-title {
    margin: 0 auto;
    margin-top: 30px;
    font-size: 20px;
  }
  .home-admin .directions-home .right,
  .home-admin .directions-home .left {
    width: 100%;
    height: max-content;
  }
  .home-admin .directions-home .left {
    height: 500px !important;
  }
  .home-admin .directions-home .left .effects {
    width: 100%;
  }
  .home-admin .directions-home .left .effects .effect.one {
    width: 350px;
    height: 350px;
    left: 3px !important;
  }
  .home-admin .directions-home .left .images {
    margin-top: 37px;
  }
  .home-admin .directions-home .box {
    width: 100%;
    justify-content: space-between;
    align-items: start;
  }
  .home-admin .directions-home .box:first-of-type .direction:before {
    content: "";
    left: -10px;
    position: absolute;
    top: 50%;
    width: 1px;
    height: 80%;
    background-color: #413634;
    transform: translateY(-50%);
    transition: 0.1s;
  }
  .home-admin .directions-home .box .direction {
    width: 48% !important;
    margin: 0;
  }
  .home-admin .directions-home .box .direction::after {
    display: none;
  }
}

.social-admin {
  background-color: #fdf8f2;
  height: 100%;
  width: 100%;
  min-height: 100dvh;
  padding-top: 50px;
  position: relative;
  overflow-x: hidden;
}
.social-admin .background {
  width: 100%;
  height: 321px;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0.2;
  background: #fdf8f2;
  background-repeat: no-repeat;
  z-index: 0;
}
.social-admin .background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.social-admin .section {
  display: flex;
  width: 100%;
  height: 700px;
  position: relative;
  z-index: 2;
  flex-direction: column;
  color: #000;
  text-decoration: none;
}
.social-admin .section.spic {
  background-color: #fcf2ec;
}
.social-admin .section .head-title {
  font-size: 40px;
  font-weight: bold;
  width: max-content;
  position: relative;
  margin: 0 auto;
  margin-bottom: 40px;
  margin-top: 20px;
}
.social-admin .section .head-title span {
  position: relative;
  z-index: 2;
  color: #413634;
}
.social-admin .section .head-title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 104%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: #ffdead;
}
.social-admin .section .section-container {
  width: 100%;
  display: flex;
  height: 100%;
  justify-content: space-between;
  color: #000;
  text-decoration: none;
}
.social-admin .section .section-container .right {
  width: calc(40% - 40px);
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.social-admin .section .section-container .right .anthor-title {
  font-weight: bold;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.social-admin .section .section-container .right .anthor-title .title {
  font-size: 40px;
  position: relative;
  width: max-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 0 !important;
}
.social-admin .section .section-container .right .anthor-title .title span {
  position: relative;
  z-index: 2;
  width: max-content;
  color: #413634;
}
.social-admin .section .section-container .right .anthor-title .title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 104%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: #ffdead;
}
.social-admin .section .section-container .right .anthor-title .info {
  color: #413634;
  font-weight: bold;
  margin: 5px 0;
  width: 83%;
  text-align: center;
}
.social-admin .section .section-container .right .location {
  height: calc(100% - 100px);
  width: calc(100% - 40px);
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 20px;
}
.social-admin .section .section-container .right .location .location {
  width: 80%;
  height: 80%;
}
.social-admin .section .section-container .right .location .location img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.social-admin .section .section-container .left {
  width: calc(55% - 40px);
  padding-left: 40px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  position: relative;
}
.social-admin .section .section-container .left iframe {
  width: 100%;
  height: 80%;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;
}
.social-admin .section .section-container .left .info {
  width: 30%;
  position: absolute;
  height: 50px;
  border-radius: 30px;
  bottom: 15%;
  left: 50%;
  transform: translateX(-45%);
  border: 1px solid #413634;
  background-color: #fcf2ec;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #000;
  text-decoration: none;
}
.social-admin .section .section-container .left .info a {
  color: #000;
  text-decoration: none;
}
.social-admin .section .section-container .left .info .icon {
  position: absolute;
  right: 10px;
  width: 30px;
  height: 30px;
  top: 50%;
  transform: translateY(-50%);
  color: #000;
  text-decoration: none;
}
.social-admin .section .simple-title {
  font-size: 40px;
  font-weight: bold;
  width: max-content;
  position: relative;
  margin: 0 auto;
  margin-bottom: 40px;
  margin-top: 80px;
}
.social-admin .section .simple-title span {
  position: relative;
  z-index: 2;
  color: #413634;
}
.social-admin .section .simple-title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 104%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: #ffdead;
}
.social-admin .section .container {
  display: flex;
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  color: #000;
  text-decoration: none;
}
.social-admin .section .container .contact {
  width: 280px;
  height: 280px;
  display: flex;
  flex-direction: column;
  background-color: #fcf2ec;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-radius: 20px;
  border: 1px solid transparent;
  transition: 0.5s;
  transform: scale(1);
  color: #000;
  text-decoration: none;
}
.social-admin .section .container .contact:hover {
  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;
  border: 1px solid #413634;
  transform: scale(1.1);
  transition: 0.5s;
}
.social-admin .section .container .contact .icon {
  width: 100px;
  height: 100px;
  margin-top: 20px;
}
.social-admin .section .container .contact .title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 40px;
  width: 90%;
  position: relative;
  margin: 0 auto;
  text-align: center;
  color: #000;
  text-decoration: none;
}
.social-admin .section .container .contact .title::before {
  content: "";
  bottom: -20px;
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  border-radius: 10px;
  background-color: #413634;
}
.social-admin .section .container .contact .value {
  font-weight: normal;
  font-size: 18px;
  margin: 0 auto;
  text-align: center;
  color: #000;
  text-decoration: none;
}

@media (max-width: 768px) {
  .social-admin {
    height: max-content;
  }
  .social-admin .background {
    width: 100%;
    height: 121px;
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0.2;
    background: #fdf8f2;
    background-repeat: no-repeat;
    z-index: 0;
  }
  .social-admin .background img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .social-admin .head-title {
    display: none;
    margin-bottom: 30px;
  }
  .social-admin .head-title .title {
    margin-top: 10px;
    margin-bottom: 30px;
  }
  .social-admin .right,
  .social-admin .left {
    width: 100% !important;
    height: max-content !important;
  }
  .social-admin .tower .group {
    margin-left: 30px;
  }
  .social-admin .left {
    margin: 30px 0;
  }
  .social-admin .left iframe {
    width: 100%;
    margin: 0 auto;
    height: 300px !important;
    width: 90% !important;
  }
  .social-admin .left .info {
    width: 52% !important;
    position: absolute;
    height: 50px;
    border-radius: 30px;
    bottom: -7% !important;
    left: 50%;
    transform: translateX(-50%);
    border: 1px solid #413634;
    background-color: #fcf2ec;
    font-size: 20px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .social-admin .section {
    height: max-content !important;
  }
  .social-admin .section .section-container {
    width: 100%;
    display: flex;
    height: max-content !important;
    justify-content: space-between;
    flex-direction: column;
  }
  .social-admin .section .section-container .anthor-title .title {
    margin-right: 40px;
    margin-top: 20px;
  }
  .social-admin .section .section-container .anthor-title .info {
    width: max-content;
    font-size: 12px;
  }
  .social-admin .section .section-container .location {
    width: 100%;
  }
  .social-admin .section .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    flex-wrap: wrap;
    gap: 10px;
  }
  .social-admin .section .container .contact {
    width: calc(48% - 20px);
    height: 185px;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  .social-admin .section .container .contact .title {
    font-size: 18px !important;
  }
  .social-admin .section .container .contact .title::before {
    display: none;
  }
  .social-admin .section .container .contact .value {
    font-size: 16px !important;
  }
}
.services-admin {
  background-color: #fdf8f2;
  height: 100%;
  width: 100%;
  min-height: 100dvh;
  padding-top: 50px;
  position: relative;
  padding-bottom: 50px;
}
.services-admin .background {
  width: 100%;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0.1;
  background: #fdf8f2;
  background-repeat: no-repeat;
  z-index: 0;
}
.services-admin .background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.services-admin .head-title {
  font-size: 40px;
  font-weight: bold;
  width: max-content;
  position: relative;
  margin: 0 auto;
  margin-bottom: 40px;
  margin-top: 20px;
  z-index: 2;
}
.services-admin .head-title span {
  position: relative;
  z-index: 2;
  color: #413634;
}
.services-admin .head-title .add-icon {
  position: absolute;
  top: 0%;
  left: -35%;
  background-color: rgb(255, 255, 255);
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: -11px;
  z-index: 55555;
}
.services-admin .head-title .add-icon:hover .img {
  transition: 0.5s;
  opacity: 1;
}
.services-admin .head-title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 104%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: #ffdead;
}
.services-admin .services-container {
  width: 90%;
  margin: 0 auto;
  height: calc(100% - 240px);
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px;
}
.services-admin .services-container .service {
  display: flex;
  background-color: #fdf8f2;
  width: 350px;
  height: 520px;
  border-radius: 10px;
  flex-direction: column;
  align-items: center;
  transition: 0.5s;
  border: 1px solid transparent;
  position: relative;
}
.services-admin .services-container .service:hover {
  transition: 0.5s;
  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;
  border: 1px solid #413634;
}
.services-admin .services-container .service .edit-icon,
.services-admin .services-container .service .save-icon {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #d0d0d0;
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: 10px 0 0 0;
}
.services-admin .services-container .service .del-icon {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #d0d0d0;
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  border-radius: 10px 0 0 0;
}
.services-admin .services-container .service .content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  flex-direction: column;
  margin-bottom: 40px;
  position: relative;
}
.services-admin .services-container .service .content::before {
  content: "";
  bottom: -20px;
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  border-radius: 10px;
  background-color: #413634;
}
.services-admin .services-container .service .content .icon {
  width: 140px;
  height: 140px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.services-admin .services-container .service .content .title {
  font-size: 24px;
  margin-top: 10px;
  font-weight: bold;
  color: #413634;
}
.services-admin .services-container .service .grouping {
  display: flex;
  width: 90%;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
}
.services-admin .services-container .service .grouping .info {
  font-size: 16px;
  line-height: 2;
  text-align: center;
  color: #525252;
}
.services-admin .services-container .service .grouping .images {
  width: 50px;
  height: 50px;
  cursor: pointer;
}
.services-admin .services-container .service.spic {
  background-color: transparent;
}
.services-admin .services-container .service.spic:hover {
  transition: 0.5s;
  box-shadow: none;
  border: 1px solid transparent;
}
.services-admin .services-container .service.spic .content {
  height: 150px;
  background-color: #413634;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 10px;
}
.services-admin .services-container .service.spic .content::before {
  display: none;
}
.services-admin .services-container .service.spic .content .title {
  color: #fff;
  margin-bottom: 10px;
}
.services-admin .services-container .service .service-container {
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 20px;
  height: calc(100% - 150px);
  width: 100%;
}
.services-admin .services-container .service .service-container .service-d {
  width: 100%;
  background-color: #fdf8f2;
  border: 1px solid #413634;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  padding: 15px 0;
  color: #000;
  font-weight: bold;
  cursor: pointer;
  overflow: hidden;
  transition: 0.5s;
}
.services-admin .services-container .service .service-container .service-d span {
  width: 100%;
  text-align: center;
}
.services-admin .services-container .service .service-container .service-d .icon {
  width: 30px;
  height: 30px;
  position: relative;
  left: -100%;
  transition: 0.5s;
}
.services-admin .services-container .service .service-container .service-d:hover {
  transition: 0.5s;
  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;
  border: 1px solid #413634;
  width: 105%;
}
.services-admin .services-container .service .service-container .service-d:hover .icon {
  left: 20px;
  transition: 0.5s;
}

@media (max-width: 768px) {
  .services-admin {
    height: max-content;
  }
  .services-admin .background {
    width: 100%;
    height: 121px;
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0.2;
    background: #fdf8f2;
    background-repeat: no-repeat;
    z-index: 0;
  }
  .services-admin .background img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .services-admin .head-title {
    margin-bottom: 30px;
  }
  .services-admin .head-title .title {
    margin-top: 10px;
    margin-bottom: 30px;
  }
  .services-admin .services-container {
    height: max-content;
    width: 100%;
    flex-direction: column;
    padding-bottom: 50px;
    gap: 40px;
  }
  .services-admin .service {
    width: 350px !important;
    height: 450px !important;
  }
  .services-admin .service.spic .content {
    height: max-content;
  }
  .services-admin .service.spic .content .icon {
    width: 70px;
    height: 70px;
  }
  .services-admin .service .info {
    font-size: 13px !important;
  }
}
.cases-admin {
  background-color: #fdf8f2;
  height: 100%;
  width: 100%;
  min-height: 600px;
  padding-top: 50px;
  position: relative;
}
.cases-admin .head-title {
  font-size: 40px;
  font-weight: bold;
  width: max-content;
  position: relative;
  margin: 0 auto;
  margin-bottom: 40px;
  margin-top: 20px;
  z-index: 2;
}
.cases-admin .head-title span {
  position: relative;
  z-index: 2;
  color: #413634;
}
.cases-admin .head-title::before {
  content: "";
  bottom: 5px;
  position: absolute;
  left: 50%;
  height: 30px;
  width: 104%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: #ffdead;
}
.cases-admin .boxes {
  width: 90%;
  margin: 0 auto;
  height: 100%;
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 100px;
}
.cases-admin .boxes .box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fdf8f2;
  border: 1px solid transparent;
  border-radius: 10px;
  width: 300px;
  height: 300px;
  gap: 30px;
  cursor: pointer;
  transition: 0.5s;
  transform: scale(1);
}
.cases-admin .boxes .box:hover {
  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;
  border: 1px solid #413634;
  transform: scale(1.1);
  transition: 0.5s;
}
.cases-admin .boxes .box .icon {
  width: 150px;
  height: 150px;
}
.cases-admin .boxes .box .title {
  font-size: 18px;
  font-weight: bold;
}

@media (max-width: 768px) {
  .cases-admin {
    height: max-content;
  }
  .cases-admin .background {
    width: 100%;
    height: 121px;
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0.2;
    background: #fdf8f2;
    background-repeat: no-repeat;
    z-index: 0;
  }
  .cases-admin .background img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .cases-admin .head-title {
    margin-bottom: 30px;
  }
  .cases-admin .head-title .title {
    margin-top: 10px;
    margin-bottom: 30px;
  }
  .cases-admin .boxes {
    height: max-content;
    width: 100%;
    flex-direction: column;
    padding-bottom: 50px;
    gap: 40px;
    align-items: center;
  }
  .cases-admin .boxes .box {
    width: 250px;
    height: 250px;
  }
}
.login-page {
  width: 100%;
  min-height: 100dvb;
  height: 100dvb;
  max-height: 100dvb;
  overflow: hidden;
  background-color: #3e3e3e !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-page .background {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0;
  z-index: 1;
  bottom: 0;
  cursor: pointer;
}
.login-page .background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}
.login-page .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  position: relative;
  z-index: 4;
  height: 70%;
}
.login-page .container .login-box {
  height: 100%;
  width: 400px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
}
.login-page .container .login-box.loading .head-box {
  height: 80%;
  flex-direction: column;
  background-color: rgba(99, 255, 219, 0.444);
  transition: 0.5s;
}
.login-page .container .login-box.loading .head-box .image {
  width: 280px;
  height: 280px;
  margin-top: 20px;
  transition: 0.5s;
}
.login-page .container .login-box.loading .box {
  min-height: 10%;
  padding-top: 10px;
  transition: 0.5s;
}
.login-page .container .login-box.loading .box .group {
  display: none;
}
.login-page .container .login-box.loading .box .head-title {
  display: none;
}
.login-page .container .login-box .head-box {
  height: 150px;
  background: rgba(179, 179, 179, 0.25);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(6.3px);
  -webkit-backdrop-filter: blur(6.3px);
  border: 1px solid rgba(179, 179, 179, 0.42);
  display: flex;
  width: calc(100% - 40px);
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  transition: 0.5s;
}
.login-page .container .login-box .head-box .image {
  width: 120px;
  height: 120px;
  transition: 0.5s;
}
.login-page .container .login-box .head-box .image img {
  width: 100%;
  height: 100%;
}
.login-page .container .login-box .head-box .group {
  width: calc(100% - 150px);
  height: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.login-page .container .login-box .head-box .group .title {
  font-weight: bold;
  position: relative;
  font-size: 18px;
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
}
.login-page .container .login-box .head-box .group .title::after {
  content: "";
  bottom: -10px;
  left: 0;
  height: 1px;
  background-color: #fff;
  width: 100%;
  position: absolute;
}
.login-page .container .login-box .head-box .info {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
}
.login-page .container .login-box .head-box .info .grouping {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 2px;
  width: 48%;
  height: 20px;
}
.login-page .container .login-box .head-box .info .grouping.spic {
  justify-content: end;
}
.login-page .container .login-box .head-box .info .grouping.spic .value {
  direction: ltr;
}
.login-page .container .login-box .head-box .info .grouping .icon {
  width: 20px;
  height: 20px;
}
.login-page .container .login-box .head-box .info .grouping .title {
  font-size: 14px;
  width: calc(100% - 20px);
}
.login-page .container .login-box .box {
  min-height: calc(96% - 180px);
  height: max-content;
  background: rgba(179, 179, 179, 0.25);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(6.3px);
  -webkit-backdrop-filter: blur(6.3px);
  border: 1px solid rgba(179, 179, 179, 0.42);
  width: calc(100% - 40px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
  gap: 40px;
  align-items: center;
  padding-bottom: 20px;
  transition: 0.5s;
}
.login-page .container .login-box .box .head-title {
  font-size: 24px;
  font-weight: bold;
  margin: 20px 0 10px;
}
.login-page .container .login-box .box .group {
  height: 40%;
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-direction: column;
}
.login-page .container .login-box .box .group input {
  width: 100%;
  outline: none;
  border: 1px solid #3e3e3e;
  background-color: #fff;
  height: 50px;
  border-radius: 10px;
  text-align: center;
}
.login-page .container .login-box .box .login-btn {
  width: 90%;
  height: 40px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  padding: 10px 0;
  align-items: center;
  background-color: #ffc73d;
  color: #000;
  font-weight: bold;
  font-size: 18px;
  cursor: pointer;
  margin-bottom: 6px;
}
.login-page .container .left {
  height: 100%;
  width: 280px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}
.login-page .container .left .group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}
.login-page .container .left .group .company-name {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  text-transform: uppercase;
  color: #fff;
  font-size: 24px;
  direction: ltr;
}
.login-page .container .left .group .logo {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-page .container .left .group .logo img {
  width: 90%;
  height: 90%;
  object-fit: contain;
}
.login-page .container .left .copyright {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: start;
  gap: 10px;
  padding-left: 10px;
  font-weight: bold;
  text-transform: uppercase;
  flex-direction: column;
  width: 379px;
  position: relative;
  left: 50px;
  direction: ltr;
}
.login-page .container .left .copyright .title {
  font-size: 24px;
  margin-bottom: -10px;
}
.login-page .container .left .copyright .info {
  font-size: 14px;
  font-weight: 600;
}
.login-page .container .left .box {
  background: rgba(179, 179, 179, 0.25);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(6.3px);
  -webkit-backdrop-filter: blur(6.3px);
  border: 1px solid rgba(179, 179, 179, 0.42);
}

@media (max-width: 768px) {
  .login-page {
    align-items: start;
    gap: 40px;
  }
  .login-page .container {
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    width: 90%;
    justify-content: space-between;
    gap: 40px;
    height: 100%;
  }
  .login-page .container .head-box .value {
    font-size: 10px;
    font-weight: bold;
  }
  .login-page .container .login-box {
    width: 100%;
    gap: 10px;
    height: 67%;
  }
  .login-page .container .login-box .box {
    height: calc(100% - 90px);
  }
  .login-page .container .left {
    width: 100%;
    height: 27%;
  }
  .login-page .container .left .group {
    flex-direction: row;
    width: 100%;
    align-items: flex-end;
    justify-content: flex-end;
  }
  .login-page .container .left .group .copyright {
    width: calc(100% - 120px);
    left: 0;
    height: 60px;
  }
  .login-page .container .left .group .copyright .title {
    font-size: 18px;
  }
  .login-page .container .left .group .copyright .info {
    font-size: 12px;
  }
  .login-page .container .left .group .logo {
    width: 120px;
    height: 120px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/_global.scss","webpack://./src/main.scss","webpack://./src/components/client/actions/main.scss","webpack://./src/components/client/header/main.scss","webpack://./src/components/client/footer/main.scss","webpack://./src/components/admin/actions/main.scss","webpack://./src/pages/client/home/main.scss","webpack://./src/pages/client/home/styles/_landing.scss","webpack://./src/pages/client/home/styles/_aboutClinic.scss","webpack://./src/pages/client/home/styles/_aboutDR.scss","webpack://./src/pages/client/home/styles/_certificates.scss","webpack://./src/pages/client/home/styles/_directions.scss","webpack://./src/pages/client/social/main.scss","webpack://./src/pages/client/services/main.scss","webpack://./src/pages/client/cases/main.scss","webpack://./src/pages/admin/home/main.scss","webpack://./src/pages/admin/home/styles/_landing.scss","webpack://./src/pages/admin/home/styles/_aboutClinic.scss","webpack://./src/pages/admin/home/styles/_aboutDR.scss","webpack://./src/pages/admin/home/styles/_certificates.scss","webpack://./src/pages/admin/home/styles/_directions.scss","webpack://./src/pages/admin/social/main.scss","webpack://./src/pages/admin/services/main.scss","webpack://./src/pages/admin/cases/main.scss","webpack://./src/pages/login/main.scss"],"names":[],"mappings":"AAAA,sBAAA;AACA;EACE,oBAAA;EACA,+DAAA;EACA,iBAAA;ACCF;ADEA;EACE,oBAAA;EACA,+DAAA;EACA,mBAAA;ACAF;ADEA;EACE,oBAAA;EACA,+DAAA;EACA,gBAAA;ACAF;ADEA,oBAAA;AAEA,qBAAA;AAEA;EACE,qBAAA;EACA,qBAAA;ACFF;;ADKA;EACE,8BAAA;ACFF;;ADKA;EACE,gCAAA;EACA,cAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;ACFF;ADGE;;;EAGE,2CAAA;ACDJ;ADGE;EACE,mBAAA;EACA,2CAAA;ACDJ;;ADKA,mBAAA;AEnDA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,UAAA;EACA,OAAA;ADkDF;AChDE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;ADkDJ;AChDE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;ADkDJ;ACjDI;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;ADmDN;AC/CU;EACE,qBAAA;EACA,gBAAA;ADiDZ;AC9CQ;EACE,OAAA;EACA,UAAA;EACA,wBAAA;ADgDV;AC7CM;EACE,OAAA;EACA,UAAA;EACA,wBAAA;AD+CR;AC5CQ;EACE,qBAAA;EACA,gBAAA;AD8CV;AC3CM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AD6CR;AC5CQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AD8CV;AC3CM;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,wBAAA;EACA,8DAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EAEA,WAAA;EACA,WAAA;AD4CR;AC1CQ;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AD4CV;AC3CU;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;AD6CZ;AC1CQ;EACE,eAAA;EACA,kBAAA;AD4CV;;ACtCA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,OAAA;ADyCF;ACvCE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;ADyCJ;ACvCE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;ADyCJ;ACxCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AD0CN;ACtCU;EACE,qBAAA;EACA,gBAAA;ADwCZ;ACrCQ;EACE,OAAA;EACA,UAAA;EACA,wBAAA;ADuCV;ACnCM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;ADqCR;ACpCQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;ADsCV;ACnCM;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,wBAAA;EACA,8DAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EAEA,WAAA;EACA,WAAA;ADoCR;AClCQ;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ADoCV;;AC9BA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,OAAA;ADiCF;AC/BE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;ADiCJ;AC/BE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;ADiCJ;AChCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADkCN;AC9BU;EACE,qBAAA;EACA,gBAAA;ADgCZ;AC7BQ;EACE,OAAA;EACA,UAAA;EACA,wBAAA;AD+BV;AC3BM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AD6BR;AC5BQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AD8BV;AC3BM;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,wBAAA;EACA,8DAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EAEA,WAAA;EACA,WAAA;AD4BR;AC1BQ;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AD4BV;;ACtBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,OAAA;ADyBF;ACvBE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;ADyBJ;ACvBE;EACE,UAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EAEA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;ADwBJ;ACvBI;EACE,UAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADyBN;ACvBM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;ADyBR;ACvBM;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,8DAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;ADyBR;ACtBI;EACE,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;EACA,SAAA;ADwBN;ACvBM;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;ADyBR;ACxBQ;EACE,gDAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA,EAAA,sBAAA;EACA,YAAA,EAAA,uBAAA;AD0BV;;ACpBA;EAEI;IACE,YAAA;IACA,aAAA;EDsBJ;AACF;AE3ZA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,aAAA;EACA,6BAAA;EACA,SAAA;AF6ZF;AE5ZE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AF8ZJ;AE5ZI;EAEE,gBAAA;EACA,WAAA;AF6ZN;;AExZA;EACE;IACE,WAAA;EF2ZF;EEzZE;IACE,eAAA;EF2ZJ;AACF;AGhcA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AHkcF;AGjcE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AHmcJ;AGhcE;EACE,WAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;AHkcJ;AGjcI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AHmcN;AGlcM;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,2BAAA;EACA,gBAAA;AHocR;AGlcM;EACE,YAAA;EACA,aAAA;AHocR;AGlcQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AHocV;AGjcM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AHmcR;AGlcQ;EACE,eAAA;EACA,iBAAA;AHocV;AGlcQ;EACE,eAAA;EACA,gBAAA;AHocV;AGhcM;EACE,WAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AHkcR;AGhcQ;EACE,YAAA;EACA,WAAA;AHkcV;AGhcQ;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;AHkcV;AGjcU;EACE,iBAAA;EACA,eAAA;AHmcZ;AG/bM;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;AHicR;AGhcQ;EACE,aAAA;EACA,sBAAA;AHkcV;AGhcQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AHkcV;AGhcQ;EACE,iBAAA;AHkcV;;AG3bA;EAGM;IACE,SAAA;IACA,eAAA;IACA,wBAAA;EH4bN;EG3bM;IACE,aAAA;EH6bR;EG3bM;IACE,aAAA;EH6bR;AACF;AItkBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,OAAA;AJwkBF;AItkBE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,OAAA;EACA,MAAA;AJwkBJ;AItkBE;EACE,UAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AJwkBJ;AIvkBI;EACE,eAAA;EACA,iBAAA;AJykBN;AIvkBI;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AJykBN;AIxkBM;EACE,YAAA;EACA,aAAA;EACA,eAAA;AJ0kBR;AIzkBQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AJ2kBV;AIxkBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AJ0kBR;AIxkBM;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,8DAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;AJ0kBR;AIvkBI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AJykBN;AIxkBM;EACE,UAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AJ0kBR;AIvkBI;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AJykBN;;AIrkBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,OAAA;AJwkBF;AItkBE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,OAAA;EACA,MAAA;AJwkBJ;AItkBE;EACE,UAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AJwkBJ;AIvkBI;EACE,eAAA;EACA,iBAAA;AJykBN;AIvkBI;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;AJykBN;AIvkBM;EACE,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;AJykBR;AIxkBQ;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AJ0kBV;AIzkBU;EAME,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AJskBZ;AI9kBY;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AJglBd;AIzkBU;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AJ2kBZ;AItkBI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AJwkBN;AIvkBM;;EAEE,YAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AJykBR;AIvkBM;EACE,aAAA;AJykBR;AItkBI;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AJwkBN;;AIpkBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,OAAA;AJukBF;AIrkBE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,OAAA;EACA,MAAA;AJukBJ;AIrkBE;EACE,UAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AJukBJ;AItkBI;EACE,eAAA;EACA,iBAAA;AJwkBN;AItkBI;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;AJwkBN;AItkBM;EACE,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;AJwkBR;AIvkBQ;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AJykBV;AIxkBU;EAME,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AJqkBZ;AI7kBY;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AJ+kBd;AIxkBU;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AJ0kBZ;AIrkBI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AJukBN;AItkBM;;EAEE,YAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AJwkBR;AItkBM;EACE,aAAA;AJwkBR;AIrkBI;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AJukBN;;AInkBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,OAAA;AJskBF;AIpkBE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,OAAA;EACA,MAAA;AJskBJ;AIpkBE;EACE,UAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AJskBJ;AIrkBI;EACE,eAAA;EACA,iBAAA;AJukBN;AIpkBI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AJskBN;AIrkBM;;EAEE,YAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AJukBR;AIrkBM;EACE,aAAA;AJukBR;AIpkBI;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AJskBN;;AIlkBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,OAAA;AJqkBF;AInkBE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,OAAA;EACA,MAAA;AJqkBJ;AInkBE;EACE,UAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AJqkBJ;AIpkBI;EACE,eAAA;EACA,iBAAA;AJskBN;AInkBI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AJqkBN;AIpkBM;;EAEE,YAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AJskBR;AIpkBM;EACE,aAAA;AJskBR;AInkBI;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AJqkBN;;AIhkBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,UAAA;EACA,OAAA;AJmkBF;AIjkBE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;AJmkBJ;AIjkBE;EACE,eAAA;EACA,OAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AJmkBJ;AIjkBM;EACE,gBAAA;EACA,UAAA;AJmkBR;AI/jBE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;AJikBJ;AIhkBI;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AJkkBN;AI9jBU;EACE,qBAAA;EACA,gBAAA;AJgkBZ;AI7jBQ;EACE,OAAA;EACA,UAAA;EACA,wBAAA;AJ+jBV;AI5jBM;EACE,OAAA;EACA,UAAA;EACA,wBAAA;AJ8jBR;AI3jBQ;EACE,qBAAA;EACA,gBAAA;AJ6jBV;AI1jBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AJ4jBR;AI3jBQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AJ6jBV;AI1jBM;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,wBAAA;EACA,8DAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EAEA,WAAA;EACA,WAAA;AJ2jBR;AIzjBQ;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AJ2jBV;AI1jBU;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;AJ4jBZ;AIzjBQ;EACE,eAAA;EACA,kBAAA;AJ2jBV;AIvjBI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AJyjBN;AIvjBI;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AJyjBN;;AIrjBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,UAAA;EACA,OAAA;AJwjBF;AItjBE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;AJwjBJ;AItjBE;EACE,kBAAA;EACA,OAAA;EACA,OAAA;EACA,oCAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AJwjBJ;AItjBM;EACE,gBAAA;EACA,UAAA;AJwjBR;AIpjBE;EACE,UAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AJsjBJ;AIrjBI;EACE,eAAA;EACA,iBAAA;AJujBN;AIrjBI;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AJujBN;AItjBM;EACE,YAAA;EACA,aAAA;EACA,eAAA;AJwjBR;AIvjBQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AJyjBV;AItjBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AJwjBR;AItjBM;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,8DAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;AJwjBR;AIrjBI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AJujBN;AItjBM;EACE,UAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AJwjBR;AIrjBI;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AJujBN;;AInjBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,UAAA;EACA,OAAA;AJsjBF;AIpjBE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;AJsjBJ;AIpjBE;EACE,kBAAA;EACA,OAAA;EACA,OAAA;EACA,oCAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AJsjBJ;AIpjBM;EACE,gBAAA;EACA,UAAA;AJsjBR;AIljBE;EACE,UAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AJojBJ;AInjBI;EACE,eAAA;EACA,iBAAA;AJqjBN;AInjBI;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AJqjBN;AIpjBM;EACE,YAAA;EACA,aAAA;EACA,eAAA;AJsjBR;AIrjBQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AJujBV;AIpjBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AJsjBR;AIpjBM;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,8DAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;AJsjBR;AInjBI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AJqjBN;AIpjBM;EACE,UAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AJsjBR;AInjBI;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AJqjBN;;AIhjBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,OAAA;AJmjBF;AIjjBE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;AJmjBJ;AIjjBE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AJmjBJ;AIjjBM;EACE,gBAAA;EACA,UAAA;AJmjBR;AI9iBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;AJgjBJ;AI9iBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AJgjBN;AI5iBU;EACE,qBAAA;EACA,gBAAA;AJ8iBZ;AI3iBQ;EACE,OAAA;EACA,UAAA;EACA,wBAAA;AJ6iBV;AI1iBM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AJ4iBR;AI1iBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AJ4iBR;AI3iBQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AJ6iBV;AI1iBM;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,wBAAA;EACA,8DAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EAEA,WAAA;EACA,WAAA;AJ2iBR;AIziBQ;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AJ2iBV;;AIriBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,UAAA;EACA,OAAA;AJwiBF;AItiBE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;AJwiBJ;AItiBE;EACE,kBAAA;EACA,OAAA;EACA,OAAA;EACA,oCAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AJwiBJ;AItiBM;EACE,gBAAA;EACA,UAAA;AJwiBR;AIpiBE;EACE,UAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AJsiBJ;AIriBI;EACE,eAAA;EACA,iBAAA;AJuiBN;AIriBI;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AJuiBN;AItiBM;EACE,YAAA;EACA,aAAA;EACA,eAAA;AJwiBR;AIviBQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AJyiBV;AItiBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AJwiBR;AItiBM;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,8DAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;AJwiBR;AIriBI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AJuiBN;AItiBM;EACE,UAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AJwiBR;AIriBI;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AJuiBN;;AIliBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,OAAA;AJqiBF;AIniBE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;AJqiBJ;AIniBE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AJqiBJ;AIniBM;EACE,gBAAA;EACA,UAAA;AJqiBR;AIhiBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;AJkiBJ;AIhiBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AJkiBN;AI9hBU;EACE,qBAAA;EACA,gBAAA;AJgiBZ;AI7hBQ;EACE,OAAA;EACA,UAAA;EACA,wBAAA;AJ+hBV;AI5hBM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AJ8hBR;AI5hBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AJ8hBR;AI7hBQ;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AJ+hBV;AI5hBM;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,wBAAA;EACA,8DAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EAEA,WAAA;EACA,WAAA;AJ6hBR;AI3hBQ;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AJ6hBV;;AIthBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,UAAA;EACA,OAAA;AJyhBF;AIvhBE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;AJyhBJ;AIvhBE;EACE,kBAAA;EACA,OAAA;EACA,OAAA;EACA,oCAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AJyhBJ;AIvhBM;EACE,gBAAA;EACA,UAAA;AJyhBR;AIrhBE;EACE,UAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AJuhBJ;AIthBI;EACE,eAAA;EACA,iBAAA;AJwhBN;AIthBI;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AJwhBN;AIvhBM;EACE,YAAA;EACA,aAAA;EACA,eAAA;AJyhBR;AIxhBQ;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AJ0hBV;AIvhBM;;EAEE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AJyhBR;AIvhBM;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,8DAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;AJyhBR;AIthBI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AJwhBN;AIvhBM;EACE,UAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AJyhBR;AIthBI;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AJwhBN;;AKz/DA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AL4/DF;AMpgEA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;ANsgEF;AMjgEQ;EACE,cAAA;EACA,qBAAA;ANmgEV;AMhgEM;EACE,UAAA;EACA,cAAA;ANkgER;AM//DQ;EACE,gBAAA;EACA,kBAAA;ANigEV;AM//DQ;EACE,cAAA;EACA,UAAA;ANigEV;AM7/DI;EACE,YAAA;EACA,cAAA;AN+/DN;AM5/DM;EACE,YAAA;EACA,cAAA;AN8/DR;AM5/DM;EACE,UAAA;AN8/DR;AM5/DQ;EACE,qCAAA;AN8/DV;AM5/DQ;EACE,UAAA;EACA,cAAA;AN8/DV;AMx/DE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;AN0/DJ;AMx/DI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AN0/DN;AMv/DE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;ANy/DJ;AMx/DI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;AN0/DN;AMz/DM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AN2/DR;AMx/DI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,cAAA;EAEA,yBAAA;ANy/DN;AMv/DI;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;ANy/DN;AMx/DM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AN0/DR;AMx/DQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AN0/DV;AMv/DM;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;ANy/DR;AMv/DQ;EACE,iBAAA;EACA,eAAA;ANy/DV;AMp/DE;EACE,kBAAA;EACA,OAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,cAAA;ANs/DJ;AMp/DI;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,OAAA;ANs/DN;AMr/DM;EACE,UAAA;EACA,UAAA;ANu/DR;AMr/DM;EACE,UAAA;EACA,UAAA;ANu/DR;AMr/DM;EACE,WAAA;ANu/DR;AMl/DE;EACE,UAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;ANo/DJ;AMn/DI;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;ANq/DN;AMn/DI;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;ANq/DN;AMn/DM;EACE,oBAAA;EACA,oBAAA;ANq/DR;AMp/DQ;EACE;IACE,oBAAA;ENs/DV;EMp/DQ;IACE,sBAAA;ENs/DV;AACF;AMn/DM;EACE,UAAA;ANq/DR;AMh/DA;EACE;IACE,aAAA;ENk/DF;EMj/DE;IACE,WAAA;IACA,WAAA;IACA,kBAAA;IACA,UAAA;IAEA,aAAA;IACA,uBAAA;IACA,SAAA;IACA,mBAAA;IACA,sBAAA;ENk/DJ;EMj/DI;IACE,uBAAA;IACA,wBAAA;IACA,iBAAA;IACA,mBAAA;ENm/DN;EMj/DI;IACE,0BAAA;IACA,iBAAA;IACA,WAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;ENm/DN;EMl/DM;IACE,iBAAA;IACA,0BAAA;ENo/DR;EM/+DI;IACE,YAAA;IACA,aAAA;IACA,kBAAA;IACA,YAAA;IACA,UAAA;IACA,UAAA;IACA,yBAAA;ENi/DN;EM9+DI;IACE,WAAA;IACA,YAAA;ENg/DN;EM5+DI;IACE,wBAAA;EN8+DN;EM3+DE;IACE,uBAAA;IACA,uBAAA;EN6+DJ;AACF;AOzwEA;EACE,wBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AP2wEF;AO1wEE;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;AP4wEJ;AO3wEI;;EAEE,UAAA;EACA,0BAAA;AP6wEN;AO1wEE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AP4wEJ;AO3wEI;EACE,kBAAA;EACA,UAAA;EACA,cAAA;AP6wEN;AO3wEI;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,2BAAA;AP6wEN;AO1wEE;EACE,aAAA;EACA,sBAAA;AP4wEJ;AO1wEI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AP4wEN;AO1wEI;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AP4wEN;AO3wEM;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AP6wER;AO3wEM;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AP6wER;AOzwEE;EACE,kBAAA;AP2wEJ;AO1wEI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AP4wEN;AO3wEM;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AP6wER;AO3wEQ;EACE,QAAA;EACA,SAAA;EACA,UAAA;EACA,sCAAA,EAAA,aAAA;AP6wEV;AO3wEQ;EACE,WAAA;EACA,UAAA;EACA,UAAA;EACA,uCAAA,EAAA,aAAA;AP6wEV;AO1wEQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AP4wEV;AOxwEI;EACE,kBAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AP0wEN;AOxwEM;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;AP0wER;AOzwEQ;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;AP2wEV;AOzwEQ;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;AP2wEV;AOzwEQ;EACE,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AP2wEV;AOtwEE;EACE;IACE,wBAAA;EPwwEJ;EOtwEE;IACE,2BAAA;EPwwEJ;AACF;AOtwEE;EACE;IACE,2BAAA;EPwwEJ;EOtwEE;IACE,wBAAA;EPwwEJ;AACF;AOpwEA;EACE;IACE,sBAAA;IACA,mBAAA;IACA,wBAAA;IACA,iBAAA;EPswEF;EOrwEE;IACE,cAAA;IACA,gBAAA;EPuwEJ;EOrwEE;IACE,8BAAA;EPuwEJ;EOtwEI;;IAEE,WAAA;IACA,mBAAA;EPwwEN;EOrwEE;IACE,gBAAA;EPuwEJ;EOtwEI;IACE,gBAAA;IACA,eAAA;EPwwEN;EOrwEE;IACE,wBAAA;IACA,oBAAA;EPuwEJ;EOrwEM;IACE,YAAA;EPuwER;EOpwEI;IACE,WAAA;EPswEN;EOrwEM;IACE,YAAA;IACA,aAAA;IACA,oBAAA;EPuwER;EOpwEI;IACE,gBAAA;EPswEN;AACF;AQj9EA;EACE,wBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;ARm9EF;AQl9EE;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;ARo9EJ;AQl9EI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;ARo9EN;AQj9EE;;EAEE,0BAAA;EACA,kBAAA;EACA,UAAA;ARm9EJ;AQh9EE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ARk9EJ;AQh9EI;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,sCAAA,EAAA,aAAA;EACA,kBAAA;ARk9EN;AQh9EQ;EACE,UAAA;EACA,wBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;ARk9EV;AQ/8EM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;ARi9ER;AQ/8EM;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,UAAA;EACA,UAAA;EAEA,YAAA;EACA,eAAA;EACA,UAAA;EACA,wBAAA;ARg9ER;AQ98EQ;EACE,WAAA;EACA,YAAA;EACA,8DAAA;EACA,mBAAA;ARg9EV;AQ98EQ;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,QAAA;ARg9EV;AQ/8EU;EACE,yBAAA;ARi9EZ;AQ38EE;EACE,aAAA;EACA,sBAAA;EACA,UAAA;AR68EJ;AQ38EI;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AR68EN;AQ58EM;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AR88ER;AQ78EQ;EACE,kBAAA;EACA,UAAA;EACA,cAAA;AR+8EV;AQ78EQ;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,2BAAA;AR+8EV;AQ58EM;EACE,eAAA;AR88ER;AQ38EI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AR68EN;AQ38EM;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AR68ER;AQ58EQ;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;AR88EV;AQ18EI;EACE,WAAA;EACA,8BAAA;EACA,aAAA;EACA,UAAA;AR48EN;AQ38EM;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AR68ER;AQx8EE;EACE;IACE,wBAAA;ER08EJ;EQx8EE;IACE,2BAAA;ER08EJ;AACF;AQv8EA;EACE;IACE,8BAAA;IACA,mBAAA;IACA,wBAAA;ERy8EF;EQx8EE;IACE,cAAA;IACA,gBAAA;ER08EJ;EQx8EE;;IAEE,WAAA;IACA,mBAAA;IACA,mBAAA;ER08EJ;EQv8EI;IACE,WAAA;ERy8EN;EQx8EM;IACE,YAAA;IACA,aAAA;IACA,oBAAA;ER08ER;EQv8EI;IACE,WAAA;ERy8EN;EQv8EM;IACE,WAAA;IACA,eAAA;ERy8ER;EQt8EI;IACE,aAAA;IACA,WAAA;IACA,8BAAA;ERw8EN;EQt8EM;IACE,kCAAA;IACA,iBAAA;IACA,0BAAA;ERw8ER;EQr8EI;IACE,gBAAA;ERu8EN;AACF;ASrrFA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;ATurFF;AStrFE;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;ATwrFJ;AStrFI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;ATwrFN;ASrrFE;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;ATurFJ;AStrFI;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;ATwrFN;ASvrFM;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;ATyrFR;ASvrFM;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;EACA,2BAAA;ATyrFR;AStrFI;EACE,eAAA;ATwrFN;ASrrFE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;ATurFJ;AStrFI;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;ATwrFN;ASvrFM;EACE,uBAAA;ATyrFR;AStrFI;EACE,WAAA;EACA,mBAAA;EACA,oBAAA;ATwrFN;AStrFM;EACE,YAAA;ATwrFR;AStrFM;;EAEE,YAAA;EACA,gBAAA;ATwrFR;ASrrFI;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,kFAAA;EAEA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;ATsrFN;ASrrFM;EACE,YAAA;EACA,YAAA;EACA,mBAAA;ATurFR;AStrFQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;ATwrFV;ASrrFM;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,wBAAA;EACA,mBAAA;ATurFR;ASrrFQ;EACE,WAAA;EACA,YAAA;EACA,8DAAA;EACA,mBAAA;ATurFV;ASrrFQ;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;ATurFV;ASlrFU;EACE,gBAAA;EACA,mBAAA;ATorFZ;ASjrFQ;EACE,UAAA;EACA,wBAAA;EACA,MAAA;EACA,UAAA;ATmrFV;AS9qFE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;ATgrFJ;AS9qFI;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;ATgrFN;AS/qFM;EACE,YAAA;EACA,aAAA;EAEA,QAAA;EACA,SAAA;EACA,4CAAA;ATgrFR;AS9qFM;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,4CAAA;ATgrFR;AUz2FA;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;EACA,iBAAA;AV22FF;AU12FE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;AV42FJ;AU12FI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AV42FN;AUz2FE;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AV22FJ;AU12FI;EACE,iBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AV42FN;AU32FM;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AV62FR;AU32FM;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,2BAAA;AV62FR;AU12FI;EACE,eAAA;AV42FN;AUz2FE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,mBAAA;EAEA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mDAAA;AV02FJ;AUx2FI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AV02FN;AUz2FM;EACE,WAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,2BAAA;EACA,gBAAA;AV22FR;AUz2FM;EACE,0FAAA;EAEA,sBAAA;EACA,gBAAA;EACA,UAAA;AV02FR;AUz2FQ;EACE,QAAA;EACA,SAAA;EACA,gBAAA;AV22FV;AUx2FM;EACE,YAAA;EACA,aAAA;AV02FR;AUx2FQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AV02FV;AUn2FA;EACE;IACE,sBAAA;IACA,mBAAA;IACA,wBAAA;EVq2FF;EUp2FE;IACE,cAAA;IACA,gBAAA;IACA,eAAA;EVs2FJ;EUp2FE;;IAEE,WAAA;IACA,mBAAA;EVs2FJ;EUp2FE;IACE,wBAAA;EVs2FJ;EUr2FI;IACE,WAAA;EVu2FN;EUt2FM;IACE,YAAA;IACA,aAAA;IACA,oBAAA;EVw2FR;EUr2FI;IACE,gBAAA;EVu2FN;EUn2FE;IACE,WAAA;IACA,8BAAA;IACA,kBAAA;EVq2FJ;EUj2FQ;IACE,WAAA;IACA,WAAA;IACA,kBAAA;IACA,QAAA;IACA,UAAA;IACA,WAAA;IACA,yBAAA;IACA,2BAAA;IACA,gBAAA;EVm2FV;EU/1FI;IACE,qBAAA;IACA,SAAA;IACA,gBAAA;EVi2FN;EUh2FM;IACE,aAAA;EVk2FR;AACF;;AW1hGA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AX6hGF;AW5hGE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,UAAA;AX8hGJ;AW7hGI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AX+hGN;AW5hGE;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;AX8hGJ;AW7hGI;EACE,yBAAA;AX+hGN;AW7hGI;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AX+hGN;AW9hGM;EACE,kBAAA;EACA,UAAA;EACA,cAAA;AXgiGR;AW9hGM;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,UAAA;EACA,yBAAA;AXgiGR;AW7hGI;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AX+hGN;AW9hGM;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AXgiGR;AW/hGQ;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AXiiGV;AWhiGU;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;AXkiGZ;AWjiGY;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AXmiGd;AWjiGY;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,UAAA;EACA,yBAAA;AXmiGd;AWhiGU;EACE,cAAA;EACA,iBAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;AXkiGZ;AW/hGQ;EACE,0BAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AXiiGV;AWhiGU;EACE,UAAA;EACA,WAAA;AXkiGZ;AWjiGY;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AXmiGd;AWp9FM;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AXs9FR;AWr9FQ;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mFAAA;AXu9FV;AWp9FQ;EACE,UAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;AXs9FV;AWr9FU;EACE,WAAA;EACA,qBAAA;AXu9FZ;AWr9FU;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,qBAAA;AXu9FZ;AWl9FI;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AXo9FN;AWn9FM;EACE,kBAAA;EACA,UAAA;EACA,cAAA;AXq9FR;AWn9FM;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,UAAA;EACA,yBAAA;AXq9FR;AWl9FI;EACE,aAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AXo9FN;AWn9FM;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AXq9FR;AWp9FQ;EACE,mFAAA;EAEA,yBAAA;EACA,qBAAA;EACA,gBAAA;AXq9FV;AWn9FQ;EACE,YAAA;EACA,aAAA;EACA,gBAAA;AXq9FV;AWn9FQ;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;AXq9FV;AWp9FU;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;AXs9FZ;AWn9FQ;EACE,mBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;AXq9FV;;AW/8FA;EACE;IACE,mBAAA;EXk9FF;EWj9FE;IACE,WAAA;IACA,aAAA;IACA,kBAAA;IACA,QAAA;IACA,MAAA;IACA,YAAA;IACA,mBAAA;IACA,4BAAA;IACA,UAAA;EXm9FJ;EWl9FI;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EXo9FN;EWj9FE;IACE,aAAA;IACA,mBAAA;EXm9FJ;EWl9FI;IACE,gBAAA;IACA,mBAAA;EXo9FN;EWj9FE;;IAEE,sBAAA;IACA,8BAAA;EXm9FJ;EWh9FI;IACE,iBAAA;EXk9FN;EW/8FE;IACE,cAAA;EXi9FJ;EWh9FI;IACE,WAAA;IACA,cAAA;IACA,wBAAA;IACA,qBAAA;EXk9FN;EWh9FI;IACE,qBAAA;IACA,kBAAA;IACA,YAAA;IACA,mBAAA;IACA,sBAAA;IACA,SAAA;IACA,2BAAA;IACA,yBAAA;IACA,yBAAA;IACA,eAAA;IACA,iBAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,eAAA;EXk9FN;EW/8FE;IACE,8BAAA;EXi9FJ;EW/8FI;IACE,WAAA;IACA,aAAA;IACA,8BAAA;IAEA,8BAAA;IACA,sBAAA;EXg9FN;EW98FQ;IACE,kBAAA;IACA,gBAAA;EXg9FV;EW98FQ;IACE,kBAAA;IACA,eAAA;EXg9FV;EW58FM;IACE,WAAA;EX88FR;EW38FI;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,mBAAA;IACA,eAAA;IACA,SAAA;EX68FN;EW58FM;IACE,uBAAA;IACA,aAAA;IACA,iBAAA;IACA,mBAAA;EX88FR;EW78FQ;IACE,0BAAA;EX+8FV;EW98FU;IACE,aAAA;EXg9FZ;EW78FQ;IACE,0BAAA;EX+8FV;AACF;AY55GA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AZ85GF;AY75GE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,UAAA;AZ+5GJ;AY95GI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AZg6GN;AY55GE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;AZ85GJ;AY75GI;EACE,kBAAA;EACA,UAAA;EACA,cAAA;AZ+5GN;AY75GI;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,UAAA;EACA,yBAAA;AZ+5GN;AY35GE;EACE,UAAA;EACA,cAAA;EACA,0BAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AZ65GJ;AY55GI;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;AZ85GN;AY55GM;EACE,gBAAA;EACA,mFAAA;EAEA,yBAAA;AZ65GR;AY15GM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AZ45GR;AY35GQ;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;AZ65GV;AY35GQ;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AZ65GV;AY35GQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AZ65GV;AYz5GM;EACE,aAAA;EACA,UAAA;EAEA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AZ05GR;AYz5GQ;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AZ25GV;AYz5GQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;AZ25GV;AYv5GM;EACE,6BAAA;AZy5GR;AYx5GQ;EACE,gBAAA;EACA,gBAAA;EACA,6BAAA;AZ05GV;AYx5GQ;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EAQA,mBAAA;AZm5GV;AY15GU;EACE,aAAA;AZ45GZ;AY15GU;EACE,WAAA;EACA,mBAAA;AZ45GZ;AYv5GM;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,SAAA;EACA,0BAAA;EACA,WAAA;AZy5GR;AYx5GQ;EACE,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AZ05GV;AYz5GU;EACE,WAAA;EACA,kBAAA;AZ25GZ;AYz5GU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AZ25GZ;AYx5GU;EACE,gBAAA;EACA,mFAAA;EAEA,yBAAA;EACA,WAAA;AZy5GZ;AYv5GY;EACE,UAAA;EACA,gBAAA;AZy5Gd;;AYj5GA;EACE;IACE,mBAAA;EZo5GF;EYn5GE;IACE,WAAA;IACA,aAAA;IACA,kBAAA;IACA,QAAA;IACA,MAAA;IACA,YAAA;IACA,mBAAA;IACA,4BAAA;IACA,UAAA;EZq5GJ;EYp5GI;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EZs5GN;EYn5GE;IACE,mBAAA;EZq5GJ;EYp5GI;IACE,gBAAA;IACA,mBAAA;EZs5GN;EYn5GE;IACE,mBAAA;IACA,WAAA;IACA,sBAAA;IACA,oBAAA;IACA,SAAA;EZq5GJ;EYn5GE;IACE,uBAAA;IACA,wBAAA;EZq5GJ;EYn5GM;IACE,mBAAA;EZq5GR;EYp5GQ;IACE,WAAA;IACA,YAAA;EZs5GV;EYl5GI;IACE,0BAAA;EZo5GN;AACF;AalpHA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AbopHF;AalpHE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;AbopHJ;AanpHI;EACE,kBAAA;EACA,UAAA;EACA,cAAA;AbqpHN;AanpHI;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,UAAA;EACA,yBAAA;AbqpHN;AalpHE;EACE,UAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;AbopHJ;AanpHI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AbqpHN;AanpHM;EACE,mFAAA;EAEA,yBAAA;EACA,qBAAA;EACA,gBAAA;AbopHR;AalpHM;EACE,YAAA;EACA,aAAA;AbopHR;AalpHM;EACE,eAAA;EACA,iBAAA;AbopHR;;Aa/oHA;EACE;IACE,mBAAA;EbkpHF;EajpHE;IACE,WAAA;IACA,aAAA;IACA,kBAAA;IACA,QAAA;IACA,MAAA;IACA,YAAA;IACA,mBAAA;IACA,4BAAA;IACA,UAAA;EbmpHJ;EalpHI;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EbopHN;EajpHE;IACE,mBAAA;EbmpHJ;EalpHI;IACE,gBAAA;IACA,mBAAA;EbopHN;EajpHE;IACE,mBAAA;IACA,WAAA;IACA,sBAAA;IACA,oBAAA;IACA,SAAA;IACA,mBAAA;EbmpHJ;EalpHI;IACE,YAAA;IACA,aAAA;EbopHN;AACF;AcrwHA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AduwHF;Ae/wHA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AfixHF;Ae5wHQ;EACE,cAAA;EACA,qBAAA;Af8wHV;Ae3wHM;EACE,UAAA;EACA,cAAA;Af6wHR;Ae1wHQ;EACE,gBAAA;EACA,kBAAA;Af4wHV;Ae1wHQ;EACE,cAAA;EACA,UAAA;Af4wHV;AexwHI;EACE,YAAA;EACA,cAAA;Af0wHN;AevwHM;EACE,YAAA;EACA,cAAA;AfywHR;AevwHM;EACE,UAAA;AfywHR;AevwHQ;EACE,qCAAA;AfywHV;AevwHQ;EACE,UAAA;EACA,cAAA;AfywHV;AenwHE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;AfqwHJ;AenwHI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AfqwHN;AelwHE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AfowHJ;AenwHI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EAEA,mBAAA;EACA,UAAA;EACA,gBAAA;AfowHN;AenwHM;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;AfqwHR;AepwHQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AfswHV;AenwHM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AfqwHR;AenwHU;EACE,gBAAA;EACA,UAAA;AfqwHZ;AehwHI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,cAAA;EAEA,yBAAA;AfiwHN;Ae/vHI;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;AfiwHN;AehwHM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AfkwHR;AehwHQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AfkwHV;Ae/vHM;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;AfiwHR;Ae/vHQ;EACE,iBAAA;EACA,eAAA;AfiwHV;Ae5vHE;EACE,kBAAA;EACA,OAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,cAAA;Af8vHJ;Ae5vHI;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,OAAA;Af8vHN;Ae7vHM;EACE,UAAA;EACA,UAAA;Af+vHR;Ae7vHM;EACE,UAAA;EACA,UAAA;Af+vHR;Ae7vHM;EACE,WAAA;Af+vHR;Ae1vHE;EACE,UAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;Af4vHJ;Ae3vHI;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;Af6vHN;Ae3vHI;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;Af6vHN;Ae3vHM;EACE,oBAAA;EACA,oBAAA;Af6vHR;Ae5vHQ;EACE;IACE,oBAAA;Ef8vHV;Ee5vHQ;IACE,sBAAA;Ef8vHV;AACF;Ae3vHM;EACE,UAAA;Af6vHR;AexvHA;EACE;IACE,aAAA;Ef0vHF;EezvHE;IACE,WAAA;IACA,WAAA;IACA,kBAAA;IACA,UAAA;IAEA,aAAA;IACA,uBAAA;IACA,SAAA;IACA,mBAAA;IACA,sBAAA;Ef0vHJ;EezvHI;IACE,uBAAA;IACA,wBAAA;IACA,iBAAA;IACA,mBAAA;Ef2vHN;EezvHI;IACE,0BAAA;IACA,iBAAA;IACA,WAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;Ef2vHN;Ee1vHM;IACE,iBAAA;IACA,0BAAA;Ef4vHR;EevvHI;IACE,YAAA;IACA,aAAA;IACA,kBAAA;IACA,YAAA;IACA,UAAA;IACA,UAAA;IACA,yBAAA;EfyvHN;EetvHI;IACE,WAAA;IACA,YAAA;EfwvHN;EepvHI;IACE,aAAA;EfsvHN;EenvHE;IACE,uBAAA;IACA,uBAAA;EfqvHJ;AACF;AgB1iIA;EACE,wBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AhB4iIF;AgB3iIE;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;AhB6iIJ;AgB5iII;;EAEE,UAAA;EACA,0BAAA;AhB8iIN;AgB3iIE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AhB6iIJ;AgB5iII;EACE,kBAAA;EACA,UAAA;EACA,cAAA;AhB8iIN;AgB5iII;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,2BAAA;AhB8iIN;AgB3iIE;EACE,aAAA;EACA,sBAAA;AhB6iIJ;AgB3iII;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AhB6iIN;AgB3iIM;EACE,WAAA;EACA,YAAA;EACA,YAAA;AhB6iIR;AgB3iIM;;EAEE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AhB6iIR;AgB1iII;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AhB4iIN;AgB3iIM;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AhB6iIR;AgB3iIM;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AhB6iIR;AgBziIE;EACE,kBAAA;AhB2iIJ;AgB1iII;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AhB4iIN;AgB3iIM;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AhB6iIR;AgB5iIQ;EACE,YAAA;EACA,WAAA;AhB8iIV;AgB5iIQ;EACE,QAAA;EACA,SAAA;EACA,UAAA;EACA,sCAAA,EAAA,aAAA;AhB8iIV;AgB5iIQ;EACE,WAAA;EACA,UAAA;EACA,UAAA;EACA,uCAAA,EAAA,aAAA;AhB8iIV;AgB5iIQ;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AhB8iIV;AgB5iIY;EACE,gBAAA;EACA,UAAA;AhB8iId;AgB1iIQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AhB4iIV;AgBxiII;EACE,kBAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AhB0iIN;AgBxiIM;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;AhB0iIR;AgBziIQ;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;AhB2iIV;AgBziIQ;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;AhB2iIV;AgBziIQ;EACE,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AhB2iIV;AgBtiIE;EACE;IACE,wBAAA;EhBwiIJ;EgBtiIE;IACE,2BAAA;EhBwiIJ;AACF;AgBtiIE;EACE;IACE,2BAAA;EhBwiIJ;EgBtiIE;IACE,wBAAA;EhBwiIJ;AACF;AgBpiIA;EACE;IACE,sBAAA;IACA,mBAAA;IACA,wBAAA;IACA,iBAAA;EhBsiIF;EgBriIE;IACE,cAAA;IACA,gBAAA;EhBuiIJ;EgBriIE;IACE,8BAAA;EhBuiIJ;EgBtiII;;IAEE,WAAA;IACA,mBAAA;EhBwiIN;EgBriIE;IACE,gBAAA;EhBuiIJ;EgBtiII;IACE,gBAAA;IACA,eAAA;EhBwiIN;EgBriIE;IACE,wBAAA;IACA,oBAAA;EhBuiIJ;EgBriIM;IACE,YAAA;EhBuiIR;EgBpiII;IACE,WAAA;EhBsiIN;EgBriIM;IACE,YAAA;IACA,aAAA;IACA,oBAAA;EhBuiIR;EgBpiII;IACE,gBAAA;EhBsiIN;AACF;AiB1xIA;EACE,wBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AjB4xIF;AiB3xIE;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;AjB6xIJ;AiB3xII;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AjB6xIN;AiB1xIE;;EAEE,0BAAA;EACA,kBAAA;EACA,UAAA;AjB4xIJ;AiBzxIE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AjB2xIJ;AiBzxII;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,sCAAA,EAAA,aAAA;EACA,kBAAA;AjB2xIN;AiBzxIQ;EACE,UAAA;EACA,wBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;AjB2xIV;AiBxxIM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AjB0xIR;AiBxxIM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AjB0xIR;AiBxxIU;EACE,gBAAA;EACA,UAAA;AjB0xIZ;AiBtxIM;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,UAAA;EACA,UAAA;EAEA,YAAA;EACA,eAAA;EACA,UAAA;EACA,wBAAA;AjBuxIR;AiBrxIQ;EACE,WAAA;EACA,YAAA;EACA,8DAAA;EACA,mBAAA;AjBuxIV;AiBrxIQ;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,QAAA;AjBuxIV;AiBtxIU;EACE,yBAAA;AjBwxIZ;AiBlxIE;EACE,aAAA;EACA,sBAAA;EACA,UAAA;AjBoxIJ;AiBlxII;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AjBoxIN;AiBnxIM;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AjBqxIR;AiBpxIQ;EACE,kBAAA;EACA,UAAA;EACA,cAAA;AjBsxIV;AiBpxIQ;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,2BAAA;AjBsxIV;AiBnxIM;EACE,eAAA;AjBqxIR;AiBlxII;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AjBoxIN;AiBlxIM;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AjBoxIR;AiBnxIQ;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;AjBqxIV;AiBjxII;EACE,WAAA;EACA,8BAAA;EACA,aAAA;EACA,UAAA;AjBmxIN;AiBlxIM;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AjBoxIR;AiB/wIE;EACE;IACE,wBAAA;EjBixIJ;EiB/wIE;IACE,2BAAA;EjBixIJ;AACF;AiB9wIA;EACE;IACE,8BAAA;IACA,mBAAA;IACA,wBAAA;EjBgxIF;EiB/wIE;IACE,cAAA;IACA,gBAAA;EjBixIJ;EiB/wIE;;IAEE,WAAA;IACA,mBAAA;IACA,mBAAA;EjBixIJ;EiB9wII;IACE,WAAA;EjBgxIN;EiB/wIM;IACE,YAAA;IACA,aAAA;IACA,oBAAA;EjBixIR;EiB9wII;IACE,WAAA;EjBgxIN;EiB9wIM;IACE,WAAA;IACA,eAAA;EjBgxIR;EiB7wII;IACE,aAAA;IACA,WAAA;IACA,8BAAA;EjB+wIN;EiB7wIM;IACE,kCAAA;IACA,iBAAA;IACA,0BAAA;EjB+wIR;EiB5wII;IACE,gBAAA;EjB8wIN;AACF;AkBhhJA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;AlBkhJF;AkBjhJE;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AlBmhJJ;AkBjhJI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AlBmhJN;AkBhhJE;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AlBkhJJ;AkBjhJI;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AlBmhJN;AkBlhJM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,cAAA;AlBohJR;AkBlhJU;EACE,gBAAA;EACA,UAAA;AlBohJZ;AkBhhJM;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AlBkhJR;AkBhhJM;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;EACA,2BAAA;AlBkhJR;AkB/gJI;EACE,eAAA;AlBihJN;AkB9gJE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;AlBghJJ;AkB/gJI;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;AlBihJN;AkBhhJM;EACE,uBAAA;AlBkhJR;AkB/gJI;EACE,WAAA;EACA,mBAAA;EACA,oBAAA;AlBihJN;AkB/gJM;EACE,YAAA;AlBihJR;AkB/gJM;;EAEE,YAAA;EACA,gBAAA;AlBihJR;AkB9gJI;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,kFAAA;EAEA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AlB+gJN;AkB9gJM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AlBghJR;AkB9gJM;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AlBghJR;AkB/gJQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AlBihJV;AkB9gJM;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,wBAAA;EACA,mBAAA;AlBghJR;AkB9gJQ;EACE,WAAA;EACA,YAAA;EACA,8DAAA;EACA,mBAAA;AlBghJV;AkB9gJQ;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;AlBghJV;AkB3gJU;EACE,gBAAA;EACA,mBAAA;AlB6gJZ;AkB1gJQ;EACE,UAAA;EACA,wBAAA;EACA,MAAA;EACA,UAAA;AlB4gJV;AkBvgJE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AlBygJJ;AkBvgJI;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;AlBygJN;AkBxgJM;EACE,YAAA;EACA,aAAA;EAEA,QAAA;EACA,SAAA;EACA,4CAAA;AlBygJR;AkBvgJM;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,4CAAA;AlBygJR;AmBruJA;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;EACA,iBAAA;AnBuuJF;AmBtuJE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;AnBwuJJ;AmBtuJI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AnBwuJN;AmBruJE;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AnBuuJJ;AmBtuJI;EACE,iBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AnBwuJN;AmBvuJM;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AnByuJR;AmBvuJM;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,2BAAA;AnByuJR;AmBtuJI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,cAAA;AnBwuJN;AmBtuJQ;EACE,gBAAA;EACA,UAAA;AnBwuJV;AmBpuJI;EACE,eAAA;AnBsuJN;AmBnuJE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mDAAA;AnBquJJ;AmBnuJI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AnBquJN;AmBpuJM;EACE,WAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,2BAAA;EACA,gBAAA;AnBsuJR;AmBpuJM;EACE,0FAAA;EAEA,sBAAA;EACA,gBAAA;EACA,UAAA;AnBquJR;AmBpuJQ;EACE,QAAA;EACA,SAAA;EACA,gBAAA;AnBsuJV;AmBnuJM;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AnBquJR;AmBnuJM;EACE,YAAA;EACA,aAAA;AnBquJR;AmBnuJQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AnBquJV;AmB9tJA;EACE;IACE,sBAAA;IACA,mBAAA;IACA,wBAAA;EnBguJF;EmB/tJE;IACE,cAAA;IACA,gBAAA;IACA,eAAA;EnBiuJJ;EmB/tJE;;IAEE,WAAA;IACA,mBAAA;EnBiuJJ;EmB/tJE;IACE,wBAAA;EnBiuJJ;EmBhuJI;IACE,WAAA;EnBkuJN;EmBjuJM;IACE,YAAA;IACA,aAAA;IACA,oBAAA;EnBmuJR;EmBhuJI;IACE,gBAAA;EnBkuJN;EmB9tJE;IACE,WAAA;IACA,8BAAA;IACA,kBAAA;EnBguJJ;EmB5tJQ;IACE,WAAA;IACA,WAAA;IACA,kBAAA;IACA,QAAA;IACA,UAAA;IACA,WAAA;IACA,yBAAA;IACA,2BAAA;IACA,gBAAA;EnB8tJV;EmB1tJI;IACE,qBAAA;IACA,SAAA;EnB4tJN;EmB1tJM;IACE,aAAA;EnB4tJR;AACF;;AoBr7JA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;ApBw7JF;AoBv7JE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,UAAA;ApBy7JJ;AoBx7JI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;ApB07JN;AoBv7JE;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;ApBy7JJ;AoBx7JI;EACE,yBAAA;ApB07JN;AoBx7JI;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;ApB07JN;AoBz7JM;EACE,kBAAA;EACA,UAAA;EACA,cAAA;ApB27JR;AoBz7JM;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,UAAA;EACA,yBAAA;ApB27JR;AoBx7JI;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;ApB07JN;AoBz7JM;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;ApB27JR;AoB17JQ;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;ApB47JV;AoB37JU;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;ApB67JZ;AoB57JY;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;ApB87Jd;AoB57JY;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,UAAA;EACA,yBAAA;ApB87Jd;AoB37JU;EACE,cAAA;EACA,iBAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;ApB67JZ;AoB17JQ;EACE,0BAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;ApB47JV;AoB37JU;EACE,UAAA;EACA,WAAA;ApB67JZ;AoB57JY;EACE,WAAA;EACA,YAAA;EACA,mBAAA;ApB87Jd;AoB/2JM;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;ApBi3JR;AoBh3JQ;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mFAAA;ApBk3JV;AoB/2JQ;EACE,UAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;ApBi3JV;AoBh3JU;EACE,WAAA;EACA,qBAAA;ApBk3JZ;AoBh3JU;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,qBAAA;ApBk3JZ;AoB72JI;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;ApB+2JN;AoB92JM;EACE,kBAAA;EACA,UAAA;EACA,cAAA;ApBg3JR;AoB92JM;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,UAAA;EACA,yBAAA;ApBg3JR;AoB72JI;EACE,aAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;ApB+2JN;AoB92JM;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;ApBg3JR;AoB/2JQ;EACE,mFAAA;EAEA,yBAAA;EACA,qBAAA;EACA,gBAAA;ApBg3JV;AoB92JQ;EACE,YAAA;EACA,aAAA;EACA,gBAAA;ApBg3JV;AoB92JQ;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;ApBg3JV;AoB/2JU;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;ApBi3JZ;AoB92JQ;EACE,mBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;ApBg3JV;;AoB12JA;EACE;IACE,mBAAA;EpB62JF;EoB52JE;IACE,WAAA;IACA,aAAA;IACA,kBAAA;IACA,QAAA;IACA,MAAA;IACA,YAAA;IACA,mBAAA;IACA,4BAAA;IACA,UAAA;EpB82JJ;EoB72JI;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EpB+2JN;EoB52JE;IACE,aAAA;IACA,mBAAA;EpB82JJ;EoB72JI;IACE,gBAAA;IACA,mBAAA;EpB+2JN;EoB52JE;;IAEE,sBAAA;IACA,8BAAA;EpB82JJ;EoB32JI;IACE,iBAAA;EpB62JN;EoB12JE;IACE,cAAA;EpB42JJ;EoB32JI;IACE,WAAA;IACA,cAAA;IACA,wBAAA;IACA,qBAAA;EpB62JN;EoB32JI;IACE,qBAAA;IACA,kBAAA;IACA,YAAA;IACA,mBAAA;IACA,sBAAA;IACA,SAAA;IACA,2BAAA;IACA,yBAAA;IACA,yBAAA;IACA,eAAA;IACA,iBAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,eAAA;EpB62JN;EoB12JE;IACE,8BAAA;EpB42JJ;EoB12JI;IACE,WAAA;IACA,aAAA;IACA,8BAAA;IAEA,8BAAA;IACA,sBAAA;EpB22JN;EoBz2JQ;IACE,kBAAA;IACA,gBAAA;EpB22JV;EoBz2JQ;IACE,kBAAA;IACA,eAAA;EpB22JV;EoBv2JM;IACE,WAAA;EpBy2JR;EoBt2JI;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,mBAAA;IACA,eAAA;IACA,SAAA;EpBw2JN;EoBv2JM;IACE,uBAAA;IACA,aAAA;IACA,iBAAA;IACA,mBAAA;EpBy2JR;EoBx2JQ;IACE,0BAAA;EpB02JV;EoBz2JU;IACE,aAAA;EpB22JZ;EoBx2JQ;IACE,0BAAA;EpB02JV;AACF;AqBvzKA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;ArByzKF;AqBvzKE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,UAAA;ArByzKJ;AqBxzKI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;ArB0zKN;AqBtzKE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;ArBwzKJ;AqBvzKI;EACE,kBAAA;EACA,UAAA;EACA,cAAA;ArByzKN;AqBvzKI;EACE,kBAAA;EACA,OAAA;EACA,UAAA;EACA,oCAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,cAAA;ArByzKN;AqBvzKQ;EACE,gBAAA;EACA,UAAA;ArByzKV;AqBrzKI;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,UAAA;EACA,yBAAA;ArBuzKN;AqBnzKE;EACE,UAAA;EACA,cAAA;EACA,0BAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;ArBqzKJ;AqBpzKI;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;ArBszKN;AqBrzKM;EACE,gBAAA;EACA,mFAAA;EAEA,yBAAA;ArBszKR;AqBpzKM;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;ArBszKR;AqBpzKM;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;ArBszKR;AqBpzKM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;ArBszKR;AqBrzKQ;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;ArBuzKV;AqBrzKQ;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;ArBuzKV;AqBrzKQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;ArBuzKV;AqBnzKM;EACE,aAAA;EACA,UAAA;EAEA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;ArBozKR;AqBnzKQ;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;ArBqzKV;AqBnzKQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;ArBqzKV;AqBjzKM;EACE,6BAAA;ArBmzKR;AqBlzKQ;EACE,gBAAA;EACA,gBAAA;EACA,6BAAA;ArBozKV;AqBlzKQ;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EAQA,mBAAA;ArB6yKV;AqBpzKU;EACE,aAAA;ArBszKZ;AqBpzKU;EACE,WAAA;EACA,mBAAA;ArBszKZ;AqBjzKM;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,SAAA;EACA,0BAAA;EACA,WAAA;ArBmzKR;AqBlzKQ;EACE,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArBozKV;AqBnzKU;EACE,WAAA;EACA,kBAAA;ArBqzKZ;AqBnzKU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;ArBqzKZ;AqBlzKU;EACE,gBAAA;EACA,mFAAA;EAEA,yBAAA;EACA,WAAA;ArBmzKZ;AqBjzKY;EACE,UAAA;EACA,gBAAA;ArBmzKd;;AqB3yKA;EACE;IACE,mBAAA;ErB8yKF;EqB7yKE;IACE,WAAA;IACA,aAAA;IACA,kBAAA;IACA,QAAA;IACA,MAAA;IACA,YAAA;IACA,mBAAA;IACA,4BAAA;IACA,UAAA;ErB+yKJ;EqB9yKI;IACE,WAAA;IACA,YAAA;IACA,iBAAA;ErBgzKN;EqB7yKE;IACE,mBAAA;ErB+yKJ;EqB9yKI;IACE,gBAAA;IACA,mBAAA;ErBgzKN;EqB7yKE;IACE,mBAAA;IACA,WAAA;IACA,sBAAA;IACA,oBAAA;IACA,SAAA;ErB+yKJ;EqB7yKE;IACE,uBAAA;IACA,wBAAA;ErB+yKJ;EqB7yKM;IACE,mBAAA;ErB+yKR;EqB9yKQ;IACE,WAAA;IACA,YAAA;ErBgzKV;EqB5yKI;IACE,0BAAA;ErB8yKN;AACF;AsB9lLA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AtBgmLF;AsB9lLE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;AtBgmLJ;AsB/lLI;EACE,kBAAA;EACA,UAAA;EACA,cAAA;AtBimLN;AsB/lLI;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,UAAA;EACA,yBAAA;AtBimLN;AsB9lLE;EACE,UAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;AtBgmLJ;AsB/lLI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AtBimLN;AsB/lLM;EACE,mFAAA;EAEA,yBAAA;EACA,qBAAA;EACA,gBAAA;AtBgmLR;AsB9lLM;EACE,YAAA;EACA,aAAA;AtBgmLR;AsB9lLM;EACE,eAAA;EACA,iBAAA;AtBgmLR;;AsB3lLA;EACE;IACE,mBAAA;EtB8lLF;EsB7lLE;IACE,WAAA;IACA,aAAA;IACA,kBAAA;IACA,QAAA;IACA,MAAA;IACA,YAAA;IACA,mBAAA;IACA,4BAAA;IACA,UAAA;EtB+lLJ;EsB9lLI;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EtBgmLN;EsB7lLE;IACE,mBAAA;EtB+lLJ;EsB9lLI;IACE,gBAAA;IACA,mBAAA;EtBgmLN;EsB7lLE;IACE,mBAAA;IACA,WAAA;IACA,sBAAA;IACA,oBAAA;IACA,SAAA;IACA,mBAAA;EtB+lLJ;EsB9lLI;IACE,YAAA;IACA,aAAA;EtBgmLN;AACF;AuBjtLA;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AvBktLF;AuBjtLE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,OAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AvBmtLJ;AuBjtLI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AvBmtLN;AuBhtLE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AvBktLJ;AuBjtLI;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,SAAA;AvBmtLN;AuBjtLQ;EACE,WAAA;EACA,sBAAA;EACA,2CAAA;EACA,gBAAA;AvBmtLV;AuBltLU;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AvBotLZ;AuBjtLQ;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AvBmtLV;AuBjtLU;EACE,aAAA;AvBmtLZ;AuBjtLU;EACE,aAAA;AvBmtLZ;AuB/sLM;EACE,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,yCAAA;EACA,4BAAA;EACA,oCAAA;EACA,2CAAA;EACA,aAAA;EACA,wBAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AvBitLR;AuB/sLQ;EACE,YAAA;EACA,aAAA;EACA,gBAAA;AvBitLV;AuB/sLU;EACE,WAAA;EACA,YAAA;AvBitLZ;AuB9sLQ;EACE,yBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AvBgtLV;AuB/sLU;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AvBitLZ;AuB/sLY;EACE,WAAA;EACA,aAAA;EACA,OAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AvBitLd;AuB7sLQ;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AvB+sLV;AuB9sLU;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;AvBgtLZ;AuB/sLY;EACE,oBAAA;AvBitLd;AuBhtLc;EACE,cAAA;AvBktLhB;AuB/sLY;EACE,WAAA;EACA,YAAA;AvBitLd;AuB/sLY;EACE,eAAA;EACA,wBAAA;AvBitLd;AuB5sLM;EACE,6BAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EACA,yCAAA;EACA,4BAAA;EACA,oCAAA;EACA,2CAAA;EACA,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AvB8sLR;AuB5sLQ;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AvB8sLV;AuB5sLQ;EACE,WAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;AvB8sLV;AuB7sLU;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AvB+sLZ;AuB5sLQ;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AvB8sLV;AuB1sLI;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AvB4sLN;AuB3sLM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AvB6sLR;AuB5sLQ;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AvB8sLV;AuB5sLQ;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AvB8sLV;AuB7sLU;EACE,UAAA;EACA,WAAA;EACA,mBAAA;AvB+sLZ;AuB3sLM;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AvB6sLR;AuB5sLQ;EACE,eAAA;EACA,oBAAA;AvB8sLV;AuB5sLQ;EACE,eAAA;EACA,gBAAA;AvB8sLV;AuB3sLM;EACE,qCAAA;EACA,mBAAA;EACA,yCAAA;EACA,4BAAA;EACA,oCAAA;EACA,2CAAA;AvB6sLR;;AuBvsLA;EACE;IACE,kBAAA;IACA,SAAA;EvB0sLF;EuBzsLE;IACE,gBAAA;IACA,aAAA;IACA,sBAAA;IACA,UAAA;IACA,8BAAA;IACA,SAAA;IACA,YAAA;EvB2sLJ;EuBzsLM;IACE,eAAA;IACA,iBAAA;EvB2sLR;EuBxsLI;IACE,WAAA;IACA,SAAA;IACA,WAAA;EvB0sLN;EuBzsLM;IACE,yBAAA;EvB2sLR;EuBxsLI;IACE,WAAA;IACA,WAAA;EvB0sLN;EuBzsLM;IACE,mBAAA;IACA,WAAA;IACA,qBAAA;IACA,yBAAA;EvB2sLR;EuB1sLQ;IACE,yBAAA;IACA,OAAA;IACA,YAAA;EvB4sLV;EuB3sLU;IACE,eAAA;EvB6sLZ;EuB3sLU;IACE,eAAA;EvB6sLZ;EuB1sLQ;IACE,YAAA;IACA,aAAA;EvB4sLV;AACF","sourcesContent":["/* Start Font Import */\n@font-face {\n  font-family: \"Somar\";\n  src: url(\"./fonts/SomarSans-Bold.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"Somar\";\n  src: url(\"./fonts/SomarSans-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n@font-face {\n  font-family: \"Somar\";\n  src: url(\"./fonts/SomarSans-SemiBold.ttf\") format(\"truetype\");\n  font-weight: 600;\n}\n/* End Font Import */\n\n/* Start Main Rules */\n\n:root {\n  --main-color: #f8b34f;\n  --dark-color: #1f2034;\n}\n\nhtml {\n  height: -webkit-fill-available;\n}\n\nbody[lang=\"ar\"] {\n  font-family: \"Somar\", sans-serif;\n  direction: rtl;\n  scroll-behavior: smooth;\n  margin: 0;\n  padding: 0;\n  background-color: #cfd3d6;\n  height: 100dvh;\n  width: 100%;\n  overflow-x: hidden;\n  input,\n  select,\n  textarea {\n    font-family: \"Somar\", sans-serif !important;\n  }\n  .Toastify * {\n    z-index: 5656565656;\n    font-family: \"Somar\", sans-serif !important;\n  }\n}\n\n/* End Main Rules */\n","/* Start Font Import */\n@font-face {\n  font-family: \"Somar\";\n  src: url(\"./fonts/SomarSans-Bold.ttf\") format(\"truetype\");\n  font-weight: bold;\n}\n@font-face {\n  font-family: \"Somar\";\n  src: url(\"./fonts/SomarSans-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n}\n@font-face {\n  font-family: \"Somar\";\n  src: url(\"./fonts/SomarSans-SemiBold.ttf\") format(\"truetype\");\n  font-weight: 600;\n}\n/* End Font Import */\n/* Start Main Rules */\n:root {\n  --main-color: #f8b34f;\n  --dark-color: #1f2034;\n}\n\nhtml {\n  height: -webkit-fill-available;\n}\n\nbody[lang=ar] {\n  font-family: \"Somar\", sans-serif;\n  direction: rtl;\n  scroll-behavior: smooth;\n  margin: 0;\n  padding: 0;\n  background-color: #cfd3d6;\n  height: 100dvh;\n  width: 100%;\n  overflow-x: hidden;\n}\nbody[lang=ar] input,\nbody[lang=ar] select,\nbody[lang=ar] textarea {\n  font-family: \"Somar\", sans-serif !important;\n}\nbody[lang=ar] .Toastify * {\n  z-index: 5656565656;\n  font-family: \"Somar\", sans-serif !important;\n}\n\n/* End Main Rules */\n.service-info {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 1;\n  left: 0;\n}\n.service-info .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n}\n.service-info .container {\n  width: 500px;\n  height: 700px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n.service-info .container .section {\n  position: relative;\n  overflow: hidden;\n  border-radius: 20px;\n}\n.service-info .container .section:hover .image img {\n  filter: grayscale(0%);\n  transition: 0.5s;\n}\n.service-info .container .section:hover .data {\n  left: 0;\n  opacity: 1;\n  transition: opacity 0.5s;\n}\n.service-info .container .section .data.active {\n  left: 0;\n  opacity: 1;\n  transition: opacity 0.5s;\n}\n.service-info .container .section .image.active img {\n  filter: grayscale(0%);\n  transition: 0.5s;\n}\n.service-info .container .section .image {\n  width: 100%;\n  height: 100%;\n  border-radius: 20px;\n  overflow: hidden;\n}\n.service-info .container .section .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: grayscale(100%);\n  transition: 0.5s;\n}\n.service-info .container .section .data {\n  position: absolute;\n  top: 0;\n  opacity: 0;\n  transition: opacity 0.5s;\n  height: calc(100% - 20px);\n  width: calc(100% - 20px);\n  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  align-items: center;\n  padding: 10px;\n  border-radius: 20px;\n  color: #fff;\n  left: -100%;\n}\n.service-info .container .section .data .title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  position: relative;\n}\n.service-info .container .section .data .title::before {\n  content: \"\";\n  width: 100%;\n  height: 1px;\n  background-color: #fff;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: -10px;\n}\n.service-info .container .section .data .desc {\n  font-size: 14px;\n  text-align: center;\n}\n\n.image-info {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n}\n.image-info .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n}\n.image-info .container {\n  width: 90%;\n  height: 70%;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n.image-info .container .section {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  border-radius: 20px;\n}\n.image-info .container .section:hover .image img {\n  filter: grayscale(0%);\n  transition: 0.5s;\n}\n.image-info .container .section:hover .data {\n  left: 0;\n  opacity: 1;\n  transition: opacity 0.5s;\n}\n.image-info .container .section .image {\n  width: 100%;\n  height: 100%;\n  border-radius: 20px;\n  overflow: hidden;\n}\n.image-info .container .section .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: grayscale(100%);\n  transition: 0.5s;\n}\n.image-info .container .section .data {\n  position: absolute;\n  top: 0;\n  opacity: 0;\n  transition: opacity 0.5s;\n  height: calc(100% - 20px);\n  width: calc(100% - 20px);\n  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  align-items: start;\n  padding: 10px;\n  border-radius: 20px;\n  color: #fff;\n  left: -100%;\n}\n.image-info .container .section .data .title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  position: relative;\n  margin-right: 30px;\n}\n\n.video-info {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n}\n.video-info .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n}\n.video-info .container {\n  width: 90%;\n  height: 70%;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n.video-info .container .section {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  border-radius: 20px;\n}\n.video-info .container .section:hover .image img {\n  filter: grayscale(0%);\n  transition: 0.5s;\n}\n.video-info .container .section:hover .data {\n  left: 0;\n  opacity: 1;\n  transition: opacity 0.5s;\n}\n.video-info .container .section .image {\n  width: 100%;\n  height: 100%;\n  border-radius: 20px;\n  overflow: hidden;\n}\n.video-info .container .section .image video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: 0.5s;\n}\n.video-info .container .section .data {\n  position: absolute;\n  top: 0;\n  opacity: 0;\n  transition: opacity 0.5s;\n  height: calc(100% - 20px);\n  width: calc(100% - 20px);\n  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  align-items: start;\n  padding: 10px;\n  border-radius: 20px;\n  color: #fff;\n  left: -100%;\n}\n.video-info .container .section .data .title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  position: relative;\n  margin-right: 30px;\n}\n\n.cases-info {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n}\n.cases-info .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n}\n.cases-info .container {\n  width: 90%;\n  max-width: 600px;\n  height: 85%;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  max-height: 85%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  flex-direction: column;\n  background-color: #f6f1ea;\n  border-radius: 20px;\n}\n.cases-info .container .image {\n  width: 90%;\n  height: 220px !important;\n  border-radius: 20px;\n  position: relative;\n  overflow: hidden;\n  margin: 20px auto 0;\n}\n.cases-info .container .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: 0.5s;\n}\n.cases-info .container .image .title {\n  position: absolute;\n  left: 0;\n  top: 0;\n  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);\n  color: #fff;\n  font-weight: bold;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: end;\n  padding-bottom: 10px;\n}\n.cases-info .container .texts {\n  height: calc(100% - 260px);\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  margin: 20px auto 0;\n  padding-bottom: 20px;\n  width: calc(100% - 60px);\n  gap: 10px;\n}\n.cases-info .container .texts .text {\n  width: 100%;\n  color: #413634;\n  font-size: 12px;\n  font-weight: bold;\n  position: relative;\n  padding-right: 30px;\n  width: calc(100% - 29px);\n}\n.cases-info .container .texts .text::before {\n  content: url(\"./info.svg\");\n  position: absolute;\n  top: 13px;\n  right: 0;\n  transform: translateY(-50%);\n  width: 18px; /* Width of your SVG */\n  height: 18px; /* Height of your SVG */\n}\n\n@media (max-width: 768px) {\n  .service-info .container {\n    width: 300px;\n    height: 500px;\n  }\n}\n.header {\n  width: 100%;\n  height: 60px;\n  background-color: #413634;\n  position: fixed;\n  z-index: 6666;\n  top: 0;\n  left: 0;\n  color: #c7c7c7;\n  display: flex;\n  justify-content: space-evenly;\n  gap: 10px;\n}\n.header .link {\n  width: max-content;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  color: #c7c7c7;\n  align-items: center;\n  text-decoration: none;\n  font-size: 18px;\n  transition: 0.5s;\n}\n.header .link.active, .header .link:hover {\n  transition: 0.5s;\n  color: #fff;\n}\n\n@media (max-width: 768px) {\n  .header {\n    width: 100%;\n  }\n  .header .link {\n    font-size: 12px;\n  }\n}\n.footer {\n  width: 100%;\n  height: 400px;\n  background-color: #413634;\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n}\n.footer .head-title {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  font-size: 18px;\n  font-weight: bold;\n  margin: 10px 0;\n  color: #fff;\n}\n.footer .container {\n  width: 100%;\n  height: calc(100% - 60px);\n  display: flex;\n  justify-content: space-between;\n}\n.footer .container .group {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 30%;\n  height: 100%;\n  align-items: center;\n  gap: 20px;\n  position: relative;\n}\n.footer .container .group:not(:last-of-type)::after {\n  content: \"\";\n  left: -20px;\n  position: absolute;\n  top: 50%;\n  border-radius: 10px;\n  width: 2px;\n  height: 80%;\n  background-color: #707070;\n  transform: translateY(-50%);\n  transition: 0.1s;\n}\n.footer .container .group .logo {\n  width: 150px;\n  height: 150px;\n}\n.footer .container .group .logo img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.footer .container .group .grouping {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n.footer .container .group .grouping .title {\n  font-size: 32px;\n  font-weight: bold;\n}\n.footer .container .group .grouping .name {\n  font-size: 22px;\n  font-weight: 600;\n}\n.footer .container .group .section {\n  width: 100%;\n  display: flex;\n  gap: 10px;\n  height: max-content;\n  justify-content: space-between;\n  align-items: center;\n}\n.footer .container .group .section .icon {\n  height: 30px;\n  width: 30px;\n}\n.footer .container .group .section .section-grouping {\n  display: flex;\n  flex-direction: column;\n  color: #fff;\n  height: 100%;\n  width: calc(98% - 40px);\n}\n.footer .container .group .section .section-grouping .value {\n  font-weight: bold;\n  font-size: 12px;\n}\n.footer .container .group .copyright {\n  width: 105%;\n  height: 60px;\n  background-color: #fff;\n  border: 1px solid #000;\n  position: relative;\n  left: -15%;\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  direction: ltr;\n  gap: 20px;\n}\n.footer .container .group .copyright .grouping2 {\n  display: flex;\n  flex-direction: column;\n}\n.footer .container .group .copyright .title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.footer .container .group .copyright .value {\n  font-weight: bold;\n}\n\n@media (max-width: 768px) {\n  .footer .container .group {\n    gap: 40px;\n    padding: 0 10px;\n    width: calc(100% - 20px);\n  }\n  .footer .container .group:first-of-type {\n    display: none;\n  }\n  .footer .container .group:last-of-type {\n    display: none;\n  }\n}\n.certificate-add-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 88888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n}\n.certificate-add-action .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n  left: 0;\n  top: 0;\n}\n.certificate-add-action .container {\n  width: 90%;\n  max-width: 600px;\n  height: max-content !important;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  flex-direction: column;\n  background-color: #f6f1ea;\n  border-radius: 20px;\n  justify-content: center;\n  align-items: center;\n}\n.certificate-add-action .container .title {\n  font-size: 24px;\n  font-weight: bold;\n}\n.certificate-add-action .container .image {\n  width: 90%;\n  height: 320px;\n  border-radius: 20px;\n  position: relative;\n  overflow: hidden;\n  margin: 20px auto 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.certificate-add-action .container .image.none {\n  width: 100px;\n  height: 100px;\n  cursor: pointer;\n}\n.certificate-add-action .container .image.none img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: 0.5s;\n}\n.certificate-add-action .container .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  transition: 0.5s;\n}\n.certificate-add-action .container .image .title {\n  position: absolute;\n  left: 0;\n  top: 0;\n  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);\n  color: #fff;\n  font-weight: bold;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: end;\n  padding-bottom: 10px;\n}\n.certificate-add-action .container .text {\n  width: 95%;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  margin: 10px 0;\n  padding-bottom: 10px;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n}\n.certificate-add-action .container .text input {\n  width: 90%;\n  color: #413634;\n  font-size: 15px;\n  height: 40px;\n  border-radius: 10px;\n  outline: none;\n  border: 1px solid #413634;\n  font-weight: bold;\n  position: relative;\n  padding-right: 30px;\n}\n.certificate-add-action .container .add-btn {\n  width: 90%;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-weight: bold;\n  cursor: pointer;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  background-color: #2ecc71;\n}\n\n.direction-add-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 88888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n}\n.direction-add-action .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n  left: 0;\n  top: 0;\n}\n.direction-add-action .container {\n  width: 90%;\n  max-width: 600px;\n  height: max-content !important;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  flex-direction: column;\n  background-color: #f6f1ea;\n  border-radius: 20px;\n  justify-content: center;\n  align-items: center;\n}\n.direction-add-action .container .title {\n  font-size: 24px;\n  font-weight: bold;\n}\n.direction-add-action .container .group {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  height: 320px;\n  margin-bottom: 20px;\n}\n.direction-add-action .container .group .image {\n  width: 48%;\n  min-height: 320px;\n  border-radius: 20px;\n  position: relative;\n  overflow: hidden;\n  margin: 20px auto 0;\n  display: flex;\n  align-items: center;\n  gap: 50px;\n  flex-direction: column;\n}\n.direction-add-action .container .group .image label {\n  width: 100%;\n  height: 320px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n}\n.direction-add-action .container .group .image label img {\n  width: 270px;\n  height: 270px;\n  object-fit: contain;\n  transition: 0.5s;\n}\n.direction-add-action .container .group .image label img.none {\n  width: 120px;\n  height: 120px;\n  object-fit: contain;\n}\n.direction-add-action .container .group .image label .title {\n  position: relative;\n  left: 0;\n  top: 0;\n  color: #000;\n  font-weight: bold;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: end;\n}\n.direction-add-action .container .text {\n  width: 95%;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  margin: 10px 0;\n  padding-bottom: 10px;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n}\n.direction-add-action .container .text input,\n.direction-add-action .container .text textarea {\n  resize: none;\n  width: 90%;\n  color: #413634;\n  font-size: 15px;\n  height: 40px;\n  border-radius: 10px;\n  outline: none;\n  border: 1px solid #413634;\n  font-weight: bold;\n  position: relative;\n  padding-right: 30px;\n}\n.direction-add-action .container .text textarea {\n  height: 150px;\n}\n.direction-add-action .container .add-btn {\n  width: 90%;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-weight: bold;\n  cursor: pointer;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  background-color: #2ecc71;\n}\n\n.direction-edit-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 88888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n}\n.direction-edit-action .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n  left: 0;\n  top: 0;\n}\n.direction-edit-action .container {\n  width: 90%;\n  max-width: 600px;\n  height: max-content !important;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  flex-direction: column;\n  background-color: #f6f1ea;\n  border-radius: 20px;\n  justify-content: center;\n  align-items: center;\n}\n.direction-edit-action .container .title {\n  font-size: 24px;\n  font-weight: bold;\n}\n.direction-edit-action .container .group {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  height: 320px;\n  margin-bottom: 20px;\n}\n.direction-edit-action .container .group .image {\n  width: 48%;\n  min-height: 320px;\n  border-radius: 20px;\n  position: relative;\n  overflow: hidden;\n  margin: 20px auto 0;\n  display: flex;\n  align-items: center;\n  gap: 50px;\n  flex-direction: column;\n}\n.direction-edit-action .container .group .image label {\n  width: 100%;\n  height: 320px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n}\n.direction-edit-action .container .group .image label img {\n  width: 270px;\n  height: 270px;\n  object-fit: contain;\n  transition: 0.5s;\n}\n.direction-edit-action .container .group .image label img.none {\n  width: 120px;\n  height: 120px;\n  object-fit: contain;\n}\n.direction-edit-action .container .group .image label .title {\n  position: relative;\n  left: 0;\n  top: 0;\n  color: #000;\n  font-weight: bold;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: end;\n}\n.direction-edit-action .container .text {\n  width: 95%;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  margin: 10px 0;\n  padding-bottom: 10px;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n}\n.direction-edit-action .container .text input,\n.direction-edit-action .container .text textarea {\n  resize: none;\n  width: 90%;\n  color: #413634;\n  font-size: 15px;\n  height: 40px;\n  border-radius: 10px;\n  outline: none;\n  border: 1px solid #413634;\n  font-weight: bold;\n  position: relative;\n  padding-right: 30px;\n}\n.direction-edit-action .container .text textarea {\n  height: 150px;\n}\n.direction-edit-action .container .add-btn {\n  width: 90%;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-weight: bold;\n  cursor: pointer;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  background-color: #2ecc71;\n}\n\n.service-add-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 88888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n}\n.service-add-action .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n  left: 0;\n  top: 0;\n}\n.service-add-action .container {\n  width: 90%;\n  max-width: 600px;\n  height: max-content !important;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  flex-direction: column;\n  background-color: #f6f1ea;\n  border-radius: 20px;\n  justify-content: center;\n  align-items: center;\n}\n.service-add-action .container .title {\n  font-size: 24px;\n  font-weight: bold;\n}\n.service-add-action .container .text {\n  width: 95%;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  margin: 10px 0;\n  padding-bottom: 10px;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n}\n.service-add-action .container .text input,\n.service-add-action .container .text textarea {\n  resize: none;\n  width: 90%;\n  color: #413634;\n  font-size: 15px;\n  height: 40px;\n  border-radius: 10px;\n  outline: none;\n  border: 1px solid #413634;\n  font-weight: bold;\n  position: relative;\n  padding-right: 30px;\n}\n.service-add-action .container .text textarea {\n  height: 150px;\n}\n.service-add-action .container .add-btn {\n  width: 90%;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-weight: bold;\n  cursor: pointer;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  background-color: #2ecc71;\n}\n\n.service-edit-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 88888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n}\n.service-edit-action .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n  left: 0;\n  top: 0;\n}\n.service-edit-action .container {\n  width: 90%;\n  max-width: 600px;\n  height: max-content !important;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  flex-direction: column;\n  background-color: #f6f1ea;\n  border-radius: 20px;\n  justify-content: center;\n  align-items: center;\n}\n.service-edit-action .container .title {\n  font-size: 24px;\n  font-weight: bold;\n}\n.service-edit-action .container .text {\n  width: 95%;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  margin: 10px 0;\n  padding-bottom: 10px;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n}\n.service-edit-action .container .text input,\n.service-edit-action .container .text textarea {\n  resize: none;\n  width: 90%;\n  color: #413634;\n  font-size: 15px;\n  height: 40px;\n  border-radius: 10px;\n  outline: none;\n  border: 1px solid #413634;\n  font-weight: bold;\n  position: relative;\n  padding-right: 30px;\n}\n.service-edit-action .container .text textarea {\n  height: 150px;\n}\n.service-edit-action .container .add-btn {\n  width: 90%;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-weight: bold;\n  cursor: pointer;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  background-color: #2ecc71;\n}\n\n.service-info-admin {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 1;\n  left: 0;\n}\n.service-info-admin .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n}\n.service-info-admin .add-icon {\n  position: fixed;\n  top: 7%;\n  left: 31%;\n  background-color: rgb(255, 255, 255);\n  z-index: 8899;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: -11px;\n}\n.service-info-admin .add-icon:hover .img {\n  transition: 0.5s;\n  opacity: 1;\n}\n.service-info-admin .container {\n  width: 500px;\n  height: 700px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n.service-info-admin .container .section {\n  position: relative;\n  overflow: hidden;\n  border-radius: 20px;\n}\n.service-info-admin .container .section:hover .image img {\n  filter: grayscale(0%);\n  transition: 0.5s;\n}\n.service-info-admin .container .section:hover .data {\n  left: 0;\n  opacity: 1;\n  transition: opacity 0.5s;\n}\n.service-info-admin .container .section .data.active {\n  left: 0;\n  opacity: 1;\n  transition: opacity 0.5s;\n}\n.service-info-admin .container .section .image.active img {\n  filter: grayscale(0%);\n  transition: 0.5s;\n}\n.service-info-admin .container .section .image {\n  width: 100%;\n  height: 100%;\n  border-radius: 20px;\n  overflow: hidden;\n}\n.service-info-admin .container .section .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: grayscale(100%);\n  transition: 0.5s;\n}\n.service-info-admin .container .section .data {\n  position: absolute;\n  top: 0;\n  opacity: 0;\n  transition: opacity 0.5s;\n  height: calc(100% - 20px);\n  width: calc(100% - 20px);\n  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  align-items: center;\n  padding: 10px;\n  border-radius: 20px;\n  color: #fff;\n  left: -100%;\n}\n.service-info-admin .container .section .data .title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  position: relative;\n}\n.service-info-admin .container .section .data .title::before {\n  content: \"\";\n  width: 100%;\n  height: 1px;\n  background-color: #fff;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: -10px;\n}\n.service-info-admin .container .section .data .desc {\n  font-size: 14px;\n  text-align: center;\n}\n.service-info-admin .container .del-icon {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: #d0d0d0;\n  z-index: 2;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: 10px 0 0 0;\n}\n.service-info-admin .container .edit-icon,\n.service-info-admin .container .save-icon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #d0d0d0;\n  z-index: 2;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: 10px 0 0 0;\n}\n\n.service-images-add-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 1;\n  left: 0;\n}\n.service-images-add-action .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n}\n.service-images-add-action .add-icon {\n  position: absolute;\n  top: 0%;\n  left: 0;\n  background-color: rgb(255, 255, 255);\n  z-index: 8899;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: -11px;\n}\n.service-images-add-action .add-icon:hover .img {\n  transition: 0.5s;\n  opacity: 1;\n}\n.service-images-add-action .container {\n  width: 90%;\n  max-width: 600px;\n  height: max-content !important;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  flex-direction: column;\n  background-color: #f6f1ea;\n  border-radius: 20px;\n  justify-content: center;\n  align-items: center;\n}\n.service-images-add-action .container .title {\n  font-size: 24px;\n  font-weight: bold;\n}\n.service-images-add-action .container .image {\n  width: 90%;\n  height: 320px;\n  border-radius: 20px;\n  position: relative;\n  overflow: hidden;\n  margin: 20px auto 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.service-images-add-action .container .image.none {\n  width: 100px;\n  height: 100px;\n  cursor: pointer;\n}\n.service-images-add-action .container .image.none img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: 0.5s;\n}\n.service-images-add-action .container .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  transition: 0.5s;\n}\n.service-images-add-action .container .image .title {\n  position: absolute;\n  left: 0;\n  top: 0;\n  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);\n  color: #fff;\n  font-weight: bold;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: end;\n  padding-bottom: 10px;\n}\n.service-images-add-action .container .text {\n  width: 95%;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  margin: 10px 0;\n  padding-bottom: 10px;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n}\n.service-images-add-action .container .text textarea {\n  width: 90%;\n  color: #413634;\n  font-size: 15px;\n  height: 200px;\n  border-radius: 10px;\n  outline: none;\n  border: 1px solid #413634;\n  font-weight: bold;\n  position: relative;\n  padding-right: 30px;\n  resize: none;\n}\n.service-images-add-action .container .add-btn {\n  width: 90%;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-weight: bold;\n  cursor: pointer;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  background-color: #2ecc71;\n}\n\n.service-images-edit-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 1;\n  left: 0;\n}\n.service-images-edit-action .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n}\n.service-images-edit-action .add-icon {\n  position: absolute;\n  top: 0%;\n  left: 0;\n  background-color: rgb(255, 255, 255);\n  z-index: 8899;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: -11px;\n}\n.service-images-edit-action .add-icon:hover .img {\n  transition: 0.5s;\n  opacity: 1;\n}\n.service-images-edit-action .container {\n  width: 90%;\n  max-width: 600px;\n  height: max-content !important;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  flex-direction: column;\n  background-color: #f6f1ea;\n  border-radius: 20px;\n  justify-content: center;\n  align-items: center;\n}\n.service-images-edit-action .container .title {\n  font-size: 24px;\n  font-weight: bold;\n}\n.service-images-edit-action .container .image {\n  width: 90%;\n  height: 320px;\n  border-radius: 20px;\n  position: relative;\n  overflow: hidden;\n  margin: 20px auto 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.service-images-edit-action .container .image.none {\n  width: 100px;\n  height: 100px;\n  cursor: pointer;\n}\n.service-images-edit-action .container .image.none img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: 0.5s;\n}\n.service-images-edit-action .container .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  transition: 0.5s;\n}\n.service-images-edit-action .container .image .title {\n  position: absolute;\n  left: 0;\n  top: 0;\n  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);\n  color: #fff;\n  font-weight: bold;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: end;\n  padding-bottom: 10px;\n}\n.service-images-edit-action .container .text {\n  width: 95%;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  margin: 10px 0;\n  padding-bottom: 10px;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n}\n.service-images-edit-action .container .text textarea {\n  width: 90%;\n  color: #413634;\n  font-size: 15px;\n  height: 200px;\n  border-radius: 10px;\n  outline: none;\n  border: 1px solid #413634;\n  font-weight: bold;\n  position: relative;\n  padding-right: 30px;\n  resize: none;\n}\n.service-images-edit-action .container .add-btn {\n  width: 90%;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-weight: bold;\n  cursor: pointer;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  background-color: #2ecc71;\n}\n\n.image-info-admin {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n}\n.image-info-admin .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n}\n.image-info-admin .add-icon {\n  position: absolute;\n  top: 5%;\n  left: 5%;\n  background-color: rgb(255, 255, 255);\n  z-index: 8899;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: -11px;\n}\n.image-info-admin .add-icon:hover .img {\n  transition: 0.5s;\n  opacity: 1;\n}\n.image-info-admin .container {\n  width: 90%;\n  height: 70%;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n.image-info-admin .container .section {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  border-radius: 20px;\n}\n.image-info-admin .container .section:hover .image img {\n  filter: grayscale(0%);\n  transition: 0.5s;\n}\n.image-info-admin .container .section:hover .data {\n  left: 0;\n  opacity: 1;\n  transition: opacity 0.5s;\n}\n.image-info-admin .container .section .del-icon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #d0d0d0;\n  z-index: 2;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: 10px 0 0 0;\n}\n.image-info-admin .container .section .image {\n  width: 100%;\n  height: 100%;\n  border-radius: 20px;\n  overflow: hidden;\n}\n.image-info-admin .container .section .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: grayscale(100%);\n  transition: 0.5s;\n}\n.image-info-admin .container .section .data {\n  position: absolute;\n  top: 0;\n  opacity: 0;\n  transition: opacity 0.5s;\n  height: calc(100% - 20px);\n  width: calc(100% - 20px);\n  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  align-items: start;\n  padding: 10px;\n  border-radius: 20px;\n  color: #fff;\n  left: -100%;\n}\n.image-info-admin .container .section .data .title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  position: relative;\n  margin-right: 30px;\n}\n\n.images-add-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 1;\n  left: 0;\n}\n.images-add-action .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n}\n.images-add-action .add-icon {\n  position: absolute;\n  top: 0%;\n  left: 0;\n  background-color: rgb(255, 255, 255);\n  z-index: 8899;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: -11px;\n}\n.images-add-action .add-icon:hover .img {\n  transition: 0.5s;\n  opacity: 1;\n}\n.images-add-action .container {\n  width: 90%;\n  max-width: 600px;\n  height: max-content !important;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  flex-direction: column;\n  background-color: #f6f1ea;\n  border-radius: 20px;\n  justify-content: center;\n  align-items: center;\n}\n.images-add-action .container .title {\n  font-size: 24px;\n  font-weight: bold;\n}\n.images-add-action .container .image {\n  width: 90%;\n  height: 320px;\n  border-radius: 20px;\n  position: relative;\n  overflow: hidden;\n  margin: 20px auto 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.images-add-action .container .image.none {\n  width: 100px;\n  height: 100px;\n  cursor: pointer;\n}\n.images-add-action .container .image.none img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: 0.5s;\n}\n.images-add-action .container .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  transition: 0.5s;\n}\n.images-add-action .container .image .title {\n  position: absolute;\n  left: 0;\n  top: 0;\n  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);\n  color: #fff;\n  font-weight: bold;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: end;\n  padding-bottom: 10px;\n}\n.images-add-action .container .text {\n  width: 95%;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  margin: 10px 0;\n  padding-bottom: 10px;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n}\n.images-add-action .container .text input {\n  width: 90%;\n  color: #413634;\n  font-size: 15px;\n  height: 50px;\n  border-radius: 10px;\n  outline: none;\n  border: 1px solid #413634;\n  font-weight: bold;\n  position: relative;\n  padding-right: 30px;\n  resize: none;\n}\n.images-add-action .container .add-btn {\n  width: 90%;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-weight: bold;\n  cursor: pointer;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  background-color: #2ecc71;\n}\n\n.video-info-admin {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n}\n.video-info-admin .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n}\n.video-info-admin .add-icon {\n  position: absolute;\n  top: 5%;\n  left: 5%;\n  background-color: rgb(255, 255, 255);\n  z-index: 8899;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: -11px;\n}\n.video-info-admin .add-icon:hover .img {\n  transition: 0.5s;\n  opacity: 1;\n}\n.video-info-admin .container {\n  width: 90%;\n  height: 70%;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n.video-info-admin .container .section {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  border-radius: 20px;\n}\n.video-info-admin .container .section:hover .image img {\n  filter: grayscale(0%);\n  transition: 0.5s;\n}\n.video-info-admin .container .section:hover .data {\n  left: 0;\n  opacity: 1;\n  transition: opacity 0.5s;\n}\n.video-info-admin .container .section .del-icon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #d0d0d0;\n  z-index: 2;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: 10px 0 0 0;\n}\n.video-info-admin .container .section .image {\n  width: 100%;\n  height: 100%;\n  border-radius: 20px;\n  overflow: hidden;\n}\n.video-info-admin .container .section .image img,\n.video-info-admin .container .section .image video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: grayscale(100%);\n  transition: 0.5s;\n}\n.video-info-admin .container .section .data {\n  position: absolute;\n  top: 0;\n  opacity: 0;\n  transition: opacity 0.5s;\n  height: calc(100% - 20px);\n  width: calc(100% - 20px);\n  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  align-items: start;\n  padding: 10px;\n  border-radius: 20px;\n  color: #fff;\n  left: -100%;\n}\n.video-info-admin .container .section .data .title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  position: relative;\n  margin-right: 30px;\n}\n\n.video-add-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 1;\n  left: 0;\n}\n.video-add-action .content-layout {\n  height: 100%;\n  width: 100%;\n  background-color: #413634;\n  opacity: 0.67;\n  z-index: 8889;\n}\n.video-add-action .add-icon {\n  position: absolute;\n  top: 0%;\n  left: 0;\n  background-color: rgb(255, 255, 255);\n  z-index: 8899;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: -11px;\n}\n.video-add-action .add-icon:hover .img {\n  transition: 0.5s;\n  opacity: 1;\n}\n.video-add-action .container {\n  width: 90%;\n  max-width: 600px;\n  height: max-content !important;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 8899;\n  display: flex;\n  flex-direction: column;\n  background-color: #f6f1ea;\n  border-radius: 20px;\n  justify-content: center;\n  align-items: center;\n}\n.video-add-action .container .title {\n  font-size: 24px;\n  font-weight: bold;\n}\n.video-add-action .container .image {\n  width: 90%;\n  height: 320px;\n  border-radius: 20px;\n  position: relative;\n  overflow: hidden;\n  margin: 20px auto 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.video-add-action .container .image.none {\n  width: 100px;\n  height: 100px;\n  cursor: pointer;\n}\n.video-add-action .container .image.none img,\n.video-add-action .container .image.none video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: 0.5s;\n}\n.video-add-action .container .image img,\n.video-add-action .container .image video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  transition: 0.5s;\n}\n.video-add-action .container .image .title {\n  position: absolute;\n  left: 0;\n  top: 0;\n  background: linear-gradient(rgba(0, 0, 0, 0) 50%, #413634 98%);\n  color: #fff;\n  font-weight: bold;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: end;\n  padding-bottom: 10px;\n}\n.video-add-action .container .text {\n  width: 95%;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  margin: 10px 0;\n  padding-bottom: 10px;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n}\n.video-add-action .container .text input {\n  width: 90%;\n  color: #413634;\n  font-size: 15px;\n  height: 50px;\n  border-radius: 10px;\n  outline: none;\n  border: 1px solid #413634;\n  font-weight: bold;\n  position: relative;\n  padding-right: 30px;\n  resize: none;\n}\n.video-add-action .container .add-btn {\n  width: 90%;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-weight: bold;\n  cursor: pointer;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  background-color: #2ecc71;\n}\n\n.home {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 100dvh;\n  height: 100%;\n  padding-top: 50px;\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n.home .landing-home {\n  width: 100%;\n  height: 600px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 10px;\n  padding-top: 50px;\n}\n.home .landing-home.activeAnm .data .data-background img {\n  transition: 1s;\n  transform: scale(1.1);\n}\n.home .landing-home.activeAnm .data .back-box {\n  top: -20px;\n  transition: 1s;\n}\n.home .landing-home.activeAnm .data .content .logo {\n  margin-bottom: 0;\n  margin-right: 30px;\n}\n.home .landing-home.activeAnm .data .content .grouping {\n  transition: 1s;\n  top: -31px;\n}\n.home .landing-home.activeAnm .effects {\n  width: 450px;\n  transition: 1s;\n}\n.home .landing-home.activeAnm .about-clinic span {\n  width: 250px;\n  transition: 1s;\n}\n.home .landing-home.activeAnm .about-clinic .arrow {\n  opacity: 1;\n}\n.home .landing-home.activeAnm .about-clinic .arrow #Path_7 {\n  animation: dashrev 2s linear forwards;\n}\n.home .landing-home.activeAnm .about-clinic .arrow #Path_8 {\n  opacity: 1;\n  transition: 4s;\n}\n.home .landing-home .background {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0.1;\n  background: #fdf8f2;\n}\n.home .landing-home .background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.home .landing-home .data {\n  position: relative;\n  width: 80%;\n  height: 80%;\n  background: #413634;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  gap: 21px;\n  position: relative;\n}\n.home .landing-home .data .data-background {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0.3;\n  background: #413634;\n  border-radius: 10px;\n  z-index: 1;\n  overflow: hidden;\n}\n.home .landing-home .data .data-background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n  transition: 1s;\n}\n.home .landing-home .data .back-box {\n  position: absolute;\n  top: -40px;\n  width: 90%;\n  height: 90%;\n  left: 50%;\n  transform: translateX(-50%);\n  transition: 1s;\n  background-color: #413634;\n}\n.home .landing-home .data .content {\n  width: 100%;\n  height: 64%;\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 24px;\n}\n.home .landing-home .data .content .logo {\n  width: 300px;\n  height: 300px;\n  margin-right: 60px;\n  margin-bottom: 20px;\n  transition: 1s;\n}\n.home .landing-home .data .content .logo img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.home .landing-home .data .content .grouping {\n  font-size: 35px;\n  color: #fff;\n  position: relative;\n  top: 50px;\n  transition: 1s;\n}\n.home .landing-home .data .content .grouping .title {\n  font-weight: bold;\n  font-size: 50px;\n}\n.home .landing-home .effects {\n  position: absolute;\n  left: 0;\n  bottom: 112px;\n  z-index: 2;\n  width: 350px;\n  height: 100px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  transition: 1s;\n}\n.home .landing-home .effects .effect {\n  height: 20px;\n  width: 100%;\n  background-color: #fcf2ec;\n  position: relative;\n  left: 0;\n}\n.home .landing-home .effects .effect.one {\n  width: 70%;\n  left: -30%;\n}\n.home .landing-home .effects .effect.two {\n  width: 90%;\n  left: -10%;\n}\n.home .landing-home .effects .effect.three {\n  width: 100%;\n}\n.home .landing-home .about-clinic {\n  width: 75%;\n  height: 60px;\n  z-index: 2;\n  position: relative;\n  margin-top: 10px;\n  cursor: pointer;\n}\n.home .landing-home .about-clinic a {\n  background-color: #413634;\n  border-radius: 30px;\n  color: #fff;\n  font-weight: bold;\n  height: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 200px;\n  transition: 1s;\n  text-decoration: none;\n  color: #fff;\n}\n.home .landing-home .about-clinic .arrow {\n  position: absolute;\n  top: 50%;\n  right: 270px;\n  opacity: 0;\n  transition: 1s;\n}\n.home .landing-home .about-clinic .arrow #Path_7 {\n  stroke-dasharray: 10;\n  stroke-dashoffset: 0;\n}\n@keyframes dashrev {\n  0% {\n    stroke-dashoffset: 0;\n  }\n  100% {\n    stroke-dashoffset: -80;\n  }\n}\n.home .landing-home .about-clinic .arrow #Path_8 {\n  opacity: 0;\n}\n@media (max-width: 768px) {\n  .home .landing-home {\n    height: 400px;\n  }\n  .home .landing-home .content {\n    width: 100%;\n    height: 92%;\n    position: relative;\n    z-index: 2;\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    align-items: center;\n    flex-direction: column;\n  }\n  .home .landing-home .content .logo {\n    width: 115px !important;\n    height: 115px !important;\n    margin-left: 30px;\n    margin-bottom: 10px;\n  }\n  .home .landing-home .content .grouping {\n    font-size: 20px !important;\n    top: 0 !important;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n  .home .landing-home .content .grouping .title {\n    font-weight: bold;\n    font-size: 32px !important;\n  }\n  .home .landing-home .about-clinic .arrow {\n    width: 111px;\n    height: 124px;\n    position: relative;\n    right: 196px;\n    opacity: 1;\n    top: -55px;\n    transform: rotate(320deg);\n  }\n  .home .landing-home .about-clinic svg {\n    width: 100%;\n    height: 100%;\n  }\n  .home .landing-home.activeAnm .effects {\n    display: none !important;\n  }\n  .home .landing-home .effects {\n    bottom: 80px !important;\n    width: 100px !important;\n  }\n}\n.home .about-clinic-home {\n  width: calc(100% - 60px);\n  padding: 0 30px;\n  height: 800px;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  flex-direction: column;\n  overflow: hidden;\n}\n.home .about-clinic-home .container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  height: 100%;\n}\n.home .about-clinic-home .container .right,\n.home .about-clinic-home .container .left {\n  width: 48%;\n  height: calc(100% - 100px);\n}\n.home .about-clinic-home .head-title {\n  font-size: 50px;\n  font-weight: bold;\n  width: max-content;\n  position: relative;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.home .about-clinic-home .head-title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n}\n.home .about-clinic-home .head-title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 117%;\n  z-index: 1;\n  background-color: #ffdead;\n  transform: translateX(-50%);\n}\n.home .about-clinic-home .right {\n  display: flex;\n  flex-direction: column;\n}\n.home .about-clinic-home .right .text {\n  width: 100%;\n  height: 100%;\n  line-height: 2.5;\n  font-size: 20px;\n  font-weight: 600;\n  color: #525252;\n  position: relative;\n}\n.home .about-clinic-home .right .bottom {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n.home .about-clinic-home .right .bottom .one {\n  width: 80px;\n  height: 4px;\n  background-color: #413634;\n  border-radius: 10px;\n}\n.home .about-clinic-home .right .bottom .two {\n  width: 20px;\n  height: 4px;\n  background-color: #413634;\n  border-radius: 10px;\n}\n.home .about-clinic-home .left {\n  position: relative;\n}\n.home .about-clinic-home .left .images {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.home .about-clinic-home .left .images .image {\n  width: 45%;\n  height: 55%;\n  border-radius: 30px;\n  position: absolute;\n}\n.home .about-clinic-home .left .images .image.one {\n  top: 35%;\n  left: 44%;\n  z-index: 2;\n  animation: dream 2s infinite alternate; /* Key part */\n}\n.home .about-clinic-home .left .images .image.two {\n  bottom: 45%;\n  right: 44%;\n  z-index: 1;\n  animation: dream2 2s infinite alternate; /* Key part */\n}\n.home .about-clinic-home .left .images .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 30px;\n}\n.home .about-clinic-home .left .effects {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  bottom: 0;\n}\n.home .about-clinic-home .left .effects .effect {\n  border-radius: 50%;\n  background-color: #413634;\n  position: absolute;\n}\n.home .about-clinic-home .left .effects .effect.one {\n  width: 450px;\n  height: 450px;\n  left: -17%;\n  bottom: -15%;\n}\n.home .about-clinic-home .left .effects .effect.two {\n  width: 100px;\n  height: 100px;\n  top: 29%;\n  right: 0%;\n}\n.home .about-clinic-home .left .effects .effect.thee {\n  top: 22%;\n  right: 15%;\n  width: 40px;\n  height: 40px;\n}\n@keyframes dream {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(20px);\n  }\n}\n@keyframes dream2 {\n  0% {\n    transform: translateY(20px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n@media (max-width: 768px) {\n  .home .about-clinic-home {\n    flex-direction: column;\n    height: max-content;\n    width: calc(100% - 60px);\n    padding-bottom: 0;\n  }\n  .home .about-clinic-home .head-title {\n    margin: 0 auto;\n    margin-top: 30px;\n  }\n  .home .about-clinic-home .container {\n    flex-direction: column-reverse;\n  }\n  .home .about-clinic-home .container .right,\n  .home .about-clinic-home .container .left {\n    width: 100%;\n    height: max-content;\n  }\n  .home .about-clinic-home .right {\n    margin-bottom: 0;\n  }\n  .home .about-clinic-home .right .text {\n    line-height: 2.3;\n    font-size: 16px;\n  }\n  .home .about-clinic-home .left {\n    height: 500px !important;\n    margin-bottom: 100px;\n  }\n  .home .about-clinic-home .left .images .image {\n    width: 200px;\n  }\n  .home .about-clinic-home .left .effects {\n    width: 100%;\n  }\n  .home .about-clinic-home .left .effects .effect.one {\n    width: 350px;\n    height: 350px;\n    left: 3px !important;\n  }\n  .home .about-clinic-home .left .images {\n    margin-top: 37px;\n  }\n}\n.home .about-dr-home {\n  width: calc(100% - 60px);\n  padding: 0 30px;\n  height: 600px;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.home .about-dr-home .background {\n  width: 59%;\n  height: 100%;\n  position: absolute;\n  right: 0;\n  top: 0;\n  opacity: 1;\n  background: #fdf8f2;\n}\n.home .about-dr-home .background img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.home .about-dr-home .right,\n.home .about-dr-home .left {\n  height: calc(100% - 100px);\n  position: relative;\n  z-index: 2;\n}\n.home .about-dr-home .right {\n  position: relative;\n  width: 40%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.home .about-dr-home .right .image {\n  width: max-content;\n  height: 100%;\n  border-radius: 30px;\n  animation: dream 2s infinite alternate; /* Key part */\n  position: relative;\n}\n.home .about-dr-home .right .image:hover .data {\n  opacity: 1;\n  transition: opacity 0.5s;\n  top: -12px;\n  left: 7px;\n  border-radius: 10px;\n}\n.home .about-dr-home .right .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  border-radius: 30px;\n}\n.home .about-dr-home .right .image .data {\n  position: absolute;\n  z-index: 2;\n  top: 1%;\n  left: 200%;\n  width: 97%;\n  height: 100%;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.5s;\n}\n.home .about-dr-home .right .image .data .layout {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(rgba(0, 0, 0, 0) 70%, #413634 98%);\n  border-radius: 30px;\n}\n.home .about-dr-home .right .image .data .text {\n  position: absolute;\n  bottom: 25px;\n  font-weight: bold;\n  width: max-content;\n  color: #fff;\n  font-size: 18px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-transform: capitalize;\n  gap: 5px;\n}\n.home .about-dr-home .right .image .data .text .info {\n  text-transform: uppercase;\n}\n.home .about-dr-home .left {\n  display: flex;\n  flex-direction: column;\n  width: 55%;\n}\n.home .about-dr-home .left .head-title {\n  font-size: 50px;\n  font-weight: bold;\n  width: max-content;\n  position: relative;\n  margin-bottom: 30px;\n}\n.home .about-dr-home .left .head-title .title {\n  font-size: 50px;\n  font-weight: bold;\n  width: max-content;\n  position: relative;\n}\n.home .about-dr-home .left .head-title .title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n}\n.home .about-dr-home .left .head-title .title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 117%;\n  z-index: 1;\n  background-color: #ffdead;\n  transform: translateX(-50%);\n}\n.home .about-dr-home .left .head-title .info {\n  font-size: 21px;\n}\n.home .about-dr-home .left .skills {\n  width: 80%;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 30px;\n  font-size: 24px;\n  margin: 20px 0 50px;\n  font-weight: bold;\n}\n.home .about-dr-home .left .skills .skill {\n  color: #413634;\n  position: relative;\n  margin-right: 30px;\n}\n.home .about-dr-home .left .skills .skill::before {\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  background-color: #ffdead;\n  top: 50%;\n  position: absolute;\n  right: -30px;\n  transform: translateY(-50%);\n  border-radius: 50%;\n}\n.home .about-dr-home .left .locations {\n  width: 100%;\n  justify-content: space-between;\n  display: flex;\n  width: 60%;\n}\n.home .about-dr-home .left .locations .location {\n  width: max-content;\n  padding: 9px 14px;\n  font-size: 14px;\n  height: 40px;\n  font-weight: bold;\n  color: #000;\n  border: 1px solid #413634;\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n@keyframes dream {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(20px);\n  }\n}\n@media (max-width: 768px) {\n  .home .about-dr-home {\n    flex-direction: column-reverse;\n    height: max-content;\n    width: calc(100% - 60px);\n  }\n  .home .about-dr-home .head-title {\n    margin: 0 auto;\n    margin-top: 30px;\n  }\n  .home .about-dr-home .right,\n  .home .about-dr-home .left {\n    width: 100%;\n    height: max-content;\n    margin-bottom: 20px;\n  }\n  .home .about-dr-home .left .effects {\n    width: 100%;\n  }\n  .home .about-dr-home .left .effects .effect.one {\n    width: 350px;\n    height: 350px;\n    left: 3px !important;\n  }\n  .home .about-dr-home .left .skills {\n    width: 100%;\n  }\n  .home .about-dr-home .left .skills .skill {\n    width: 100%;\n    font-size: 20px;\n  }\n  .home .about-dr-home .left .locations {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n  }\n  .home .about-dr-home .left .locations .location {\n    width: calc(48% - 20px) !important;\n    padding: 8px 10px;\n    font-size: 11px !important;\n  }\n  .home .about-dr-home .left .images {\n    margin-top: 37px;\n  }\n}\n.home .certificates-home {\n  width: 100%;\n  padding: 0 0;\n  min-height: 600px;\n  height: max-content;\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 50px;\n  padding-bottom: 50px;\n}\n.home .certificates-home .background {\n  width: 100%;\n  height: 88%;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  opacity: 0.04;\n  background: #fdf8f2;\n}\n.home .certificates-home .background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.home .certificates-home .head-title {\n  font-size: 50px;\n  font-weight: bold;\n  width: 100%;\n  position: relative;\n  margin-bottom: 30px;\n}\n.home .certificates-home .head-title .title {\n  font-size: 50px;\n  font-weight: bold;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n.home .certificates-home .head-title .title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n  text-align: center;\n}\n.home .certificates-home .head-title .title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 80%;\n  z-index: 1;\n  background-color: #ffdead;\n  transform: translateX(-50%);\n}\n.home .certificates-home .head-title .info {\n  font-size: 21px;\n}\n.home .certificates-home .certificates {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  justify-content: space-between;\n  position: relative;\n  z-index: 2;\n}\n.home .certificates-home .certificates.pc {\n  display: flex;\n  padding-bottom: 40px;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  justify-content: space-between;\n}\n.home .certificates-home .certificates.pc .certificate {\n  width: 300px !important;\n}\n.home .certificates-home .certificates .mySwiper {\n  width: 100%;\n  height: max-content;\n  padding-bottom: 50px;\n}\n.home .certificates-home .certificates .mySwiper .swiper-pagination {\n  bottom: 30px;\n}\n.home .certificates-home .certificates .mySwiper .swiper-slide-prev,\n.home .certificates-home .certificates .mySwiper .swiper-slide-next {\n  opacity: 0.7;\n  transition: 0.5s;\n}\n.home .certificates-home .certificates .certificate {\n  width: 300px !important;\n  height: 400px;\n  transition: 0.5s;\n  border-radius: 15px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;\n  position: relative;\n  margin-top: 30px;\n  margin-left: 12px;\n  margin-right: 12px;\n}\n.home .certificates-home .certificates .certificate .image {\n  width: 300px;\n  height: 100%;\n  border-radius: 15px;\n}\n.home .certificates-home .certificates .certificate .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 15px;\n  transition: 0.5s;\n}\n.home .certificates-home .certificates .certificate .data {\n  position: absolute;\n  z-index: -2;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.5s;\n  border-radius: 15px;\n}\n.home .certificates-home .certificates .certificate .data .layout {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(rgba(0, 0, 0, 0) 70%, #413634 98%);\n  border-radius: 15px;\n}\n.home .certificates-home .certificates .certificate .data .text {\n  position: absolute;\n  bottom: 25px;\n  font-weight: bold;\n  width: max-content;\n  color: #fff;\n  font-size: 18px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.home .certificates-home .certificates .certificate:hover .image img {\n  transition: 0.5s;\n  transform: scale(1);\n}\n.home .certificates-home .certificates .certificate:hover .data {\n  opacity: 1;\n  transition: opacity 0.5s;\n  top: 0;\n  z-index: 2;\n}\n.home .certificates-home .effects {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n}\n.home .certificates-home .effects .effect {\n  position: absolute;\n  z-index: 1;\n  background-color: #ffdead;\n  border-radius: 50%;\n}\n.home .certificates-home .effects .effect.middle {\n  width: 400px;\n  height: 400px;\n  top: 56%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n}\n.home .certificates-home .effects .effect.two {\n  width: 100px;\n  height: 100px;\n  bottom: -16%;\n  right: -32%;\n  transform: translateX(-50%) translateY(-50%);\n}\n.home .directions-home {\n  width: calc(100% - 60px);\n  padding: 0 30px;\n  min-height: 650px;\n  height: max-content;\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding-bottom: 50px;\n  padding-top: 20px;\n}\n.home .directions-home .background {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  opacity: 0.2;\n  background: #fdf8f2;\n}\n.home .directions-home .background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.home .directions-home .head-title {\n  font-size: 50px;\n  font-weight: bold;\n  width: 100%;\n  position: relative;\n  margin-bottom: 30px;\n  z-index: 2;\n}\n.home .directions-home .head-title .title {\n  font-weight: bold;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n.home .directions-home .head-title .title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n  text-align: center;\n}\n.home .directions-home .head-title .title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 100%;\n  z-index: 1;\n  background-color: #ffdead;\n  transform: translateX(-50%);\n}\n.home .directions-home .head-title .info {\n  font-size: 21px;\n}\n.home .directions-home .box {\n  position: relative;\n  z-index: 2;\n  width: 95%;\n  height: max-content;\n  background-color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-top: 40px;\n  box-shadow: rgba(99, 99, 99, 0.39) 0px 2px 13px 3px;\n}\n.home .directions-home .box .direction {\n  display: flex;\n  flex-direction: column;\n  width: 230px;\n  height: 230px;\n  margin: 10px;\n  justify-content: center;\n  gap: 20px;\n  align-items: center;\n  font-weight: bold;\n  font-size: 17px;\n  position: relative;\n  transition: 0.5s;\n  background-color: #fff;\n  text-align: center;\n}\n.home .directions-home .box .direction:not(:last-of-type):after {\n  content: \"\";\n  left: 0;\n  position: absolute;\n  top: 50%;\n  width: 1px;\n  height: 80%;\n  background-color: #413634;\n  transform: translateY(-50%);\n  transition: 0.1s;\n}\n.home .directions-home .box .direction:hover {\n  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 10px 4px, rgba(60, 64, 67, 0.15) 0px 1px 9px 4px;\n  transform: scale(1.05);\n  transition: 0.5s;\n  z-index: 3;\n}\n.home .directions-home .box .direction:hover::after {\n  width: 0;\n  height: 0;\n  transition: 0.1s;\n}\n.home .directions-home .box .direction .image {\n  width: 130px;\n  height: 130px;\n}\n.home .directions-home .box .direction .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n@media (max-width: 768px) {\n  .home .directions-home {\n    flex-direction: column;\n    height: max-content;\n    width: calc(100% - 60px);\n  }\n  .home .directions-home .head-title {\n    margin: 0 auto;\n    margin-top: 30px;\n    font-size: 20px;\n  }\n  .home .directions-home .right,\n  .home .directions-home .left {\n    width: 100%;\n    height: max-content;\n  }\n  .home .directions-home .left {\n    height: 500px !important;\n  }\n  .home .directions-home .left .effects {\n    width: 100%;\n  }\n  .home .directions-home .left .effects .effect.one {\n    width: 350px;\n    height: 350px;\n    left: 3px !important;\n  }\n  .home .directions-home .left .images {\n    margin-top: 37px;\n  }\n  .home .directions-home .box {\n    width: 100%;\n    justify-content: space-between;\n    align-items: start;\n  }\n  .home .directions-home .box:first-of-type .direction:before {\n    content: \"\";\n    left: -10px;\n    position: absolute;\n    top: 50%;\n    width: 1px;\n    height: 80%;\n    background-color: #413634;\n    transform: translateY(-50%);\n    transition: 0.1s;\n  }\n  .home .directions-home .box .direction {\n    width: 48% !important;\n    margin: 0;\n    text-align: 14px;\n  }\n  .home .directions-home .box .direction::after {\n    display: none;\n  }\n}\n\n.social {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 100dvh;\n  padding-top: 50px;\n  position: relative;\n  overflow-x: hidden;\n}\n.social .background {\n  width: 100%;\n  height: 321px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  opacity: 0.2;\n  background: #fdf8f2;\n  background-repeat: no-repeat;\n  z-index: 0;\n}\n.social .background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.social .section {\n  display: flex;\n  width: 100%;\n  height: 700px;\n  position: relative;\n  z-index: 2;\n  flex-direction: column;\n  color: #000;\n  text-decoration: none;\n}\n.social .section.spic {\n  background-color: #fcf2ec;\n}\n.social .section .head-title {\n  font-size: 40px;\n  font-weight: bold;\n  width: max-content;\n  position: relative;\n  margin: 0 auto;\n  margin-bottom: 40px;\n  margin-top: 20px;\n}\n.social .section .head-title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n}\n.social .section .head-title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 104%;\n  transform: translateX(-50%);\n  z-index: 1;\n  background-color: #ffdead;\n}\n.social .section .section-container {\n  width: 100%;\n  display: flex;\n  height: 100%;\n  justify-content: space-between;\n  color: #000;\n  text-decoration: none;\n}\n.social .section .section-container .right {\n  width: calc(40% - 40px);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.social .section .section-container .right .anthor-title {\n  font-weight: bold;\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.social .section .section-container .right .anthor-title .title {\n  font-size: 40px;\n  position: relative;\n  width: max-content;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-right: 0 !important;\n}\n.social .section .section-container .right .anthor-title .title span {\n  position: relative;\n  z-index: 2;\n  width: max-content;\n  color: #413634;\n}\n.social .section .section-container .right .anthor-title .title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 104%;\n  transform: translateX(-50%);\n  z-index: 1;\n  background-color: #ffdead;\n}\n.social .section .section-container .right .anthor-title .info {\n  color: #413634;\n  font-weight: bold;\n  margin: 5px 0;\n  width: 83%;\n  text-align: center;\n}\n.social .section .section-container .right .location {\n  height: calc(100% - 100px);\n  width: calc(100% - 40px);\n  padding: 0 20px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin-top: 20px;\n}\n.social .section .section-container .right .location .location {\n  width: 80%;\n  height: 80%;\n}\n.social .section .section-container .right .location .location img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.social .section .section-container .left {\n  width: calc(55% - 40px);\n  padding-left: 40px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n  position: relative;\n}\n.social .section .section-container .left iframe {\n  width: 100%;\n  height: 80%;\n  border-radius: 10px;\n  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n}\n.social .section .section-container .left .info {\n  width: 30%;\n  position: absolute;\n  height: 50px;\n  border-radius: 30px;\n  bottom: 15%;\n  left: 50%;\n  transform: translateX(-45%);\n  border: 1px solid #413634;\n  background-color: #fcf2ec;\n  font-size: 20px;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  color: #000;\n  text-decoration: none;\n}\n.social .section .section-container .left .info a {\n  color: #000;\n  text-decoration: none;\n}\n.social .section .section-container .left .info .icon {\n  position: absolute;\n  right: 10px;\n  width: 30px;\n  height: 30px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #000;\n  text-decoration: none;\n}\n.social .section .simple-title {\n  font-size: 40px;\n  font-weight: bold;\n  width: max-content;\n  position: relative;\n  margin: 0 auto;\n  margin-bottom: 40px;\n  margin-top: 80px;\n}\n.social .section .simple-title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n}\n.social .section .simple-title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 104%;\n  transform: translateX(-50%);\n  z-index: 1;\n  background-color: #ffdead;\n}\n.social .section .container {\n  display: flex;\n  width: 90%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  color: #000;\n  text-decoration: none;\n}\n.social .section .container .contact {\n  width: 280px;\n  height: 280px;\n  display: flex;\n  flex-direction: column;\n  background-color: #fcf2ec;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-radius: 20px;\n  border: 1px solid transparent;\n  transition: 0.5s;\n  transform: scale(1);\n  color: #000;\n  text-decoration: none;\n}\n.social .section .container .contact:hover {\n  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n  border: 1px solid #413634;\n  transform: scale(1.1);\n  transition: 0.5s;\n}\n.social .section .container .contact .icon {\n  width: 100px;\n  height: 100px;\n  margin-top: 20px;\n}\n.social .section .container .contact .title {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 40px;\n  width: 90%;\n  position: relative;\n  margin: 0 auto;\n  text-align: center;\n  color: #000;\n  text-decoration: none;\n}\n.social .section .container .contact .title::before {\n  content: \"\";\n  bottom: -20px;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  border-radius: 10px;\n  background-color: #413634;\n}\n.social .section .container .contact .value {\n  font-weight: normal;\n  font-size: 18px;\n  margin: 0 auto;\n  text-align: center;\n  color: #000;\n  text-decoration: none;\n}\n\n@media (max-width: 768px) {\n  .social {\n    height: max-content;\n  }\n  .social .background {\n    width: 100%;\n    height: 121px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    opacity: 0.2;\n    background: #fdf8f2;\n    background-repeat: no-repeat;\n    z-index: 0;\n  }\n  .social .background img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  .social .head-title {\n    display: none;\n    margin-bottom: 30px;\n  }\n  .social .head-title .title {\n    margin-top: 10px;\n    margin-bottom: 30px;\n  }\n  .social .right,\n  .social .left {\n    width: 100% !important;\n    height: max-content !important;\n  }\n  .social .tower .group {\n    margin-left: 30px;\n  }\n  .social .left {\n    margin: 30px 0;\n  }\n  .social .left iframe {\n    width: 100%;\n    margin: 0 auto;\n    height: 300px !important;\n    width: 90% !important;\n  }\n  .social .left .info {\n    width: 52% !important;\n    position: absolute;\n    height: 50px;\n    border-radius: 30px;\n    bottom: -7% !important;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 1px solid #413634;\n    background-color: #fcf2ec;\n    font-size: 20px;\n    font-weight: bold;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n  }\n  .social .section {\n    height: max-content !important;\n  }\n  .social .section .section-container {\n    width: 100%;\n    display: flex;\n    height: max-content !important;\n    justify-content: space-between;\n    flex-direction: column;\n  }\n  .social .section .section-container .anthor-title .title {\n    margin-right: 40px;\n    margin-top: 20px;\n  }\n  .social .section .section-container .anthor-title .info {\n    width: max-content;\n    font-size: 12px;\n  }\n  .social .section .section-container .location {\n    width: 100%;\n  }\n  .social .section .container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 30px;\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n  .social .section .container .contact {\n    width: calc(48% - 20px);\n    height: 185px;\n    margin-left: 10px;\n    margin-bottom: 10px;\n  }\n  .social .section .container .contact .title {\n    font-size: 18px !important;\n  }\n  .social .section .container .contact .title::before {\n    display: none;\n  }\n  .social .section .container .contact .value {\n    font-size: 16px !important;\n  }\n}\n.services {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 100dvh;\n  padding-top: 50px;\n  position: relative;\n  padding-bottom: 50px;\n}\n.services .background {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  right: 0;\n  top: 0;\n  opacity: 0.1;\n  background: #fdf8f2;\n  background-repeat: no-repeat;\n  z-index: 0;\n}\n.services .background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.services .head-title {\n  font-size: 40px;\n  font-weight: bold;\n  width: max-content;\n  position: relative;\n  margin: 0 auto;\n  margin-bottom: 40px;\n  margin-top: 20px;\n  z-index: 2;\n}\n.services .head-title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n}\n.services .head-title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 104%;\n  transform: translateX(-50%);\n  z-index: 1;\n  background-color: #ffdead;\n}\n.services .services-container {\n  width: 90%;\n  margin: 0 auto;\n  height: calc(100% - 240px);\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 30px;\n}\n.services .services-container .service {\n  display: flex;\n  background-color: #fdf8f2;\n  width: 350px;\n  height: 520px;\n  border-radius: 10px;\n  flex-direction: column;\n  align-items: center;\n  transition: 0.5s;\n  border: 1px solid transparent;\n}\n.services .services-container .service:hover {\n  transition: 0.5s;\n  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n  border: 1px solid #413634;\n}\n.services .services-container .service .content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 90%;\n  flex-direction: column;\n  margin-bottom: 40px;\n  position: relative;\n}\n.services .services-container .service .content::before {\n  content: \"\";\n  bottom: -20px;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  border-radius: 10px;\n  background-color: #413634;\n}\n.services .services-container .service .content .icon {\n  width: 140px;\n  height: 140px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.services .services-container .service .content .title {\n  font-size: 24px;\n  margin-top: 10px;\n  font-weight: bold;\n  color: #413634;\n}\n.services .services-container .service .grouping {\n  display: flex;\n  width: 90%;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 30px;\n}\n.services .services-container .service .grouping .info {\n  font-size: 16px;\n  line-height: 2;\n  text-align: center;\n  color: #525252;\n}\n.services .services-container .service .grouping .images {\n  width: 50px;\n  height: 50px;\n  cursor: pointer;\n}\n.services .services-container .service.spic {\n  background-color: transparent;\n}\n.services .services-container .service.spic:hover {\n  transition: 0.5s;\n  box-shadow: none;\n  border: 1px solid transparent;\n}\n.services .services-container .service.spic .content {\n  height: 150px;\n  background-color: #413634;\n  width: 100%;\n  margin-bottom: 10px;\n  border-radius: 10px;\n}\n.services .services-container .service.spic .content::before {\n  display: none;\n}\n.services .services-container .service.spic .content .title {\n  color: #fff;\n  margin-bottom: 10px;\n}\n.services .services-container .service .service-container {\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  gap: 20px;\n  height: calc(100% - 150px);\n  width: 100%;\n}\n.services .services-container .service .service-container .service-d {\n  width: 100%;\n  background-color: #fdf8f2;\n  border: 1px solid #413634;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: auto;\n  padding: 15px 0;\n  color: #000;\n  font-weight: bold;\n  cursor: pointer;\n  overflow: hidden;\n  transition: 0.5s;\n}\n.services .services-container .service .service-container .service-d span {\n  width: 100%;\n  text-align: center;\n}\n.services .services-container .service .service-container .service-d .icon {\n  width: 30px;\n  height: 30px;\n  position: relative;\n  left: -100%;\n  transition: 0.5s;\n}\n.services .services-container .service .service-container .service-d:hover {\n  transition: 0.5s;\n  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n  border: 1px solid #413634;\n  width: 100%;\n}\n.services .services-container .service .service-container .service-d:hover .icon {\n  left: 20px;\n  transition: 0.5s;\n}\n\n@media (max-width: 768px) {\n  .services {\n    height: max-content;\n  }\n  .services .background {\n    width: 100%;\n    height: 121px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    opacity: 0.2;\n    background: #fdf8f2;\n    background-repeat: no-repeat;\n    z-index: 0;\n  }\n  .services .background img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  .services .head-title {\n    margin-bottom: 30px;\n  }\n  .services .head-title .title {\n    margin-top: 10px;\n    margin-bottom: 30px;\n  }\n  .services .services-container {\n    height: max-content;\n    width: 100%;\n    flex-direction: column;\n    padding-bottom: 50px;\n    gap: 40px;\n  }\n  .services .service {\n    width: 350px !important;\n    height: 450px !important;\n  }\n  .services .service.spic .content {\n    height: max-content;\n  }\n  .services .service.spic .content .icon {\n    width: 70px;\n    height: 70px;\n  }\n  .services .service .info {\n    font-size: 13px !important;\n  }\n}\n.cases {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 600px;\n  padding-top: 50px;\n  position: relative;\n}\n.cases .head-title {\n  font-size: 40px;\n  font-weight: bold;\n  width: max-content;\n  position: relative;\n  margin: 0 auto;\n  margin-bottom: 40px;\n  margin-top: 20px;\n  z-index: 2;\n}\n.cases .head-title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n}\n.cases .head-title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 104%;\n  transform: translateX(-50%);\n  z-index: 1;\n  background-color: #ffdead;\n}\n.cases .boxes {\n  width: 90%;\n  margin: 0 auto;\n  height: 100%;\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  gap: 40px;\n  margin-top: 100px;\n}\n.cases .boxes .box {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: #fdf8f2;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  width: 300px;\n  height: 300px;\n  gap: 30px;\n  cursor: pointer;\n  transition: 0.5s;\n  transform: scale(1);\n}\n.cases .boxes .box:hover {\n  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n  border: 1px solid #413634;\n  transform: scale(1.1);\n  transition: 0.5s;\n}\n.cases .boxes .box .icon {\n  width: 150px;\n  height: 150px;\n}\n.cases .boxes .box .title {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n@media (max-width: 768px) {\n  .cases {\n    height: max-content;\n  }\n  .cases .background {\n    width: 100%;\n    height: 121px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    opacity: 0.2;\n    background: #fdf8f2;\n    background-repeat: no-repeat;\n    z-index: 0;\n  }\n  .cases .background img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  .cases .head-title {\n    margin-bottom: 30px;\n  }\n  .cases .head-title .title {\n    margin-top: 10px;\n    margin-bottom: 30px;\n  }\n  .cases .boxes {\n    height: max-content;\n    width: 100%;\n    flex-direction: column;\n    padding-bottom: 50px;\n    gap: 40px;\n    align-items: center;\n  }\n  .cases .boxes .box {\n    width: 250px;\n    height: 250px;\n  }\n}\n.home-admin {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 100dvh;\n  height: 100%;\n  padding-top: 50px;\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n.home-admin .landing-home {\n  width: 100%;\n  height: 600px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 10px;\n  padding-top: 50px;\n}\n.home-admin .landing-home.activeAnm .data .data-background img {\n  transition: 1s;\n  transform: scale(1.1);\n}\n.home-admin .landing-home.activeAnm .data .back-box {\n  top: -20px;\n  transition: 1s;\n}\n.home-admin .landing-home.activeAnm .data .content .logo {\n  margin-bottom: 0;\n  margin-right: 30px;\n}\n.home-admin .landing-home.activeAnm .data .content .grouping {\n  transition: 1s;\n  top: -31px;\n}\n.home-admin .landing-home.activeAnm .effects {\n  width: 450px;\n  transition: 1s;\n}\n.home-admin .landing-home.activeAnm .about-clinic span {\n  width: 250px;\n  transition: 1s;\n}\n.home-admin .landing-home.activeAnm .about-clinic .arrow {\n  opacity: 1;\n}\n.home-admin .landing-home.activeAnm .about-clinic .arrow #Path_7 {\n  animation: dashrev 2s linear forwards;\n}\n.home-admin .landing-home.activeAnm .about-clinic .arrow #Path_8 {\n  opacity: 1;\n  transition: 4s;\n}\n.home-admin .landing-home .background {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0.1;\n  background: #fdf8f2;\n}\n.home-admin .landing-home .background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.home-admin .landing-home .data {\n  position: relative;\n  width: 80%;\n  height: 80%;\n  background: #413634;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  gap: 21px;\n  position: relative;\n}\n.home-admin .landing-home .data .data-background {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  border-radius: 10px;\n  z-index: 2;\n  overflow: hidden;\n}\n.home-admin .landing-home .data .data-background .image {\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  opacity: 0.3;\n  background: #413634;\n}\n.home-admin .landing-home .data .data-background .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n  transition: 1s;\n}\n.home-admin .landing-home .data .data-background .add-icon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: white;\n  z-index: 2;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n}\n.home-admin .landing-home .data .data-background .add-icon:hover .img {\n  transition: 0.5s;\n  opacity: 1;\n}\n.home-admin .landing-home .data .back-box {\n  position: absolute;\n  top: -40px;\n  width: 90%;\n  height: 90%;\n  left: 50%;\n  transform: translateX(-50%);\n  transition: 1s;\n  background-color: #413634;\n}\n.home-admin .landing-home .data .content {\n  width: 100%;\n  height: 64%;\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 24px;\n}\n.home-admin .landing-home .data .content .logo {\n  width: 300px;\n  height: 300px;\n  margin-right: 60px;\n  margin-bottom: 20px;\n  transition: 1s;\n}\n.home-admin .landing-home .data .content .logo img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.home-admin .landing-home .data .content .grouping {\n  font-size: 35px;\n  color: #fff;\n  position: relative;\n  top: 50px;\n  transition: 1s;\n}\n.home-admin .landing-home .data .content .grouping .title {\n  font-weight: bold;\n  font-size: 50px;\n}\n.home-admin .landing-home .effects {\n  position: absolute;\n  left: 0;\n  bottom: 112px;\n  z-index: 2;\n  width: 350px;\n  height: 100px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  transition: 1s;\n}\n.home-admin .landing-home .effects .effect {\n  height: 20px;\n  width: 100%;\n  background-color: #fcf2ec;\n  position: relative;\n  left: 0;\n}\n.home-admin .landing-home .effects .effect.one {\n  width: 70%;\n  left: -30%;\n}\n.home-admin .landing-home .effects .effect.two {\n  width: 90%;\n  left: -10%;\n}\n.home-admin .landing-home .effects .effect.three {\n  width: 100%;\n}\n.home-admin .landing-home .about-clinic {\n  width: 75%;\n  height: 60px;\n  z-index: 2;\n  position: relative;\n  margin-top: 10px;\n  cursor: pointer;\n}\n.home-admin .landing-home .about-clinic a {\n  background-color: #413634;\n  border-radius: 30px;\n  color: #fff;\n  font-weight: bold;\n  height: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 200px;\n  transition: 1s;\n  text-decoration: none;\n  color: #fff;\n}\n.home-admin .landing-home .about-clinic .arrow {\n  position: absolute;\n  top: 50%;\n  right: 270px;\n  opacity: 0;\n  transition: 1s;\n}\n.home-admin .landing-home .about-clinic .arrow #Path_7 {\n  stroke-dasharray: 10;\n  stroke-dashoffset: 0;\n}\n@keyframes dashrev {\n  0% {\n    stroke-dashoffset: 0;\n  }\n  100% {\n    stroke-dashoffset: -80;\n  }\n}\n.home-admin .landing-home .about-clinic .arrow #Path_8 {\n  opacity: 0;\n}\n@media (max-width: 768px) {\n  .home-admin .landing-home {\n    height: 400px;\n  }\n  .home-admin .landing-home .content {\n    width: 100%;\n    height: 92%;\n    position: relative;\n    z-index: 2;\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    align-items: center;\n    flex-direction: column;\n  }\n  .home-admin .landing-home .content .logo {\n    width: 115px !important;\n    height: 115px !important;\n    margin-left: 30px;\n    margin-bottom: 10px;\n  }\n  .home-admin .landing-home .content .grouping {\n    font-size: 20px !important;\n    top: 0 !important;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n  .home-admin .landing-home .content .grouping .title {\n    font-weight: bold;\n    font-size: 32px !important;\n  }\n  .home-admin .landing-home .about-clinic .arrow {\n    width: 111px;\n    height: 124px;\n    position: relative;\n    right: 196px;\n    opacity: 1;\n    top: -55px;\n    transform: rotate(320deg);\n  }\n  .home-admin .landing-home .about-clinic svg {\n    width: 100%;\n    height: 100%;\n  }\n  .home-admin .landing-home.activeAnm .effects {\n    display: none;\n  }\n  .home-admin .landing-home .effects {\n    bottom: 80px !important;\n    width: 100px !important;\n  }\n}\n.home-admin .about-clinic-home {\n  width: calc(100% - 60px);\n  padding: 0 30px;\n  height: 800px;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  flex-direction: column;\n  overflow: hidden;\n}\n.home-admin .about-clinic-home .container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  height: 100%;\n}\n.home-admin .about-clinic-home .container .right,\n.home-admin .about-clinic-home .container .left {\n  width: 48%;\n  height: calc(100% - 100px);\n}\n.home-admin .about-clinic-home .head-title {\n  font-size: 50px;\n  font-weight: bold;\n  width: max-content;\n  position: relative;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.home-admin .about-clinic-home .head-title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n}\n.home-admin .about-clinic-home .head-title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 117%;\n  z-index: 1;\n  background-color: #ffdead;\n  transform: translateX(-50%);\n}\n.home-admin .about-clinic-home .right {\n  display: flex;\n  flex-direction: column;\n}\n.home-admin .about-clinic-home .right .text {\n  width: 100%;\n  height: 100%;\n  line-height: 2.5;\n  font-size: 20px;\n  font-weight: 600;\n  color: #7a7a7a;\n  position: relative;\n}\n.home-admin .about-clinic-home .right .text textarea {\n  width: 100%;\n  height: 100%;\n  resize: none;\n}\n.home-admin .about-clinic-home .right .text .edit-icon,\n.home-admin .about-clinic-home .right .text .save-icon {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  background-color: #d0d0d0;\n  z-index: 2;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n}\n.home-admin .about-clinic-home .right .bottom {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n.home-admin .about-clinic-home .right .bottom .one {\n  width: 80px;\n  height: 4px;\n  background-color: #413634;\n  border-radius: 10px;\n}\n.home-admin .about-clinic-home .right .bottom .two {\n  width: 20px;\n  height: 4px;\n  background-color: #413634;\n  border-radius: 10px;\n}\n.home-admin .about-clinic-home .left {\n  position: relative;\n}\n.home-admin .about-clinic-home .left .images {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.home-admin .about-clinic-home .left .images .image-container {\n  width: 45%;\n  height: 55%;\n  border-radius: 30px;\n  position: absolute;\n}\n.home-admin .about-clinic-home .left .images .image-container .image {\n  height: 100%;\n  width: 100%;\n}\n.home-admin .about-clinic-home .left .images .image-container.one {\n  top: 35%;\n  left: 44%;\n  z-index: 2;\n  animation: dream 2s infinite alternate; /* Key part */\n}\n.home-admin .about-clinic-home .left .images .image-container.two {\n  bottom: 45%;\n  right: 44%;\n  z-index: 1;\n  animation: dream2 2s infinite alternate; /* Key part */\n}\n.home-admin .about-clinic-home .left .images .image-container .add-icon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #ededed;\n  z-index: 2;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n}\n.home-admin .about-clinic-home .left .images .image-container .add-icon:hover .img {\n  transition: 0.5s;\n  opacity: 1;\n}\n.home-admin .about-clinic-home .left .images .image-container img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 30px;\n}\n.home-admin .about-clinic-home .left .effects {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  bottom: 0;\n}\n.home-admin .about-clinic-home .left .effects .effect {\n  border-radius: 50%;\n  background-color: #413634;\n  position: absolute;\n}\n.home-admin .about-clinic-home .left .effects .effect.one {\n  width: 450px;\n  height: 450px;\n  left: -17%;\n  bottom: -15%;\n}\n.home-admin .about-clinic-home .left .effects .effect.two {\n  width: 100px;\n  height: 100px;\n  top: 29%;\n  right: 0%;\n}\n.home-admin .about-clinic-home .left .effects .effect.thee {\n  top: 22%;\n  right: 15%;\n  width: 40px;\n  height: 40px;\n}\n@keyframes dream {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(20px);\n  }\n}\n@keyframes dream2 {\n  0% {\n    transform: translateY(20px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n@media (max-width: 768px) {\n  .home-admin .about-clinic-home {\n    flex-direction: column;\n    height: max-content;\n    width: calc(100% - 60px);\n    padding-bottom: 0;\n  }\n  .home-admin .about-clinic-home .head-title {\n    margin: 0 auto;\n    margin-top: 30px;\n  }\n  .home-admin .about-clinic-home .container {\n    flex-direction: column-reverse;\n  }\n  .home-admin .about-clinic-home .container .right,\n  .home-admin .about-clinic-home .container .left {\n    width: 100%;\n    height: max-content;\n  }\n  .home-admin .about-clinic-home .right {\n    margin-bottom: 0;\n  }\n  .home-admin .about-clinic-home .right .text {\n    line-height: 2.3;\n    font-size: 16px;\n  }\n  .home-admin .about-clinic-home .left {\n    height: 500px !important;\n    margin-bottom: 100px;\n  }\n  .home-admin .about-clinic-home .left .images .image {\n    width: 200px;\n  }\n  .home-admin .about-clinic-home .left .effects {\n    width: 100%;\n  }\n  .home-admin .about-clinic-home .left .effects .effect.one {\n    width: 350px;\n    height: 350px;\n    left: 3px !important;\n  }\n  .home-admin .about-clinic-home .left .images {\n    margin-top: 37px;\n  }\n}\n.home-admin .about-dr-home {\n  width: calc(100% - 60px);\n  padding: 0 30px;\n  height: 600px;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.home-admin .about-dr-home .background {\n  width: 59%;\n  height: 100%;\n  position: absolute;\n  right: 0;\n  top: 0;\n  opacity: 1;\n  background: #fdf8f2;\n}\n.home-admin .about-dr-home .background img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.home-admin .about-dr-home .right,\n.home-admin .about-dr-home .left {\n  height: calc(100% - 100px);\n  position: relative;\n  z-index: 2;\n}\n.home-admin .about-dr-home .right {\n  position: relative;\n  width: 40%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.home-admin .about-dr-home .right .image {\n  width: max-content;\n  height: 100%;\n  border-radius: 30px;\n  animation: dream 2s infinite alternate; /* Key part */\n  position: relative;\n}\n.home-admin .about-dr-home .right .image:hover .data {\n  opacity: 1;\n  transition: opacity 0.5s;\n  top: -12px;\n  left: 7px;\n  border-radius: 10px;\n}\n.home-admin .about-dr-home .right .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  border-radius: 30px;\n}\n.home-admin .about-dr-home .right .image .add-icon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: white;\n  z-index: 2;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  z-index: 55555;\n}\n.home-admin .about-dr-home .right .image .add-icon:hover .img {\n  transition: 0.5s;\n  opacity: 1;\n}\n.home-admin .about-dr-home .right .image .data {\n  position: absolute;\n  z-index: 2;\n  top: 1%;\n  left: 200%;\n  width: 97%;\n  height: 100%;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.5s;\n}\n.home-admin .about-dr-home .right .image .data .layout {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(rgba(0, 0, 0, 0) 70%, #413634 98%);\n  border-radius: 30px;\n}\n.home-admin .about-dr-home .right .image .data .text {\n  position: absolute;\n  bottom: 25px;\n  font-weight: bold;\n  width: max-content;\n  color: #fff;\n  font-size: 18px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-transform: capitalize;\n  gap: 5px;\n}\n.home-admin .about-dr-home .right .image .data .text .info {\n  text-transform: uppercase;\n}\n.home-admin .about-dr-home .left {\n  display: flex;\n  flex-direction: column;\n  width: 55%;\n}\n.home-admin .about-dr-home .left .head-title {\n  font-size: 50px;\n  font-weight: bold;\n  width: max-content;\n  position: relative;\n  margin-bottom: 30px;\n}\n.home-admin .about-dr-home .left .head-title .title {\n  font-size: 50px;\n  font-weight: bold;\n  width: max-content;\n  position: relative;\n}\n.home-admin .about-dr-home .left .head-title .title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n}\n.home-admin .about-dr-home .left .head-title .title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 117%;\n  z-index: 1;\n  background-color: #ffdead;\n  transform: translateX(-50%);\n}\n.home-admin .about-dr-home .left .head-title .info {\n  font-size: 21px;\n}\n.home-admin .about-dr-home .left .skills {\n  width: 80%;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 30px;\n  font-size: 24px;\n  margin: 20px 0 50px;\n  font-weight: bold;\n}\n.home-admin .about-dr-home .left .skills .skill {\n  color: #413634;\n  position: relative;\n  margin-right: 30px;\n}\n.home-admin .about-dr-home .left .skills .skill::before {\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  background-color: #ffdead;\n  top: 50%;\n  position: absolute;\n  right: -30px;\n  transform: translateY(-50%);\n  border-radius: 50%;\n}\n.home-admin .about-dr-home .left .locations {\n  width: 100%;\n  justify-content: space-between;\n  display: flex;\n  width: 60%;\n}\n.home-admin .about-dr-home .left .locations .location {\n  width: max-content;\n  padding: 9px 14px;\n  font-size: 14px;\n  height: 40px;\n  font-weight: bold;\n  color: #000;\n  border: 1px solid #413634;\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n@keyframes dream {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(20px);\n  }\n}\n@media (max-width: 768px) {\n  .home-admin .about-dr-home {\n    flex-direction: column-reverse;\n    height: max-content;\n    width: calc(100% - 60px);\n  }\n  .home-admin .about-dr-home .head-title {\n    margin: 0 auto;\n    margin-top: 30px;\n  }\n  .home-admin .about-dr-home .right,\n  .home-admin .about-dr-home .left {\n    width: 100%;\n    height: max-content;\n    margin-bottom: 20px;\n  }\n  .home-admin .about-dr-home .left .effects {\n    width: 100%;\n  }\n  .home-admin .about-dr-home .left .effects .effect.one {\n    width: 350px;\n    height: 350px;\n    left: 3px !important;\n  }\n  .home-admin .about-dr-home .left .skills {\n    width: 100%;\n  }\n  .home-admin .about-dr-home .left .skills .skill {\n    width: 100%;\n    font-size: 20px;\n  }\n  .home-admin .about-dr-home .left .locations {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n  }\n  .home-admin .about-dr-home .left .locations .location {\n    width: calc(48% - 20px) !important;\n    padding: 8px 10px;\n    font-size: 11px !important;\n  }\n  .home-admin .about-dr-home .left .images {\n    margin-top: 37px;\n  }\n}\n.home-admin .certificates-home {\n  width: 100%;\n  padding: 0 0;\n  min-height: 600px;\n  height: max-content;\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 50px;\n  padding-bottom: 50px;\n}\n.home-admin .certificates-home .background {\n  width: 100%;\n  height: 88%;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  opacity: 0.04;\n  background: #fdf8f2;\n}\n.home-admin .certificates-home .background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.home-admin .certificates-home .head-title {\n  font-size: 50px;\n  font-weight: bold;\n  width: 100%;\n  position: relative;\n  margin-bottom: 30px;\n}\n.home-admin .certificates-home .head-title .title {\n  font-size: 50px;\n  font-weight: bold;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n.home-admin .certificates-home .head-title .title .add-icon {\n  position: absolute;\n  top: 22%;\n  left: 10%;\n  background-color: white;\n  z-index: 2;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: -11px;\n  z-index: 55555;\n}\n.home-admin .certificates-home .head-title .title .add-icon:hover .img {\n  transition: 0.5s;\n  opacity: 1;\n}\n.home-admin .certificates-home .head-title .title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n  text-align: center;\n}\n.home-admin .certificates-home .head-title .title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 80%;\n  z-index: 1;\n  background-color: #ffdead;\n  transform: translateX(-50%);\n}\n.home-admin .certificates-home .head-title .info {\n  font-size: 21px;\n}\n.home-admin .certificates-home .certificates {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  justify-content: space-between;\n  position: relative;\n  z-index: 2;\n}\n.home-admin .certificates-home .certificates.pc {\n  display: flex;\n  padding-bottom: 40px;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  justify-content: space-between;\n}\n.home-admin .certificates-home .certificates.pc .certificate {\n  width: 300px !important;\n}\n.home-admin .certificates-home .certificates .mySwiper {\n  width: 100%;\n  height: max-content;\n  padding-bottom: 50px;\n}\n.home-admin .certificates-home .certificates .mySwiper .swiper-pagination {\n  bottom: 30px;\n}\n.home-admin .certificates-home .certificates .mySwiper .swiper-slide-prev,\n.home-admin .certificates-home .certificates .mySwiper .swiper-slide-next {\n  opacity: 0.7;\n  transition: 0.5s;\n}\n.home-admin .certificates-home .certificates .certificate {\n  width: 300px !important;\n  height: 400px;\n  transition: 0.5s;\n  border-radius: 15px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;\n  position: relative;\n  margin-top: 30px;\n  margin-left: 12px;\n  margin-right: 12px;\n}\n.home-admin .certificates-home .certificates .certificate .del-icon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #d0d0d0;\n  z-index: 555;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: 10px 0 0 0;\n}\n.home-admin .certificates-home .certificates .certificate .image {\n  width: 300px;\n  height: 100%;\n  border-radius: 15px;\n}\n.home-admin .certificates-home .certificates .certificate .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 15px;\n  transition: 0.5s;\n}\n.home-admin .certificates-home .certificates .certificate .data {\n  position: absolute;\n  z-index: -2;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.5s;\n  border-radius: 15px;\n}\n.home-admin .certificates-home .certificates .certificate .data .layout {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(rgba(0, 0, 0, 0) 70%, #413634 98%);\n  border-radius: 15px;\n}\n.home-admin .certificates-home .certificates .certificate .data .text {\n  position: absolute;\n  bottom: 25px;\n  font-weight: bold;\n  width: max-content;\n  color: #fff;\n  font-size: 18px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.home-admin .certificates-home .certificates .certificate:hover .image img {\n  transition: 0.5s;\n  transform: scale(1);\n}\n.home-admin .certificates-home .certificates .certificate:hover .data {\n  opacity: 1;\n  transition: opacity 0.5s;\n  top: 0;\n  z-index: 2;\n}\n.home-admin .certificates-home .effects {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n}\n.home-admin .certificates-home .effects .effect {\n  position: absolute;\n  z-index: 1;\n  background-color: #ffdead;\n  border-radius: 50%;\n}\n.home-admin .certificates-home .effects .effect.middle {\n  width: 400px;\n  height: 400px;\n  top: 56%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n}\n.home-admin .certificates-home .effects .effect.two {\n  width: 100px;\n  height: 100px;\n  bottom: -16%;\n  right: -32%;\n  transform: translateX(-50%) translateY(-50%);\n}\n.home-admin .directions-home {\n  width: calc(100% - 60px);\n  padding: 0 30px;\n  min-height: 650px;\n  height: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding-bottom: 50px;\n  padding-top: 20px;\n}\n.home-admin .directions-home .background {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  opacity: 0.2;\n  background: #fdf8f2;\n}\n.home-admin .directions-home .background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.home-admin .directions-home .head-title {\n  font-size: 50px;\n  font-weight: bold;\n  width: 100%;\n  position: relative;\n  margin-bottom: 30px;\n  z-index: 2;\n}\n.home-admin .directions-home .head-title .title {\n  font-weight: bold;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n.home-admin .directions-home .head-title .title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n  text-align: center;\n}\n.home-admin .directions-home .head-title .title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 100%;\n  z-index: 1;\n  background-color: #ffdead;\n  transform: translateX(-50%);\n}\n.home-admin .directions-home .head-title .add-icon {\n  position: absolute;\n  top: 22%;\n  left: 10%;\n  background-color: white;\n  z-index: 2;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: -11px;\n  z-index: 55555;\n}\n.home-admin .directions-home .head-title .add-icon:hover .img {\n  transition: 0.5s;\n  opacity: 1;\n}\n.home-admin .directions-home .head-title .info {\n  font-size: 21px;\n}\n.home-admin .directions-home .box {\n  position: relative;\n  z-index: 2;\n  width: 95%;\n  height: 86%;\n  background-color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-top: 40px;\n  box-shadow: rgba(99, 99, 99, 0.39) 0px 2px 13px 3px;\n}\n.home-admin .directions-home .box .direction {\n  display: flex;\n  flex-direction: column;\n  width: 230px;\n  height: 230px;\n  margin: 10px;\n  justify-content: center;\n  gap: 20px;\n  align-items: center;\n  font-weight: bold;\n  font-size: 18px;\n  position: relative;\n  transition: 0.5s;\n  background-color: #fff;\n}\n.home-admin .directions-home .box .direction:not(:last-of-type):after {\n  content: \"\";\n  left: 0;\n  position: absolute;\n  top: 50%;\n  width: 1px;\n  height: 80%;\n  background-color: #413634;\n  transform: translateY(-50%);\n  transition: 0.1s;\n}\n.home-admin .directions-home .box .direction:hover {\n  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 10px 4px, rgba(60, 64, 67, 0.15) 0px 1px 9px 4px;\n  transform: scale(1.05);\n  transition: 0.5s;\n  z-index: 3;\n}\n.home-admin .directions-home .box .direction:hover::after {\n  width: 0;\n  height: 0;\n  transition: 0.1s;\n}\n.home-admin .directions-home .box .direction .edit-icon,\n.home-admin .directions-home .box .direction .save-icon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #d0d0d0;\n  z-index: 2;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n}\n.home-admin .directions-home .box .direction .image {\n  width: 130px;\n  height: 130px;\n}\n.home-admin .directions-home .box .direction .image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n@media (max-width: 768px) {\n  .home-admin .directions-home {\n    flex-direction: column;\n    height: max-content;\n    width: calc(100% - 60px);\n  }\n  .home-admin .directions-home .head-title {\n    margin: 0 auto;\n    margin-top: 30px;\n    font-size: 20px;\n  }\n  .home-admin .directions-home .right,\n  .home-admin .directions-home .left {\n    width: 100%;\n    height: max-content;\n  }\n  .home-admin .directions-home .left {\n    height: 500px !important;\n  }\n  .home-admin .directions-home .left .effects {\n    width: 100%;\n  }\n  .home-admin .directions-home .left .effects .effect.one {\n    width: 350px;\n    height: 350px;\n    left: 3px !important;\n  }\n  .home-admin .directions-home .left .images {\n    margin-top: 37px;\n  }\n  .home-admin .directions-home .box {\n    width: 100%;\n    justify-content: space-between;\n    align-items: start;\n  }\n  .home-admin .directions-home .box:first-of-type .direction:before {\n    content: \"\";\n    left: -10px;\n    position: absolute;\n    top: 50%;\n    width: 1px;\n    height: 80%;\n    background-color: #413634;\n    transform: translateY(-50%);\n    transition: 0.1s;\n  }\n  .home-admin .directions-home .box .direction {\n    width: 48% !important;\n    margin: 0;\n  }\n  .home-admin .directions-home .box .direction::after {\n    display: none;\n  }\n}\n\n.social-admin {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 100dvh;\n  padding-top: 50px;\n  position: relative;\n  overflow-x: hidden;\n}\n.social-admin .background {\n  width: 100%;\n  height: 321px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  opacity: 0.2;\n  background: #fdf8f2;\n  background-repeat: no-repeat;\n  z-index: 0;\n}\n.social-admin .background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.social-admin .section {\n  display: flex;\n  width: 100%;\n  height: 700px;\n  position: relative;\n  z-index: 2;\n  flex-direction: column;\n  color: #000;\n  text-decoration: none;\n}\n.social-admin .section.spic {\n  background-color: #fcf2ec;\n}\n.social-admin .section .head-title {\n  font-size: 40px;\n  font-weight: bold;\n  width: max-content;\n  position: relative;\n  margin: 0 auto;\n  margin-bottom: 40px;\n  margin-top: 20px;\n}\n.social-admin .section .head-title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n}\n.social-admin .section .head-title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 104%;\n  transform: translateX(-50%);\n  z-index: 1;\n  background-color: #ffdead;\n}\n.social-admin .section .section-container {\n  width: 100%;\n  display: flex;\n  height: 100%;\n  justify-content: space-between;\n  color: #000;\n  text-decoration: none;\n}\n.social-admin .section .section-container .right {\n  width: calc(40% - 40px);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.social-admin .section .section-container .right .anthor-title {\n  font-weight: bold;\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.social-admin .section .section-container .right .anthor-title .title {\n  font-size: 40px;\n  position: relative;\n  width: max-content;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-right: 0 !important;\n}\n.social-admin .section .section-container .right .anthor-title .title span {\n  position: relative;\n  z-index: 2;\n  width: max-content;\n  color: #413634;\n}\n.social-admin .section .section-container .right .anthor-title .title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 104%;\n  transform: translateX(-50%);\n  z-index: 1;\n  background-color: #ffdead;\n}\n.social-admin .section .section-container .right .anthor-title .info {\n  color: #413634;\n  font-weight: bold;\n  margin: 5px 0;\n  width: 83%;\n  text-align: center;\n}\n.social-admin .section .section-container .right .location {\n  height: calc(100% - 100px);\n  width: calc(100% - 40px);\n  padding: 0 20px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin-top: 20px;\n}\n.social-admin .section .section-container .right .location .location {\n  width: 80%;\n  height: 80%;\n}\n.social-admin .section .section-container .right .location .location img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.social-admin .section .section-container .left {\n  width: calc(55% - 40px);\n  padding-left: 40px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n  position: relative;\n}\n.social-admin .section .section-container .left iframe {\n  width: 100%;\n  height: 80%;\n  border-radius: 10px;\n  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n}\n.social-admin .section .section-container .left .info {\n  width: 30%;\n  position: absolute;\n  height: 50px;\n  border-radius: 30px;\n  bottom: 15%;\n  left: 50%;\n  transform: translateX(-45%);\n  border: 1px solid #413634;\n  background-color: #fcf2ec;\n  font-size: 20px;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  color: #000;\n  text-decoration: none;\n}\n.social-admin .section .section-container .left .info a {\n  color: #000;\n  text-decoration: none;\n}\n.social-admin .section .section-container .left .info .icon {\n  position: absolute;\n  right: 10px;\n  width: 30px;\n  height: 30px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #000;\n  text-decoration: none;\n}\n.social-admin .section .simple-title {\n  font-size: 40px;\n  font-weight: bold;\n  width: max-content;\n  position: relative;\n  margin: 0 auto;\n  margin-bottom: 40px;\n  margin-top: 80px;\n}\n.social-admin .section .simple-title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n}\n.social-admin .section .simple-title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 104%;\n  transform: translateX(-50%);\n  z-index: 1;\n  background-color: #ffdead;\n}\n.social-admin .section .container {\n  display: flex;\n  width: 90%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  color: #000;\n  text-decoration: none;\n}\n.social-admin .section .container .contact {\n  width: 280px;\n  height: 280px;\n  display: flex;\n  flex-direction: column;\n  background-color: #fcf2ec;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-radius: 20px;\n  border: 1px solid transparent;\n  transition: 0.5s;\n  transform: scale(1);\n  color: #000;\n  text-decoration: none;\n}\n.social-admin .section .container .contact:hover {\n  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n  border: 1px solid #413634;\n  transform: scale(1.1);\n  transition: 0.5s;\n}\n.social-admin .section .container .contact .icon {\n  width: 100px;\n  height: 100px;\n  margin-top: 20px;\n}\n.social-admin .section .container .contact .title {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 40px;\n  width: 90%;\n  position: relative;\n  margin: 0 auto;\n  text-align: center;\n  color: #000;\n  text-decoration: none;\n}\n.social-admin .section .container .contact .title::before {\n  content: \"\";\n  bottom: -20px;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  border-radius: 10px;\n  background-color: #413634;\n}\n.social-admin .section .container .contact .value {\n  font-weight: normal;\n  font-size: 18px;\n  margin: 0 auto;\n  text-align: center;\n  color: #000;\n  text-decoration: none;\n}\n\n@media (max-width: 768px) {\n  .social-admin {\n    height: max-content;\n  }\n  .social-admin .background {\n    width: 100%;\n    height: 121px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    opacity: 0.2;\n    background: #fdf8f2;\n    background-repeat: no-repeat;\n    z-index: 0;\n  }\n  .social-admin .background img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  .social-admin .head-title {\n    display: none;\n    margin-bottom: 30px;\n  }\n  .social-admin .head-title .title {\n    margin-top: 10px;\n    margin-bottom: 30px;\n  }\n  .social-admin .right,\n  .social-admin .left {\n    width: 100% !important;\n    height: max-content !important;\n  }\n  .social-admin .tower .group {\n    margin-left: 30px;\n  }\n  .social-admin .left {\n    margin: 30px 0;\n  }\n  .social-admin .left iframe {\n    width: 100%;\n    margin: 0 auto;\n    height: 300px !important;\n    width: 90% !important;\n  }\n  .social-admin .left .info {\n    width: 52% !important;\n    position: absolute;\n    height: 50px;\n    border-radius: 30px;\n    bottom: -7% !important;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 1px solid #413634;\n    background-color: #fcf2ec;\n    font-size: 20px;\n    font-weight: bold;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n  }\n  .social-admin .section {\n    height: max-content !important;\n  }\n  .social-admin .section .section-container {\n    width: 100%;\n    display: flex;\n    height: max-content !important;\n    justify-content: space-between;\n    flex-direction: column;\n  }\n  .social-admin .section .section-container .anthor-title .title {\n    margin-right: 40px;\n    margin-top: 20px;\n  }\n  .social-admin .section .section-container .anthor-title .info {\n    width: max-content;\n    font-size: 12px;\n  }\n  .social-admin .section .section-container .location {\n    width: 100%;\n  }\n  .social-admin .section .container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 30px;\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n  .social-admin .section .container .contact {\n    width: calc(48% - 20px);\n    height: 185px;\n    margin-left: 10px;\n    margin-bottom: 10px;\n  }\n  .social-admin .section .container .contact .title {\n    font-size: 18px !important;\n  }\n  .social-admin .section .container .contact .title::before {\n    display: none;\n  }\n  .social-admin .section .container .contact .value {\n    font-size: 16px !important;\n  }\n}\n.services-admin {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 100dvh;\n  padding-top: 50px;\n  position: relative;\n  padding-bottom: 50px;\n}\n.services-admin .background {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  right: 0;\n  top: 0;\n  opacity: 0.1;\n  background: #fdf8f2;\n  background-repeat: no-repeat;\n  z-index: 0;\n}\n.services-admin .background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.services-admin .head-title {\n  font-size: 40px;\n  font-weight: bold;\n  width: max-content;\n  position: relative;\n  margin: 0 auto;\n  margin-bottom: 40px;\n  margin-top: 20px;\n  z-index: 2;\n}\n.services-admin .head-title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n}\n.services-admin .head-title .add-icon {\n  position: absolute;\n  top: 0%;\n  left: -35%;\n  background-color: rgb(255, 255, 255);\n  z-index: 2;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: -11px;\n  z-index: 55555;\n}\n.services-admin .head-title .add-icon:hover .img {\n  transition: 0.5s;\n  opacity: 1;\n}\n.services-admin .head-title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 104%;\n  transform: translateX(-50%);\n  z-index: 1;\n  background-color: #ffdead;\n}\n.services-admin .services-container {\n  width: 90%;\n  margin: 0 auto;\n  height: calc(100% - 240px);\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 30px;\n}\n.services-admin .services-container .service {\n  display: flex;\n  background-color: #fdf8f2;\n  width: 350px;\n  height: 520px;\n  border-radius: 10px;\n  flex-direction: column;\n  align-items: center;\n  transition: 0.5s;\n  border: 1px solid transparent;\n  position: relative;\n}\n.services-admin .services-container .service:hover {\n  transition: 0.5s;\n  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n  border: 1px solid #413634;\n}\n.services-admin .services-container .service .edit-icon,\n.services-admin .services-container .service .save-icon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #d0d0d0;\n  z-index: 2;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: 10px 0 0 0;\n}\n.services-admin .services-container .service .del-icon {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: #d0d0d0;\n  z-index: 2;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  width: 60px;\n  border-radius: 10px 0 0 0;\n}\n.services-admin .services-container .service .content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 90%;\n  flex-direction: column;\n  margin-bottom: 40px;\n  position: relative;\n}\n.services-admin .services-container .service .content::before {\n  content: \"\";\n  bottom: -20px;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  border-radius: 10px;\n  background-color: #413634;\n}\n.services-admin .services-container .service .content .icon {\n  width: 140px;\n  height: 140px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.services-admin .services-container .service .content .title {\n  font-size: 24px;\n  margin-top: 10px;\n  font-weight: bold;\n  color: #413634;\n}\n.services-admin .services-container .service .grouping {\n  display: flex;\n  width: 90%;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 30px;\n}\n.services-admin .services-container .service .grouping .info {\n  font-size: 16px;\n  line-height: 2;\n  text-align: center;\n  color: #525252;\n}\n.services-admin .services-container .service .grouping .images {\n  width: 50px;\n  height: 50px;\n  cursor: pointer;\n}\n.services-admin .services-container .service.spic {\n  background-color: transparent;\n}\n.services-admin .services-container .service.spic:hover {\n  transition: 0.5s;\n  box-shadow: none;\n  border: 1px solid transparent;\n}\n.services-admin .services-container .service.spic .content {\n  height: 150px;\n  background-color: #413634;\n  width: 100%;\n  margin-bottom: 10px;\n  border-radius: 10px;\n}\n.services-admin .services-container .service.spic .content::before {\n  display: none;\n}\n.services-admin .services-container .service.spic .content .title {\n  color: #fff;\n  margin-bottom: 10px;\n}\n.services-admin .services-container .service .service-container {\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  gap: 20px;\n  height: calc(100% - 150px);\n  width: 100%;\n}\n.services-admin .services-container .service .service-container .service-d {\n  width: 100%;\n  background-color: #fdf8f2;\n  border: 1px solid #413634;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: auto;\n  padding: 15px 0;\n  color: #000;\n  font-weight: bold;\n  cursor: pointer;\n  overflow: hidden;\n  transition: 0.5s;\n}\n.services-admin .services-container .service .service-container .service-d span {\n  width: 100%;\n  text-align: center;\n}\n.services-admin .services-container .service .service-container .service-d .icon {\n  width: 30px;\n  height: 30px;\n  position: relative;\n  left: -100%;\n  transition: 0.5s;\n}\n.services-admin .services-container .service .service-container .service-d:hover {\n  transition: 0.5s;\n  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n  border: 1px solid #413634;\n  width: 105%;\n}\n.services-admin .services-container .service .service-container .service-d:hover .icon {\n  left: 20px;\n  transition: 0.5s;\n}\n\n@media (max-width: 768px) {\n  .services-admin {\n    height: max-content;\n  }\n  .services-admin .background {\n    width: 100%;\n    height: 121px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    opacity: 0.2;\n    background: #fdf8f2;\n    background-repeat: no-repeat;\n    z-index: 0;\n  }\n  .services-admin .background img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  .services-admin .head-title {\n    margin-bottom: 30px;\n  }\n  .services-admin .head-title .title {\n    margin-top: 10px;\n    margin-bottom: 30px;\n  }\n  .services-admin .services-container {\n    height: max-content;\n    width: 100%;\n    flex-direction: column;\n    padding-bottom: 50px;\n    gap: 40px;\n  }\n  .services-admin .service {\n    width: 350px !important;\n    height: 450px !important;\n  }\n  .services-admin .service.spic .content {\n    height: max-content;\n  }\n  .services-admin .service.spic .content .icon {\n    width: 70px;\n    height: 70px;\n  }\n  .services-admin .service .info {\n    font-size: 13px !important;\n  }\n}\n.cases-admin {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 600px;\n  padding-top: 50px;\n  position: relative;\n}\n.cases-admin .head-title {\n  font-size: 40px;\n  font-weight: bold;\n  width: max-content;\n  position: relative;\n  margin: 0 auto;\n  margin-bottom: 40px;\n  margin-top: 20px;\n  z-index: 2;\n}\n.cases-admin .head-title span {\n  position: relative;\n  z-index: 2;\n  color: #413634;\n}\n.cases-admin .head-title::before {\n  content: \"\";\n  bottom: 5px;\n  position: absolute;\n  left: 50%;\n  height: 30px;\n  width: 104%;\n  transform: translateX(-50%);\n  z-index: 1;\n  background-color: #ffdead;\n}\n.cases-admin .boxes {\n  width: 90%;\n  margin: 0 auto;\n  height: 100%;\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  gap: 40px;\n  margin-top: 100px;\n}\n.cases-admin .boxes .box {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: #fdf8f2;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  width: 300px;\n  height: 300px;\n  gap: 30px;\n  cursor: pointer;\n  transition: 0.5s;\n  transform: scale(1);\n}\n.cases-admin .boxes .box:hover {\n  box-shadow: rgba(0, 0, 0, 0) 0px 1px 20px 8px, rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n  border: 1px solid #413634;\n  transform: scale(1.1);\n  transition: 0.5s;\n}\n.cases-admin .boxes .box .icon {\n  width: 150px;\n  height: 150px;\n}\n.cases-admin .boxes .box .title {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n@media (max-width: 768px) {\n  .cases-admin {\n    height: max-content;\n  }\n  .cases-admin .background {\n    width: 100%;\n    height: 121px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    opacity: 0.2;\n    background: #fdf8f2;\n    background-repeat: no-repeat;\n    z-index: 0;\n  }\n  .cases-admin .background img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  .cases-admin .head-title {\n    margin-bottom: 30px;\n  }\n  .cases-admin .head-title .title {\n    margin-top: 10px;\n    margin-bottom: 30px;\n  }\n  .cases-admin .boxes {\n    height: max-content;\n    width: 100%;\n    flex-direction: column;\n    padding-bottom: 50px;\n    gap: 40px;\n    align-items: center;\n  }\n  .cases-admin .boxes .box {\n    width: 250px;\n    height: 250px;\n  }\n}\n.login-page {\n  width: 100%;\n  min-height: 100dvb;\n  height: 100dvb;\n  max-height: 100dvb;\n  overflow: hidden;\n  background-color: #3e3e3e !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.login-page .background {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  left: 0;\n  z-index: 1;\n  bottom: 0;\n  cursor: pointer;\n}\n.login-page .background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  cursor: pointer;\n}\n.login-page .container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 90%;\n  position: relative;\n  z-index: 4;\n  height: 70%;\n}\n.login-page .container .login-box {\n  height: 100%;\n  width: 400px;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  gap: 10px;\n}\n.login-page .container .login-box.loading .head-box {\n  height: 80%;\n  flex-direction: column;\n  background-color: rgba(99, 255, 219, 0.444);\n  transition: 0.5s;\n}\n.login-page .container .login-box.loading .head-box .image {\n  width: 280px;\n  height: 280px;\n  margin-top: 20px;\n  transition: 0.5s;\n}\n.login-page .container .login-box.loading .box {\n  min-height: 10%;\n  padding-top: 10px;\n  transition: 0.5s;\n}\n.login-page .container .login-box.loading .box .group {\n  display: none;\n}\n.login-page .container .login-box.loading .box .head-title {\n  display: none;\n}\n.login-page .container .login-box .head-box {\n  height: 150px;\n  background: rgba(179, 179, 179, 0.25);\n  border-radius: 16px;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(6.3px);\n  -webkit-backdrop-filter: blur(6.3px);\n  border: 1px solid rgba(179, 179, 179, 0.42);\n  display: flex;\n  width: calc(100% - 40px);\n  justify-content: space-between;\n  padding: 0 20px;\n  align-items: center;\n  transition: 0.5s;\n}\n.login-page .container .login-box .head-box .image {\n  width: 120px;\n  height: 120px;\n  transition: 0.5s;\n}\n.login-page .container .login-box .head-box .image img {\n  width: 100%;\n  height: 100%;\n}\n.login-page .container .login-box .head-box .group {\n  width: calc(100% - 150px);\n  height: 85%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.login-page .container .login-box .head-box .group .title {\n  font-weight: bold;\n  position: relative;\n  font-size: 18px;\n  width: 100%;\n  text-align: center;\n  margin-bottom: 10px;\n}\n.login-page .container .login-box .head-box .group .title::after {\n  content: \"\";\n  bottom: -10px;\n  left: 0;\n  height: 1px;\n  background-color: #fff;\n  width: 100%;\n  position: absolute;\n}\n.login-page .container .login-box .head-box .info {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 15px;\n}\n.login-page .container .login-box .head-box .info .grouping {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  gap: 2px;\n  width: 48%;\n  height: 20px;\n}\n.login-page .container .login-box .head-box .info .grouping.spic {\n  justify-content: end;\n}\n.login-page .container .login-box .head-box .info .grouping.spic .value {\n  direction: ltr;\n}\n.login-page .container .login-box .head-box .info .grouping .icon {\n  width: 20px;\n  height: 20px;\n}\n.login-page .container .login-box .head-box .info .grouping .title {\n  font-size: 14px;\n  width: calc(100% - 20px);\n}\n.login-page .container .login-box .box {\n  min-height: calc(96% - 180px);\n  height: max-content;\n  background: rgba(179, 179, 179, 0.25);\n  border-radius: 16px;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(6.3px);\n  -webkit-backdrop-filter: blur(6.3px);\n  border: 1px solid rgba(179, 179, 179, 0.42);\n  width: calc(100% - 40px);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0 20px;\n  gap: 40px;\n  align-items: center;\n  padding-bottom: 20px;\n  transition: 0.5s;\n}\n.login-page .container .login-box .box .head-title {\n  font-size: 24px;\n  font-weight: bold;\n  margin: 20px 0 10px;\n}\n.login-page .container .login-box .box .group {\n  height: 40%;\n  width: 90%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  flex-direction: column;\n}\n.login-page .container .login-box .box .group input {\n  width: 100%;\n  outline: none;\n  border: 1px solid #3e3e3e;\n  background-color: #fff;\n  height: 50px;\n  border-radius: 10px;\n  text-align: center;\n}\n.login-page .container .login-box .box .login-btn {\n  width: 90%;\n  height: 40px;\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  padding: 10px 0;\n  align-items: center;\n  background-color: #ffc73d;\n  color: #000;\n  font-weight: bold;\n  font-size: 18px;\n  cursor: pointer;\n  margin-bottom: 6px;\n}\n.login-page .container .left {\n  height: 100%;\n  width: 280px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: column;\n}\n.login-page .container .left .group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n.login-page .container .left .group .company-name {\n  height: 80px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  text-transform: uppercase;\n  color: #fff;\n  font-size: 24px;\n  direction: ltr;\n}\n.login-page .container .left .group .logo {\n  width: 100%;\n  height: 200px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.login-page .container .left .group .logo img {\n  width: 90%;\n  height: 90%;\n  object-fit: contain;\n}\n.login-page .container .left .copyright {\n  height: 80px;\n  display: flex;\n  justify-content: center;\n  align-items: start;\n  gap: 10px;\n  padding-left: 10px;\n  font-weight: bold;\n  text-transform: uppercase;\n  flex-direction: column;\n  width: 379px;\n  position: relative;\n  left: 50px;\n  direction: ltr;\n}\n.login-page .container .left .copyright .title {\n  font-size: 24px;\n  margin-bottom: -10px;\n}\n.login-page .container .left .copyright .info {\n  font-size: 14px;\n  font-weight: 600;\n}\n.login-page .container .left .box {\n  background: rgba(179, 179, 179, 0.25);\n  border-radius: 16px;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(6.3px);\n  -webkit-backdrop-filter: blur(6.3px);\n  border: 1px solid rgba(179, 179, 179, 0.42);\n}\n\n@media (max-width: 768px) {\n  .login-page {\n    align-items: start;\n    gap: 40px;\n  }\n  .login-page .container {\n    margin-top: 50px;\n    display: flex;\n    flex-direction: column;\n    width: 90%;\n    justify-content: space-between;\n    gap: 40px;\n    height: 100%;\n  }\n  .login-page .container .head-box .value {\n    font-size: 10px;\n    font-weight: bold;\n  }\n  .login-page .container .login-box {\n    width: 100%;\n    gap: 10px;\n    height: 67%;\n  }\n  .login-page .container .login-box .box {\n    height: calc(100% - 90px);\n  }\n  .login-page .container .left {\n    width: 100%;\n    height: 27%;\n  }\n  .login-page .container .left .group {\n    flex-direction: row;\n    width: 100%;\n    align-items: flex-end;\n    justify-content: flex-end;\n  }\n  .login-page .container .left .group .copyright {\n    width: calc(100% - 120px);\n    left: 0;\n    height: 60px;\n  }\n  .login-page .container .left .group .copyright .title {\n    font-size: 18px;\n  }\n  .login-page .container .left .group .copyright .info {\n    font-size: 12px;\n  }\n  .login-page .container .left .group .logo {\n    width: 120px;\n    height: 120px;\n  }\n}",".service-info {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n  }\n  .container {\n    width: 500px;\n    height: 700px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    .section {\n      position: relative;\n      overflow: hidden;\n      border-radius: 20px;\n\n      &:hover {\n        .image {\n          img {\n            filter: grayscale(0%);\n            transition: 0.5s;\n          }\n        }\n        .data {\n          left: 0;\n          opacity: 1;\n          transition: opacity 0.5s;\n        }\n      }\n      .data.active {\n        left: 0;\n        opacity: 1;\n        transition: opacity 0.5s;\n      }\n      .image.active {\n        img {\n          filter: grayscale(0%);\n          transition: 0.5s;\n        }\n      }\n      .image {\n        width: 100%;\n        height: 100%;\n        border-radius: 20px;\n        overflow: hidden;\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          filter: grayscale(100%);\n          transition: 0.5s;\n        }\n      }\n      .data {\n        position: absolute;\n        top: 0;\n        opacity: 0;\n        transition: opacity 0.5s;\n        height: calc(100% - 20px);\n        width: calc(100% - 20px);\n        background: linear-gradient(#00000000 50%, #413634 98%);\n        display: flex;\n        flex-direction: column;\n        justify-content: end;\n        align-items: center;\n        padding: 10px;\n        border-radius: 20px;\n\n        color: #fff;\n        left: -100%;\n\n        .title {\n          font-size: 18px;\n          font-weight: bold;\n          margin-bottom: 20px;\n          position: relative;\n          &::before {\n            content: \"\";\n            width: 100%;\n            height: 1px;\n            background-color: #fff;\n            position: absolute;\n            left: 50%;\n            transform: translateX(-50%);\n            bottom: -10px;\n          }\n        }\n        .desc {\n          font-size: 14px;\n          text-align: center;\n        }\n      }\n    }\n  }\n}\n.image-info {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n  }\n  .container {\n    width: 90%;\n    height: 70%;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    .section {\n      width: 100%;\n      height: 100%;\n      position: relative;\n      overflow: hidden;\n      border-radius: 20px;\n\n      &:hover {\n        .image {\n          img {\n            filter: grayscale(0%);\n            transition: 0.5s;\n          }\n        }\n        .data {\n          left: 0;\n          opacity: 1;\n          transition: opacity 0.5s;\n        }\n      }\n\n      .image {\n        width: 100%;\n        height: 100%;\n        border-radius: 20px;\n        overflow: hidden;\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          filter: grayscale(100%);\n          transition: 0.5s;\n        }\n      }\n      .data {\n        position: absolute;\n        top: 0;\n        opacity: 0;\n        transition: opacity 0.5s;\n        height: calc(100% - 20px);\n        width: calc(100% - 20px);\n        background: linear-gradient(#00000000 50%, #413634 98%);\n        display: flex;\n        flex-direction: column;\n        justify-content: end;\n        align-items: start;\n        padding: 10px;\n        border-radius: 20px;\n\n        color: #fff;\n        left: -100%;\n\n        .title {\n          font-size: 18px;\n          font-weight: bold;\n          margin-bottom: 20px;\n          position: relative;\n          margin-right: 30px;\n        }\n      }\n    }\n  }\n}\n.video-info {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n  }\n  .container {\n    width: 90%;\n    height: 70%;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    .section {\n      width: 100%;\n      height: 100%;\n      position: relative;\n      overflow: hidden;\n      border-radius: 20px;\n\n      &:hover {\n        .image {\n          img {\n            filter: grayscale(0%);\n            transition: 0.5s;\n          }\n        }\n        .data {\n          left: 0;\n          opacity: 1;\n          transition: opacity 0.5s;\n        }\n      }\n\n      .image {\n        width: 100%;\n        height: 100%;\n        border-radius: 20px;\n        overflow: hidden;\n        video {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          transition: 0.5s;\n        }\n      }\n      .data {\n        position: absolute;\n        top: 0;\n        opacity: 0;\n        transition: opacity 0.5s;\n        height: calc(100% - 20px);\n        width: calc(100% - 20px);\n        background: linear-gradient(#00000000 50%, #413634 98%);\n        display: flex;\n        flex-direction: column;\n        justify-content: end;\n        align-items: start;\n        padding: 10px;\n        border-radius: 20px;\n\n        color: #fff;\n        left: -100%;\n\n        .title {\n          font-size: 18px;\n          font-weight: bold;\n          margin-bottom: 20px;\n          position: relative;\n          margin-right: 30px;\n        }\n      }\n    }\n  }\n}\n.cases-info {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n  }\n  .container {\n    width: 90%;\n    max-width: 600px;\n    height: 85%;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    max-height: 85%;\n\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    flex-direction: column;\n    background-color: #f6f1ea;\n    border-radius: 20px;\n    .image {\n      width: 90%;\n      height: 220px !important;\n      border-radius: 20px;\n      position: relative;\n      overflow: hidden;\n      margin: 20px auto 0;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        transition: 0.5s;\n      }\n      .title {\n        position: absolute;\n        left: 0;\n        top: 00;\n        background: linear-gradient(#00000000 50%, #413634 98%);\n        color: #fff;\n        font-weight: bold;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: end;\n        padding-bottom: 10px;\n      }\n    }\n    .texts {\n      height: calc(100% - 260px);\n      display: flex;\n      flex-direction: column;\n      overflow-x: hidden;\n      overflow-y: scroll;\n      margin: 20px auto 0;\n      padding-bottom: 20px;\n      width: calc(100% - 60px);\n      gap: 10px;\n      .text {\n        width: 100%;\n        color: #413634;\n        font-size: 12px;\n        font-weight: bold;\n        position: relative;\n        padding-right: 30px;\n        width: calc(100% - 29px);\n        &::before {\n          content: url(\"./info.svg\");\n          position: absolute;\n          top: 13px;\n          right: 0;\n          transform: translateY(-50%);\n          width: 18px; /* Width of your SVG */\n          height: 18px; /* Height of your SVG */\n        }\n      }\n    }\n  }\n}\n@media (max-width: 768px) {\n  .service-info {\n    .container {\n      width: 300px;\n      height: 500px;\n    }\n  }\n}\n",".header {\n  width: 100%;\n  height: 60px;\n  background-color: #413634;\n  position: fixed;\n  z-index: 6666;\n  top: 0;\n  left: 0;\n  color: #c7c7c7;\n  display: flex;\n  justify-content: space-evenly;\n  gap: 10px;\n  .link {\n    width: max-content;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    color: #c7c7c7;\n    align-items: center;\n    text-decoration: none;\n    font-size: 18px;\n    transition: 0.5s;\n\n    &.active,\n    &:hover {\n      transition: 0.5s;\n      color: #fff;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .header {\n    width: 100%;\n\n    .link {\n      font-size: 12px;\n    }\n  }\n}\n",".footer {\n  width: 100%;\n  height: 400px;\n  background-color: #413634;\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n  .head-title {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 40px;\n    font-size: 18px;\n    font-weight: bold;\n    margin: 10px 0;\n    color: #fff;\n  }\n\n  .container {\n    width: 100%;\n    height: calc(100% - 60px);\n    display: flex;\n    justify-content: space-between;\n    .group {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      width: 30%;\n      height: 100%;\n      align-items: center;\n      gap: 20px;\n      position: relative;\n      &:not(:last-of-type)::after {\n        content: \"\";\n        left: -20px;\n        position: absolute;\n        top: 50%;\n        border-radius: 10px;\n        width: 2px;\n        height: 80%;\n        background-color: #707070;\n        transform: translateY(-50%);\n        transition: 0.1s;\n      }\n      .logo {\n        width: 150px;\n        height: 150px;\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: contain;\n        }\n      }\n      .grouping {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        color: #fff;\n        .title {\n          font-size: 32px;\n          font-weight: bold;\n        }\n        .name {\n          font-size: 22px;\n          font-weight: 600;\n        }\n      }\n\n      .section {\n        width: 100%;\n        display: flex;\n        gap: 10px;\n        height: max-content;\n        justify-content: space-between;\n        align-items: center;\n\n        .icon {\n          height: 30px;\n          width: 30px;\n        }\n        .section-grouping {\n          display: flex;\n          flex-direction: column;\n          color: #fff;\n          height: 100%;\n          width: calc(98% - 40px);\n          .value {\n            font-weight: bold;\n            font-size: 12px;\n          }\n        }\n      }\n      .copyright {\n        width: 105%;\n        height: 60px;\n        background-color: #fff;\n        border: 1px solid #000;\n        position: relative;\n        left: -15%;\n        padding: 10px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        direction: ltr;\n        gap: 20px;\n        .grouping2 {\n          display: flex;\n          flex-direction: column;\n        }\n        .title {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n        .value {\n          font-weight: bold;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .footer {\n    .container {\n      .group {\n        gap: 40px;\n        padding: 0 10px;\n        width: calc(100% - 20px);\n        &:first-of-type {\n          display: none;\n        }\n        &:last-of-type {\n          display: none;\n        }\n      }\n    }\n  }\n}\n",".certificate-add-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 88888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n    left: 00;\n    top: 0;\n  }\n  .container {\n    width: 90%;\n    max-width: 600px;\n    height: max-content !important;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    flex-direction: column;\n    background-color: #f6f1ea;\n    border-radius: 20px;\n    justify-content: center;\n    align-items: center;\n    .title {\n      font-size: 24px;\n      font-weight: bold;\n    }\n    .image {\n      width: 90%;\n      height: 320px;\n      border-radius: 20px;\n      position: relative;\n      overflow: hidden;\n      margin: 20px auto 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      &.none {\n        width: 100px;\n        height: 100px;\n        cursor: pointer;\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          transition: 0.5s;\n        }\n      }\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        transition: 0.5s;\n      }\n      .title {\n        position: absolute;\n        left: 0;\n        top: 00;\n        background: linear-gradient(#00000000 50%, #413634 98%);\n        color: #fff;\n        font-weight: bold;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: end;\n        padding-bottom: 10px;\n      }\n    }\n    .text {\n      width: 95%;\n      height: max-content;\n      display: flex;\n      flex-direction: column;\n      margin: 10px 0;\n      padding-bottom: 10px;\n      gap: 10px;\n      justify-content: center;\n      align-items: center;\n      input {\n        width: 90%;\n        color: #413634;\n        font-size: 15px;\n        height: 40px;\n        border-radius: 10px;\n        outline: none;\n        border: 1px solid #413634;\n        font-weight: bold;\n        position: relative;\n        padding-right: 30px;\n      }\n    }\n    .add-btn {\n      width: 90%;\n      height: 40px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 20px;\n      font-weight: bold;\n      cursor: pointer;\n      border-radius: 10px;\n      margin-bottom: 10px;\n      background-color: #2ecc71;\n    }\n  }\n}\n.direction-add-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 88888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n    left: 00;\n    top: 0;\n  }\n  .container {\n    width: 90%;\n    max-width: 600px;\n    height: max-content !important;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    flex-direction: column;\n    background-color: #f6f1ea;\n    border-radius: 20px;\n    justify-content: center;\n    align-items: center;\n    .title {\n      font-size: 24px;\n      font-weight: bold;\n    }\n    .group {\n      width: 100%;\n      display: flex;\n      justify-content: space-between;\n      height: 320px;\n      margin-bottom: 20px;\n\n      .image {\n        width: 48%;\n        min-height: 320px;\n        border-radius: 20px;\n        position: relative;\n        overflow: hidden;\n        margin: 20px auto 0;\n        display: flex;\n        align-items: center;\n        gap: 50px;\n        flex-direction: column;\n        label {\n          width: 100%;\n          height: 320px;\n          display: flex;\n          flex-direction: column;\n          gap: 10px;\n          justify-content: center;\n          align-items: center;\n          img {\n            &.none {\n              width: 120px;\n              height: 120px;\n              object-fit: contain;\n            }\n            width: 270px;\n            height: 270px;\n            object-fit: contain;\n            transition: 0.5s;\n          }\n          .title {\n            position: relative;\n            left: 0;\n            top: 00;\n            color: #000;\n            font-weight: bold;\n            width: 100%;\n            display: flex;\n            justify-content: center;\n            align-items: end;\n          }\n        }\n      }\n    }\n    .text {\n      width: 95%;\n      height: max-content;\n      display: flex;\n      flex-direction: column;\n      margin: 10px 0;\n      padding-bottom: 10px;\n      gap: 10px;\n      justify-content: center;\n      align-items: center;\n      input,\n      textarea {\n        resize: none;\n        width: 90%;\n        color: #413634;\n        font-size: 15px;\n        height: 40px;\n        border-radius: 10px;\n        outline: none;\n        border: 1px solid #413634;\n        font-weight: bold;\n        position: relative;\n        padding-right: 30px;\n      }\n      textarea {\n        height: 150px;\n      }\n    }\n    .add-btn {\n      width: 90%;\n      height: 40px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 20px;\n      font-weight: bold;\n      cursor: pointer;\n      border-radius: 10px;\n      margin-bottom: 10px;\n      background-color: #2ecc71;\n    }\n  }\n}\n.direction-edit-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 88888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n    left: 00;\n    top: 0;\n  }\n  .container {\n    width: 90%;\n    max-width: 600px;\n    height: max-content !important;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    flex-direction: column;\n    background-color: #f6f1ea;\n    border-radius: 20px;\n    justify-content: center;\n    align-items: center;\n    .title {\n      font-size: 24px;\n      font-weight: bold;\n    }\n    .group {\n      width: 100%;\n      display: flex;\n      justify-content: space-between;\n      height: 320px;\n      margin-bottom: 20px;\n\n      .image {\n        width: 48%;\n        min-height: 320px;\n        border-radius: 20px;\n        position: relative;\n        overflow: hidden;\n        margin: 20px auto 0;\n        display: flex;\n        align-items: center;\n        gap: 50px;\n        flex-direction: column;\n        label {\n          width: 100%;\n          height: 320px;\n          display: flex;\n          flex-direction: column;\n          gap: 10px;\n          justify-content: center;\n          align-items: center;\n          img {\n            &.none {\n              width: 120px;\n              height: 120px;\n              object-fit: contain;\n            }\n            width: 270px;\n            height: 270px;\n            object-fit: contain;\n            transition: 0.5s;\n          }\n          .title {\n            position: relative;\n            left: 0;\n            top: 00;\n            color: #000;\n            font-weight: bold;\n            width: 100%;\n            display: flex;\n            justify-content: center;\n            align-items: end;\n          }\n        }\n      }\n    }\n    .text {\n      width: 95%;\n      height: max-content;\n      display: flex;\n      flex-direction: column;\n      margin: 10px 0;\n      padding-bottom: 10px;\n      gap: 10px;\n      justify-content: center;\n      align-items: center;\n      input,\n      textarea {\n        resize: none;\n        width: 90%;\n        color: #413634;\n        font-size: 15px;\n        height: 40px;\n        border-radius: 10px;\n        outline: none;\n        border: 1px solid #413634;\n        font-weight: bold;\n        position: relative;\n        padding-right: 30px;\n      }\n      textarea {\n        height: 150px;\n      }\n    }\n    .add-btn {\n      width: 90%;\n      height: 40px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 20px;\n      font-weight: bold;\n      cursor: pointer;\n      border-radius: 10px;\n      margin-bottom: 10px;\n      background-color: #2ecc71;\n    }\n  }\n}\n.service-add-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 88888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n    left: 00;\n    top: 0;\n  }\n  .container {\n    width: 90%;\n    max-width: 600px;\n    height: max-content !important;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    flex-direction: column;\n    background-color: #f6f1ea;\n    border-radius: 20px;\n    justify-content: center;\n    align-items: center;\n    .title {\n      font-size: 24px;\n      font-weight: bold;\n    }\n\n    .text {\n      width: 95%;\n      height: max-content;\n      display: flex;\n      flex-direction: column;\n      margin: 10px 0;\n      padding-bottom: 10px;\n      gap: 10px;\n      justify-content: center;\n      align-items: center;\n      input,\n      textarea {\n        resize: none;\n        width: 90%;\n        color: #413634;\n        font-size: 15px;\n        height: 40px;\n        border-radius: 10px;\n        outline: none;\n        border: 1px solid #413634;\n        font-weight: bold;\n        position: relative;\n        padding-right: 30px;\n      }\n      textarea {\n        height: 150px;\n      }\n    }\n    .add-btn {\n      width: 90%;\n      height: 40px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 20px;\n      font-weight: bold;\n      cursor: pointer;\n      border-radius: 10px;\n      margin-bottom: 10px;\n      background-color: #2ecc71;\n    }\n  }\n}\n.service-edit-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 88888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n    left: 00;\n    top: 0;\n  }\n  .container {\n    width: 90%;\n    max-width: 600px;\n    height: max-content !important;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    flex-direction: column;\n    background-color: #f6f1ea;\n    border-radius: 20px;\n    justify-content: center;\n    align-items: center;\n    .title {\n      font-size: 24px;\n      font-weight: bold;\n    }\n\n    .text {\n      width: 95%;\n      height: max-content;\n      display: flex;\n      flex-direction: column;\n      margin: 10px 0;\n      padding-bottom: 10px;\n      gap: 10px;\n      justify-content: center;\n      align-items: center;\n      input,\n      textarea {\n        resize: none;\n        width: 90%;\n        color: #413634;\n        font-size: 15px;\n        height: 40px;\n        border-radius: 10px;\n        outline: none;\n        border: 1px solid #413634;\n        font-weight: bold;\n        position: relative;\n        padding-right: 30px;\n      }\n      textarea {\n        height: 150px;\n      }\n    }\n    .add-btn {\n      width: 90%;\n      height: 40px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 20px;\n      font-weight: bold;\n      cursor: pointer;\n      border-radius: 10px;\n      margin-bottom: 10px;\n      background-color: #2ecc71;\n    }\n  }\n}\n\n.service-info-admin {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n  }\n  .add-icon {\n    position: fixed;\n    top: 7%;\n    left: 31%;\n    background-color: rgb(255 255 255);\n    z-index: 8899;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 60px;\n    width: 60px;\n    border-radius: -11px;\n    &:hover {\n      .img {\n        transition: 0.5s;\n        opacity: 1;\n      }\n    }\n  }\n  .container {\n    width: 500px;\n    height: 700px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    .section {\n      position: relative;\n      overflow: hidden;\n      border-radius: 20px;\n\n      &:hover {\n        .image {\n          img {\n            filter: grayscale(0%);\n            transition: 0.5s;\n          }\n        }\n        .data {\n          left: 0;\n          opacity: 1;\n          transition: opacity 0.5s;\n        }\n      }\n      .data.active {\n        left: 0;\n        opacity: 1;\n        transition: opacity 0.5s;\n      }\n      .image.active {\n        img {\n          filter: grayscale(0%);\n          transition: 0.5s;\n        }\n      }\n      .image {\n        width: 100%;\n        height: 100%;\n        border-radius: 20px;\n        overflow: hidden;\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          filter: grayscale(100%);\n          transition: 0.5s;\n        }\n      }\n      .data {\n        position: absolute;\n        top: 0;\n        opacity: 0;\n        transition: opacity 0.5s;\n        height: calc(100% - 20px);\n        width: calc(100% - 20px);\n        background: linear-gradient(#00000000 50%, #413634 98%);\n        display: flex;\n        flex-direction: column;\n        justify-content: end;\n        align-items: center;\n        padding: 10px;\n        border-radius: 20px;\n\n        color: #fff;\n        left: -100%;\n\n        .title {\n          font-size: 18px;\n          font-weight: bold;\n          margin-bottom: 20px;\n          position: relative;\n          &::before {\n            content: \"\";\n            width: 100%;\n            height: 1px;\n            background-color: #fff;\n            position: absolute;\n            left: 50%;\n            transform: translateX(-50%);\n            bottom: -10px;\n          }\n        }\n        .desc {\n          font-size: 14px;\n          text-align: center;\n        }\n      }\n    }\n    .del-icon {\n      position: absolute;\n      top: 0;\n      right: 0;\n      background-color: #d0d0d0;\n      z-index: 2;\n      cursor: pointer;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 60px;\n      width: 60px;\n      border-radius: 10px 0 0 0;\n    }\n    .edit-icon,\n    .save-icon {\n      position: absolute;\n      top: 0;\n      left: 0;\n      background-color: #d0d0d0;\n      z-index: 2;\n      cursor: pointer;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 60px;\n      width: 60px;\n      border-radius: 10px 0 0 0;\n    }\n  }\n}\n.service-images-add-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n  }\n  .add-icon {\n    position: absolute;\n    top: 0%;\n    left: 0;\n    background-color: rgb(255 255 255);\n    z-index: 8899;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 60px;\n    width: 60px;\n    border-radius: -11px;\n    &:hover {\n      .img {\n        transition: 0.5s;\n        opacity: 1;\n      }\n    }\n  }\n  .container {\n    width: 90%;\n    max-width: 600px;\n    height: max-content !important;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    flex-direction: column;\n    background-color: #f6f1ea;\n    border-radius: 20px;\n    justify-content: center;\n    align-items: center;\n    .title {\n      font-size: 24px;\n      font-weight: bold;\n    }\n    .image {\n      width: 90%;\n      height: 320px;\n      border-radius: 20px;\n      position: relative;\n      overflow: hidden;\n      margin: 20px auto 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      &.none {\n        width: 100px;\n        height: 100px;\n        cursor: pointer;\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          transition: 0.5s;\n        }\n      }\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        transition: 0.5s;\n      }\n      .title {\n        position: absolute;\n        left: 0;\n        top: 00;\n        background: linear-gradient(#00000000 50%, #413634 98%);\n        color: #fff;\n        font-weight: bold;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: end;\n        padding-bottom: 10px;\n      }\n    }\n    .text {\n      width: 95%;\n      height: max-content;\n      display: flex;\n      flex-direction: column;\n      margin: 10px 0;\n      padding-bottom: 10px;\n      gap: 10px;\n      justify-content: center;\n      align-items: center;\n      textarea {\n        width: 90%;\n        color: #413634;\n        font-size: 15px;\n        height: 200px;\n        border-radius: 10px;\n        outline: none;\n        border: 1px solid #413634;\n        font-weight: bold;\n        position: relative;\n        padding-right: 30px;\n        resize: none;\n      }\n    }\n    .add-btn {\n      width: 90%;\n      height: 40px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 20px;\n      font-weight: bold;\n      cursor: pointer;\n      border-radius: 10px;\n      margin-bottom: 10px;\n      background-color: #2ecc71;\n    }\n  }\n}\n.service-images-edit-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n  }\n  .add-icon {\n    position: absolute;\n    top: 0%;\n    left: 0;\n    background-color: rgb(255 255 255);\n    z-index: 8899;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 60px;\n    width: 60px;\n    border-radius: -11px;\n    &:hover {\n      .img {\n        transition: 0.5s;\n        opacity: 1;\n      }\n    }\n  }\n  .container {\n    width: 90%;\n    max-width: 600px;\n    height: max-content !important;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    flex-direction: column;\n    background-color: #f6f1ea;\n    border-radius: 20px;\n    justify-content: center;\n    align-items: center;\n    .title {\n      font-size: 24px;\n      font-weight: bold;\n    }\n    .image {\n      width: 90%;\n      height: 320px;\n      border-radius: 20px;\n      position: relative;\n      overflow: hidden;\n      margin: 20px auto 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      &.none {\n        width: 100px;\n        height: 100px;\n        cursor: pointer;\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          transition: 0.5s;\n        }\n      }\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        transition: 0.5s;\n      }\n      .title {\n        position: absolute;\n        left: 0;\n        top: 00;\n        background: linear-gradient(#00000000 50%, #413634 98%);\n        color: #fff;\n        font-weight: bold;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: end;\n        padding-bottom: 10px;\n      }\n    }\n    .text {\n      width: 95%;\n      height: max-content;\n      display: flex;\n      flex-direction: column;\n      margin: 10px 0;\n      padding-bottom: 10px;\n      gap: 10px;\n      justify-content: center;\n      align-items: center;\n      textarea {\n        width: 90%;\n        color: #413634;\n        font-size: 15px;\n        height: 200px;\n        border-radius: 10px;\n        outline: none;\n        border: 1px solid #413634;\n        font-weight: bold;\n        position: relative;\n        padding-right: 30px;\n        resize: none;\n      }\n    }\n    .add-btn {\n      width: 90%;\n      height: 40px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 20px;\n      font-weight: bold;\n      cursor: pointer;\n      border-radius: 10px;\n      margin-bottom: 10px;\n      background-color: #2ecc71;\n    }\n  }\n}\n\n.image-info-admin {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n  }\n  .add-icon {\n    position: absolute;\n    top: 5%;\n    left: 5%;\n    background-color: rgb(255 255 255);\n    z-index: 8899;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 60px;\n    width: 60px;\n    border-radius: -11px;\n    &:hover {\n      .img {\n        transition: 0.5s;\n        opacity: 1;\n      }\n    }\n  }\n\n  .container {\n    width: 90%;\n    height: 70%;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n\n    .section {\n      width: 100%;\n      height: 100%;\n      position: relative;\n      overflow: hidden;\n      border-radius: 20px;\n\n      &:hover {\n        .image {\n          img {\n            filter: grayscale(0%);\n            transition: 0.5s;\n          }\n        }\n        .data {\n          left: 0;\n          opacity: 1;\n          transition: opacity 0.5s;\n        }\n      }\n      .del-icon {\n        position: absolute;\n        top: 0;\n        left: 0;\n        background-color: #d0d0d0;\n        z-index: 2;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 60px;\n        width: 60px;\n        border-radius: 10px 0 0 0;\n      }\n      .image {\n        width: 100%;\n        height: 100%;\n        border-radius: 20px;\n        overflow: hidden;\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          filter: grayscale(100%);\n          transition: 0.5s;\n        }\n      }\n      .data {\n        position: absolute;\n        top: 0;\n        opacity: 0;\n        transition: opacity 0.5s;\n        height: calc(100% - 20px);\n        width: calc(100% - 20px);\n        background: linear-gradient(#00000000 50%, #413634 98%);\n        display: flex;\n        flex-direction: column;\n        justify-content: end;\n        align-items: start;\n        padding: 10px;\n        border-radius: 20px;\n\n        color: #fff;\n        left: -100%;\n\n        .title {\n          font-size: 18px;\n          font-weight: bold;\n          margin-bottom: 20px;\n          position: relative;\n          margin-right: 30px;\n        }\n      }\n    }\n  }\n}\n.images-add-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n  }\n  .add-icon {\n    position: absolute;\n    top: 0%;\n    left: 0;\n    background-color: rgb(255 255 255);\n    z-index: 8899;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 60px;\n    width: 60px;\n    border-radius: -11px;\n    &:hover {\n      .img {\n        transition: 0.5s;\n        opacity: 1;\n      }\n    }\n  }\n  .container {\n    width: 90%;\n    max-width: 600px;\n    height: max-content !important;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    flex-direction: column;\n    background-color: #f6f1ea;\n    border-radius: 20px;\n    justify-content: center;\n    align-items: center;\n    .title {\n      font-size: 24px;\n      font-weight: bold;\n    }\n    .image {\n      width: 90%;\n      height: 320px;\n      border-radius: 20px;\n      position: relative;\n      overflow: hidden;\n      margin: 20px auto 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      &.none {\n        width: 100px;\n        height: 100px;\n        cursor: pointer;\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          transition: 0.5s;\n        }\n      }\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        transition: 0.5s;\n      }\n      .title {\n        position: absolute;\n        left: 0;\n        top: 00;\n        background: linear-gradient(#00000000 50%, #413634 98%);\n        color: #fff;\n        font-weight: bold;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: end;\n        padding-bottom: 10px;\n      }\n    }\n    .text {\n      width: 95%;\n      height: max-content;\n      display: flex;\n      flex-direction: column;\n      margin: 10px 0;\n      padding-bottom: 10px;\n      gap: 10px;\n      justify-content: center;\n      align-items: center;\n      input {\n        width: 90%;\n        color: #413634;\n        font-size: 15px;\n        height: 50px;\n        border-radius: 10px;\n        outline: none;\n        border: 1px solid #413634;\n        font-weight: bold;\n        position: relative;\n        padding-right: 30px;\n        resize: none;\n      }\n    }\n    .add-btn {\n      width: 90%;\n      height: 40px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 20px;\n      font-weight: bold;\n      cursor: pointer;\n      border-radius: 10px;\n      margin-bottom: 10px;\n      background-color: #2ecc71;\n    }\n  }\n}\n\n.video-info-admin {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n  }\n  .add-icon {\n    position: absolute;\n    top: 5%;\n    left: 5%;\n    background-color: rgb(255 255 255);\n    z-index: 8899;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 60px;\n    width: 60px;\n    border-radius: -11px;\n    &:hover {\n      .img {\n        transition: 0.5s;\n        opacity: 1;\n      }\n    }\n  }\n\n  .container {\n    width: 90%;\n    height: 70%;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n\n    .section {\n      width: 100%;\n      height: 100%;\n      position: relative;\n      overflow: hidden;\n      border-radius: 20px;\n\n      &:hover {\n        .image {\n          img {\n            filter: grayscale(0%);\n            transition: 0.5s;\n          }\n        }\n        .data {\n          left: 0;\n          opacity: 1;\n          transition: opacity 0.5s;\n        }\n      }\n      .del-icon {\n        position: absolute;\n        top: 0;\n        left: 0;\n        background-color: #d0d0d0;\n        z-index: 2;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 60px;\n        width: 60px;\n        border-radius: 10px 0 0 0;\n      }\n      .image {\n        width: 100%;\n        height: 100%;\n        border-radius: 20px;\n        overflow: hidden;\n        img,\n        video {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          filter: grayscale(100%);\n          transition: 0.5s;\n        }\n      }\n      .data {\n        position: absolute;\n        top: 0;\n        opacity: 0;\n        transition: opacity 0.5s;\n        height: calc(100% - 20px);\n        width: calc(100% - 20px);\n        background: linear-gradient(#00000000 50%, #413634 98%);\n        display: flex;\n        flex-direction: column;\n        justify-content: end;\n        align-items: start;\n        padding: 10px;\n        border-radius: 20px;\n\n        color: #fff;\n        left: -100%;\n\n        .title {\n          font-size: 18px;\n          font-weight: bold;\n          margin-bottom: 20px;\n          position: relative;\n          margin-right: 30px;\n        }\n      }\n    }\n  }\n}\n\n.video-add-action {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 8888;\n  top: 0;\n  opacity: 1;\n  left: 0;\n\n  .content-layout {\n    height: 100%;\n    width: 100%;\n    background-color: #413634;\n    opacity: 0.67;\n    z-index: 8889;\n  }\n  .add-icon {\n    position: absolute;\n    top: 0%;\n    left: 0;\n    background-color: rgb(255 255 255);\n    z-index: 8899;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 60px;\n    width: 60px;\n    border-radius: -11px;\n    &:hover {\n      .img {\n        transition: 0.5s;\n        opacity: 1;\n      }\n    }\n  }\n  .container {\n    width: 90%;\n    max-width: 600px;\n    height: max-content !important;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 8899;\n    display: flex;\n    flex-direction: column;\n    background-color: #f6f1ea;\n    border-radius: 20px;\n    justify-content: center;\n    align-items: center;\n    .title {\n      font-size: 24px;\n      font-weight: bold;\n    }\n    .image {\n      width: 90%;\n      height: 320px;\n      border-radius: 20px;\n      position: relative;\n      overflow: hidden;\n      margin: 20px auto 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      &.none {\n        width: 100px;\n        height: 100px;\n        cursor: pointer;\n        img,\n        video {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          transition: 0.5s;\n        }\n      }\n      img,\n      video {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        transition: 0.5s;\n      }\n      .title {\n        position: absolute;\n        left: 0;\n        top: 00;\n        background: linear-gradient(#00000000 50%, #413634 98%);\n        color: #fff;\n        font-weight: bold;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: end;\n        padding-bottom: 10px;\n      }\n    }\n    .text {\n      width: 95%;\n      height: max-content;\n      display: flex;\n      flex-direction: column;\n      margin: 10px 0;\n      padding-bottom: 10px;\n      gap: 10px;\n      justify-content: center;\n      align-items: center;\n      input {\n        width: 90%;\n        color: #413634;\n        font-size: 15px;\n        height: 50px;\n        border-radius: 10px;\n        outline: none;\n        border: 1px solid #413634;\n        font-weight: bold;\n        position: relative;\n        padding-right: 30px;\n        resize: none;\n      }\n    }\n    .add-btn {\n      width: 90%;\n      height: 40px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 20px;\n      font-weight: bold;\n      cursor: pointer;\n      border-radius: 10px;\n      margin-bottom: 10px;\n      background-color: #2ecc71;\n    }\n  }\n}\n",".home {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 100dvh;\n  height: 100%;\n  padding-top: 50px;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  @import \"./styles/landing\";\n  @import \"./styles/aboutClinic\";\n  @import \"./styles/aboutDR\";\n  @import \"./styles/certificates\";\n  @import \"./styles/directions\";\n}\n",".landing-home {\n  width: 100%;\n  height: 600px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 10px;\n  padding-top: 50px;\n\n  &.activeAnm {\n    .data {\n      .data-background {\n        img {\n          transition: 1s;\n          transform: scale(1.1);\n        }\n      }\n      .back-box {\n        top: -20px;\n        transition: 1s;\n      }\n      .content {\n        .logo {\n          margin-bottom: 0;\n          margin-right: 30px;\n        }\n        .grouping {\n          transition: 1s;\n          top: -31px;\n        }\n      }\n    }\n    .effects {\n      width: 450px;\n      transition: 1s;\n    }\n    .about-clinic {\n      span {\n        width: 250px;\n        transition: 1s;\n      }\n      .arrow {\n        opacity: 1;\n\n        #Path_7 {\n          animation: dashrev 2s linear forwards;\n        }\n        #Path_8 {\n          opacity: 1;\n          transition: 4s;\n        }\n      }\n    }\n  }\n\n  .background {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    opacity: 0.1;\n    background: #fdf8f2;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n  .data {\n    position: relative;\n    width: 80%;\n    height: 80%;\n    background: #413634;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    gap: 21px;\n    position: relative;\n    .data-background {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      left: 0;\n      top: 0;\n      opacity: 0.3;\n      background: #413634;\n      border-radius: 10px;\n      z-index: 1;\n      overflow: hidden;\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        border-radius: 10px;\n        transition: 1s;\n      }\n    }\n    .back-box {\n      position: absolute;\n      top: -40px;\n      width: 90%;\n      height: 90%;\n      left: 50%;\n      transform: translateX(-50%);\n      transition: 1s;\n\n      background-color: #413634;\n    }\n    .content {\n      width: 100%;\n      height: 64%;\n      position: relative;\n      z-index: 2;\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      gap: 24px;\n      .logo {\n        width: 300px;\n        height: 300px;\n        margin-right: 60px;\n        margin-bottom: 20px;\n        transition: 1s;\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: contain;\n        }\n      }\n      .grouping {\n        font-size: 35px;\n        color: #fff;\n        position: relative;\n        top: 50px;\n        transition: 1s;\n\n        .title {\n          font-weight: bold;\n          font-size: 50px;\n        }\n      }\n    }\n  }\n  .effects {\n    position: absolute;\n    left: 0;\n    bottom: 112px;\n    z-index: 2;\n    width: 350px;\n    height: 100px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    transition: 1s;\n\n    .effect {\n      height: 20px;\n      width: 100%;\n      background-color: #fcf2ec;\n      position: relative;\n      left: 0;\n      &.one {\n        width: 70%;\n        left: -30%;\n      }\n      &.two {\n        width: 90%;\n        left: -10%;\n      }\n      &.three {\n        width: 100%;\n      }\n    }\n  }\n\n  .about-clinic {\n    width: 75%;\n    height: 60px;\n    z-index: 2;\n    position: relative;\n    margin-top: 10px;\n    cursor: pointer;\n    a {\n      background-color: #413634;\n      border-radius: 30px;\n      color: #fff;\n      font-weight: bold;\n      height: 60px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 200px;\n      transition: 1s;\n      text-decoration: none;\n      color: #fff;\n    }\n    .arrow {\n      position: absolute;\n      top: 50%;\n      right: 270px;\n      opacity: 0;\n      transition: 1s;\n\n      #Path_7 {\n        stroke-dasharray: 10;\n        stroke-dashoffset: 0;\n        @keyframes dashrev {\n          0% {\n            stroke-dashoffset: 0;\n          }\n          100% {\n            stroke-dashoffset: -80;\n          }\n        }\n      }\n      #Path_8 {\n        opacity: 0;\n      }\n    }\n  }\n}\n@media (max-width: 768px) {\n  .landing-home {\n    height: 400px;\n    .content {\n      width: 100%;\n      height: 92%;\n      position: relative;\n      z-index: 2;\n\n      display: flex;\n      justify-content: center;\n      gap: 10px;\n      align-items: center;\n      flex-direction: column;\n      .logo {\n        width: 115px !important;\n        height: 115px !important;\n        margin-left: 30px;\n        margin-bottom: 10px;\n      }\n      .grouping {\n        font-size: 20px !important;\n        top: 0 !important;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        .title {\n          font-weight: bold;\n          font-size: 32px !important;\n        }\n      }\n    }\n    .about-clinic {\n      .arrow {\n        width: 111px;\n        height: 124px;\n        position: relative;\n        right: 196px;\n        opacity: 1;\n        top: -55px;\n        transform: rotate(320deg);\n      }\n\n      svg {\n        width: 100%;\n        height: 100%;\n      }\n    }\n    &.activeAnm {\n      .effects {\n        display: none !important;\n      }\n    }\n    .effects {\n      bottom: 80px !important;\n      width: 100px !important;\n    }\n  }\n}\n",".about-clinic-home {\n  width: calc(100% - 60px);\n  padding: 0 30px;\n  height: 800px;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  flex-direction: column;\n  overflow: hidden;\n  .container {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    height: 100%;\n    .right,\n    .left {\n      width: 48%;\n      height: calc(100% - 100px);\n    }\n  }\n  .head-title {\n    font-size: 50px;\n    font-weight: bold;\n    width: max-content;\n    position: relative;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    span {\n      position: relative;\n      z-index: 2;\n      color: #413634;\n    }\n    &::before {\n      content: \"\";\n      bottom: 5px;\n      position: absolute;\n      left: 50%;\n      height: 30px;\n      width: 117%;\n      z-index: 1;\n      background-color: #ffdead;\n      transform: translateX(-50%);\n    }\n  }\n  .right {\n    display: flex;\n    flex-direction: column;\n\n    .text {\n      width: 100%;\n      height: 100%;\n      line-height: 2.5;\n      font-size: 20px;\n      font-weight: 600;\n      color: #525252;\n      position: relative;\n    }\n    .bottom {\n      display: flex;\n      gap: 10px;\n      margin-top: 20px;\n      .one {\n        width: 80px;\n        height: 4px;\n        background-color: #413634;\n        border-radius: 10px;\n      }\n      .two {\n        width: 20px;\n        height: 4px;\n        background-color: #413634;\n        border-radius: 10px;\n      }\n    }\n  }\n  .left {\n    position: relative;\n    .images {\n      position: relative;\n      width: 100%;\n      height: 100%;\n      .image {\n        width: 45%;\n        height: 55%;\n        border-radius: 30px;\n        position: absolute;\n\n        &.one {\n          top: 35%;\n          left: 44%;\n          z-index: 2;\n          animation: dream 2s infinite alternate; /* Key part */\n        }\n        &.two {\n          bottom: 45%;\n          right: 44%;\n          z-index: 1;\n          animation: dream2 2s infinite alternate; /* Key part */\n        }\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          border-radius: 30px;\n        }\n      }\n    }\n    .effects {\n      position: absolute;\n      left: 0;\n      z-index: 1;\n      width: 100%;\n      height: 100%;\n      bottom: 0;\n\n      .effect {\n        border-radius: 50%;\n        background-color: #413634;\n        position: absolute;\n        &.one {\n          width: 450px;\n          height: 450px;\n          left: -17%;\n          bottom: -15%;\n        }\n        &.two {\n          width: 100px;\n          height: 100px;\n          top: 29%;\n          right: 0%;\n        }\n        &.thee {\n          top: 22%;\n          right: 15%;\n          width: 40px;\n          height: 40px;\n        }\n      }\n    }\n  }\n  @keyframes dream {\n    0% {\n      transform: translateY(0);\n    }\n    100% {\n      transform: translateY(20px);\n    }\n  }\n  @keyframes dream2 {\n    0% {\n      transform: translateY(20px);\n    }\n    100% {\n      transform: translateY(0);\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .about-clinic-home {\n    flex-direction: column;\n    height: max-content;\n    width: calc(100% - 60px);\n    padding-bottom: 0;\n    .head-title {\n      margin: 0 auto;\n      margin-top: 30px;\n    }\n    .container {\n      flex-direction: column-reverse;\n      .right,\n      .left {\n        width: 100%;\n        height: max-content;\n      }\n    }\n    .right {\n      margin-bottom: 0;\n      .text {\n        line-height: 2.3;\n        font-size: 16px;\n      }\n    }\n    .left {\n      height: 500px !important;\n      margin-bottom: 100px;\n      .images {\n        .image {\n          width: 200px;\n        }\n      }\n      .effects {\n        width: 100%;\n        .effect.one {\n          width: 350px;\n          height: 350px;\n          left: 3px !important;\n        }\n      }\n      .images {\n        margin-top: 37px;\n      }\n    }\n  }\n}\n",".about-dr-home {\n  width: calc(100% - 60px);\n  padding: 0 30px;\n  height: 600px;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  .background {\n    width: 59%;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    top: 0;\n    opacity: 1;\n    background: #fdf8f2;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n    }\n  }\n  .right,\n  .left {\n    height: calc(100% - 100px);\n    position: relative;\n    z-index: 2;\n  }\n\n  .right {\n    position: relative;\n    width: 40%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .image {\n      width: max-content;\n      height: 100%;\n      border-radius: 30px;\n      animation: dream 2s infinite alternate; /* Key part */\n      position: relative;\n      &:hover {\n        .data {\n          opacity: 1;\n          transition: opacity 0.5s;\n          top: -12px;\n          left: 7px;\n          border-radius: 10px;\n        }\n      }\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        border-radius: 30px;\n      }\n      .data {\n        position: absolute;\n        z-index: 2;\n        top: 1%;\n        left: 200%;\n        width: 97%;\n\n        height: 100%;\n        cursor: pointer;\n        opacity: 0;\n        transition: opacity 0.5s;\n\n        .layout {\n          width: 100%;\n          height: 100%;\n          background: linear-gradient(#00000000 70%, #413634 98%);\n          border-radius: 30px;\n        }\n        .text {\n          position: absolute;\n          bottom: 25px;\n          font-weight: bold;\n          width: max-content;\n          color: #fff;\n          font-size: 18px;\n          left: 50%;\n          transform: translateX(-50%);\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n          align-items: center;\n          text-transform: capitalize;\n          gap: 5px;\n          .info {\n            text-transform: uppercase;\n          }\n        }\n      }\n    }\n  }\n  .left {\n    display: flex;\n    flex-direction: column;\n    width: 55%;\n\n    .head-title {\n      font-size: 50px;\n      font-weight: bold;\n      width: max-content;\n      position: relative;\n      margin-bottom: 30px;\n      .title {\n        font-size: 50px;\n        font-weight: bold;\n        width: max-content;\n        position: relative;\n        span {\n          position: relative;\n          z-index: 2;\n          color: #413634;\n        }\n        &::before {\n          content: \"\";\n          bottom: 5px;\n          position: absolute;\n          left: 50%;\n          height: 30px;\n          width: 117%;\n          z-index: 1;\n          background-color: #ffdead;\n          transform: translateX(-50%);\n        }\n      }\n      .info {\n        font-size: 21px;\n      }\n    }\n    .skills {\n      width: 80%;\n      height: max-content;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      gap: 30px;\n      font-size: 24px;\n      margin: 20px 0 50px;\n      font-weight: bold;\n\n      .skill {\n        color: #413634;\n        position: relative;\n        margin-right: 30px;\n        &::before {\n          content: \"\";\n          height: 20px;\n          width: 20px;\n          background-color: #ffdead;\n          top: 50%;\n          position: absolute;\n          right: -30px;\n          transform: translateY(-50%);\n          border-radius: 50%;\n        }\n      }\n    }\n    .locations {\n      width: 100%;\n      justify-content: space-between;\n      display: flex;\n      width: 60%;\n      .location {\n        width: max-content;\n        padding: 9px 14px;\n        font-size: 14px;\n        height: 40px;\n        font-weight: bold;\n        color: #000;\n        border: 1px solid #413634;\n        border-radius: 20px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n  }\n\n  @keyframes dream {\n    0% {\n      transform: translateY(0);\n    }\n    100% {\n      transform: translateY(20px);\n    }\n  }\n}\n@media (max-width: 768px) {\n  .about-dr-home {\n    flex-direction: column-reverse;\n    height: max-content;\n    width: calc(100% - 60px);\n    .head-title {\n      margin: 0 auto;\n      margin-top: 30px;\n    }\n    .right,\n    .left {\n      width: 100%;\n      height: max-content;\n      margin-bottom: 20px;\n    }\n    .left {\n      .effects {\n        width: 100%;\n        .effect.one {\n          width: 350px;\n          height: 350px;\n          left: 3px !important;\n        }\n      }\n      .skills {\n        width: 100%;\n\n        .skill {\n          width: 100%;\n          font-size: 20px;\n        }\n      }\n      .locations {\n        display: flex;\n        width: 100%;\n        justify-content: space-between;\n\n        .location {\n          width: calc(48% - 20px) !important;\n          padding: 8px 10px;\n          font-size: 11px !important;\n        }\n      }\n      .images {\n        margin-top: 37px;\n      }\n    }\n  }\n}\n",".certificates-home {\n  width: 100%;\n  padding: 0 0;\n  min-height: 600px;\n  height: max-content;\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 50px;\n  padding-bottom: 50px;\n  .background {\n    width: 100%;\n    height: 88%;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    opacity: 0.04;\n    background: #fdf8f2;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n  .head-title {\n    font-size: 50px;\n    font-weight: bold;\n    width: 100%;\n    position: relative;\n    margin-bottom: 30px;\n    .title {\n      font-size: 50px;\n      font-weight: bold;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: relative;\n      span {\n        position: relative;\n        z-index: 2;\n        color: #413634;\n        text-align: center;\n      }\n      &::before {\n        content: \"\";\n        bottom: 5px;\n        position: absolute;\n        left: 50%;\n        height: 30px;\n        width: 80%;\n        z-index: 1;\n        background-color: #ffdead;\n        transform: translateX(-50%);\n      }\n    }\n    .info {\n      font-size: 21px;\n    }\n  }\n  .certificates {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    justify-content: space-between;\n    position: relative;\n    z-index: 2;\n    &.pc {\n      display: flex;\n      padding-bottom: 40px;\n      overflow-x: scroll;\n      overflow-y: hidden;\n      justify-content: space-between;\n      .certificate {\n        width: 300px !important;\n      }\n    }\n    .mySwiper {\n      width: 100%;\n      height: max-content;\n      padding-bottom: 50px;\n\n      .swiper-pagination {\n        bottom: 30px;\n      }\n      .swiper-slide-prev,\n      .swiper-slide-next {\n        opacity: 0.7;\n        transition: 0.5s;\n      }\n    }\n    .certificate {\n      width: 300px !important;\n      height: 400px;\n      transition: 0.5s;\n      border-radius: 15px;\n      box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px,\n        rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;\n      position: relative;\n      margin-top: 30px;\n      margin-left: 12px;\n      margin-right: 12px;\n      .image {\n        width: 300px;\n        height: 100%;\n        border-radius: 15px;\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          border-radius: 15px;\n          transition: 0.5s;\n        }\n      }\n      .data {\n        position: absolute;\n        z-index: -2;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        cursor: pointer;\n        opacity: 0;\n        transition: opacity 0.5s;\n        border-radius: 15px;\n\n        .layout {\n          width: 100%;\n          height: 100%;\n          background: linear-gradient(#00000000 70%, #413634 98%);\n          border-radius: 15px;\n        }\n        .text {\n          position: absolute;\n          bottom: 25px;\n          font-weight: bold;\n          width: max-content;\n          color: #fff;\n          font-size: 18px;\n          left: 50%;\n          transform: translateX(-50%);\n        }\n      }\n      &:hover {\n        .image {\n          img {\n            transition: 0.5s;\n            transform: scale(1);\n          }\n        }\n        .data {\n          opacity: 1;\n          transition: opacity 0.5s;\n          top: 0;\n          z-index: 2;\n        }\n      }\n    }\n  }\n  .effects {\n    position: absolute;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n\n    .effect {\n      position: absolute;\n      z-index: 1;\n      background-color: #ffdead;\n      border-radius: 50%;\n      &.middle {\n        width: 400px;\n        height: 400px;\n\n        top: 56%;\n        left: 50%;\n        transform: translateX(-50%) translateY(-50%);\n      }\n      &.two {\n        width: 100px;\n        height: 100px;\n        bottom: -16%;\n        right: -32%;\n        transform: translateX(-50%) translateY(-50%);\n      }\n    }\n  }\n}\n",".directions-home {\n  width: calc(100% - 60px);\n  padding: 0 30px;\n  min-height: 650px;\n  height: max-content;\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding-bottom: 50px;\n  padding-top: 20px;\n  .background {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    opacity: 0.2;\n    background: #fdf8f2;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n  .head-title {\n    font-size: 50px;\n    font-weight: bold;\n    width: 100%;\n    position: relative;\n    margin-bottom: 30px;\n    z-index: 2;\n    .title {\n      font-weight: bold;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: relative;\n      span {\n        position: relative;\n        z-index: 2;\n        color: #413634;\n        text-align: center;\n      }\n      &::before {\n        content: \"\";\n        bottom: 5px;\n        position: absolute;\n        left: 50%;\n        height: 30px;\n        width: 100%;\n        z-index: 1;\n        background-color: #ffdead;\n        transform: translateX(-50%);\n      }\n    }\n    .info {\n      font-size: 21px;\n    }\n  }\n  .box {\n    position: relative;\n    z-index: 2;\n    width: 95%;\n    height: max-content;\n\n    background-color: #fff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-top: 40px;\n    box-shadow: rgb(99 99 99 / 39%) 0px 2px 13px 3px;\n\n    .direction {\n      display: flex;\n      flex-direction: column;\n      width: 230px;\n      height: 230px;\n      margin: 10px;\n      justify-content: center;\n      gap: 20px;\n      align-items: center;\n      font-weight: bold;\n      font-size: 17px;\n      position: relative;\n      transition: 0.5s;\n      background-color: #fff;\n      text-align: center;\n      &:not(:last-of-type):after {\n        content: \"\";\n        left: 0;\n        position: absolute;\n        top: 50%;\n        width: 1px;\n        height: 80%;\n        background-color: #413634;\n        transform: translateY(-50%);\n        transition: 0.1s;\n      }\n      &:hover {\n        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 10px 4px,\n          rgba(60, 64, 67, 0.15) 0px 1px 9px 4px;\n        transform: scale(1.05);\n        transition: 0.5s;\n        z-index: 3;\n        &::after {\n          width: 0;\n          height: 0;\n          transition: 0.1s;\n        }\n      }\n      .image {\n        width: 130px;\n        height: 130px;\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: contain;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .directions-home {\n    flex-direction: column;\n    height: max-content;\n    width: calc(100% - 60px);\n    .head-title {\n      margin: 0 auto;\n      margin-top: 30px;\n      font-size: 20px;\n    }\n    .right,\n    .left {\n      width: 100%;\n      height: max-content;\n    }\n    .left {\n      height: 500px !important;\n      .effects {\n        width: 100%;\n        .effect.one {\n          width: 350px;\n          height: 350px;\n          left: 3px !important;\n        }\n      }\n      .images {\n        margin-top: 37px;\n      }\n    }\n\n    .box {\n      width: 100%;\n      justify-content: space-between;\n      align-items: start;\n\n      &:first-of-type {\n        .direction {\n          &:before {\n            content: \"\";\n            left: -10px;\n            position: absolute;\n            top: 50%;\n            width: 1px;\n            height: 80%;\n            background-color: #413634;\n            transform: translateY(-50%);\n            transition: 0.1s;\n          }\n        }\n      }\n      .direction {\n        width: 48% !important;\n        margin: 0;\n        text-align: 14px;\n        &::after {\n          display: none;\n        }\n      }\n    }\n  }\n}\n",".social {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 100dvh;\n  padding-top: 50px;\n  position: relative;\n  overflow-x: hidden;\n  .background {\n    width: 100%;\n    height: 321px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    opacity: 0.2;\n    background: #fdf8f2;\n    background-repeat: no-repeat;\n    z-index: 0;\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n  .section {\n    display: flex;\n    width: 100%;\n    height: 700px;\n    position: relative;\n    z-index: 2;\n    flex-direction: column;\n    color: #000;\n    text-decoration: none;\n    &.spic {\n      background-color: #fcf2ec;\n    }\n    .head-title {\n      font-size: 40px;\n      font-weight: bold;\n      width: max-content;\n      position: relative;\n      margin: 0 auto;\n      margin-bottom: 40px;\n      margin-top: 20px;\n      span {\n        position: relative;\n        z-index: 2;\n        color: #413634;\n      }\n      &::before {\n        content: \"\";\n        bottom: 5px;\n        position: absolute;\n        left: 50%;\n        height: 30px;\n        width: 104%;\n        transform: translateX(-50%);\n        z-index: 1;\n        background-color: #ffdead;\n      }\n    }\n    .section-container {\n      width: 100%;\n      display: flex;\n      height: 100%;\n      justify-content: space-between;\n      color: #000;\n      text-decoration: none;\n      .right {\n        width: calc(40% - 40px);\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        .anthor-title {\n          font-weight: bold;\n          width: 100%;\n          position: relative;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          .title {\n            font-size: 40px;\n            position: relative;\n            width: max-content;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            margin-right: 0 !important;\n            span {\n              position: relative;\n              z-index: 2;\n              width: max-content;\n              color: #413634;\n            }\n            &::before {\n              content: \"\";\n              bottom: 5px;\n              position: absolute;\n              left: 50%;\n              height: 30px;\n              width: 104%;\n              transform: translateX(-50%);\n              z-index: 1;\n              background-color: #ffdead;\n            }\n          }\n          .info {\n            color: #413634;\n            font-weight: bold;\n            margin: 5px 0;\n            width: 83%;\n            text-align: center;\n          }\n        }\n        .location {\n          height: calc(100% - 100px);\n          width: calc(100% - 40px);\n          padding: 0 20px;\n          display: flex;\n          flex-direction: column;\n          position: relative;\n          margin-top: 20px;\n          .location {\n            width: 80%;\n            height: 80%;\n            img {\n              width: 100%;\n              height: 100%;\n              object-fit: contain;\n            }\n          }\n          // .city,\n          // .cinema {\n          //   display: flex;\n          //   flex-direction: column;\n          //   .group {\n          //     position: relative;\n          //     display: flex;\n          //     flex-direction: column;\n          //     align-items: center;\n          //     width: max-content;\n          //     font-weight: bold;\n          //     color: #413634;\n          //     font-size: 18px;\n          //   }\n          // }\n          // .cinema {\n          //   align-items: flex-end;\n          // }\n          // .tower {\n          //   position: relative;\n\n          //   padding-top: 10px;\n          //   display: flex;\n          //   width: 100%;\n          //   align-items: center;\n          //   justify-content: center;\n          //   position: relative;\n\n          //   .group {\n          //     display: flex;\n          //     height: 100px;\n          //     justify-content: space-between;\n          //     align-items: center;\n          //     position: relative;\n          //     left: 31px;\n\n          //     .grouping {\n          //       display: flex;\n          //       flex-direction: column;\n          //       color: #413634;\n          //       .group-title {\n          //         font-size: 18px;\n          //         font-weight: bold;\n          //       }\n          //       .group-desc {\n          //         font-size: 14px;\n          //         font-weight: 600;\n          //       }\n          //       .group-info {\n          //         font-size: 12px;\n          //         font-weight: normal;\n          //       }\n          //     }\n          //   }\n          // }\n          // .num {\n          //   position: absolute;\n          //   top: 0;\n          //   left: 0;\n          //   border: 1px solid #e94434;\n          //   width: 20px;\n          //   height: 20px;\n          //   display: flex;\n          //   align-items: center;\n          //   justify-content: center;\n          //   border-radius: 50%;\n          //   color: #e94434;\n          //   font-size: 12px;\n          //   font-weight: bold;\n          // }\n          // .icon {\n          //   width: 100px !important;\n          //   height: 100px !important;\n          // }\n        }\n      }\n      .left {\n        width: calc(55% - 40px);\n        padding-left: 40px;\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: center;\n        gap: 10px;\n        position: relative;\n        iframe {\n          width: 100%;\n          height: 80%;\n          border-radius: 10px;\n          box-shadow: rgb(0 0 0 / 0%) 0px 1px 20px 8px,\n            rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n        }\n        .info {\n          width: 30%;\n          position: absolute;\n          height: 50px;\n          border-radius: 30px;\n          bottom: 15%;\n          left: 50%;\n          transform: translateX(-45%);\n          border: 1px solid #413634;\n          background-color: #fcf2ec;\n          font-size: 20px;\n          font-weight: bold;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          cursor: pointer;\n          color: #000;\n          text-decoration: none;\n          a {\n            color: #000;\n            text-decoration: none;\n          }\n          .icon {\n            position: absolute;\n            right: 10px;\n            width: 30px;\n            height: 30px;\n            top: 50%;\n            transform: translateY(-50%);\n            color: #000;\n            text-decoration: none;\n          }\n        }\n      }\n    }\n    .simple-title {\n      font-size: 40px;\n      font-weight: bold;\n      width: max-content;\n      position: relative;\n      margin: 0 auto;\n      margin-bottom: 40px;\n      margin-top: 80px;\n      span {\n        position: relative;\n        z-index: 2;\n        color: #413634;\n      }\n      &::before {\n        content: \"\";\n        bottom: 5px;\n        position: absolute;\n        left: 50%;\n        height: 30px;\n        width: 104%;\n        transform: translateX(-50%);\n        z-index: 1;\n        background-color: #ffdead;\n      }\n    }\n    .container {\n      display: flex;\n      width: 90%;\n      margin: 0 auto;\n      display: flex;\n      justify-content: space-between;\n      color: #000;\n      text-decoration: none;\n      .contact {\n        width: 280px;\n        height: 280px;\n        display: flex;\n        flex-direction: column;\n        background-color: #fcf2ec;\n        justify-content: space-between;\n        align-items: center;\n        padding: 10px 0;\n        border-radius: 20px;\n        border: 1px solid transparent;\n        transition: 0.5s;\n        transform: scale(1);\n        color: #000;\n        text-decoration: none;\n        &:hover {\n          box-shadow: rgb(0 0 0 / 0%) 0px 1px 20px 8px,\n            rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n          border: 1px solid #413634;\n          transform: scale(1.1);\n          transition: 0.5s;\n        }\n        .icon {\n          width: 100px;\n          height: 100px;\n          margin-top: 20px;\n        }\n        .title {\n          font-size: 24px;\n          font-weight: bold;\n          margin-bottom: 40px;\n          width: 90%;\n          position: relative;\n          margin: 0 auto;\n          text-align: center;\n          color: #000;\n          text-decoration: none;\n          &::before {\n            content: \"\";\n            bottom: -20px;\n            position: absolute;\n            left: 0;\n            width: 100%;\n            height: 1px;\n            border-radius: 10px;\n            background-color: #413634;\n          }\n        }\n        .value {\n          font-weight: normal;\n          font-size: 18px;\n          margin: 0 auto;\n          text-align: center;\n          color: #000;\n          text-decoration: none;\n        }\n      }\n    }\n  }\n}\n@media (max-width: 768px) {\n  .social {\n    height: max-content;\n    .background {\n      width: 100%;\n      height: 121px;\n      position: absolute;\n      right: 0;\n      top: 0;\n      opacity: 0.2;\n      background: #fdf8f2;\n      background-repeat: no-repeat;\n      z-index: 0;\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n    .head-title {\n      display: none;\n      margin-bottom: 30px;\n      .title {\n        margin-top: 10px;\n        margin-bottom: 30px;\n      }\n    }\n    .right,\n    .left {\n      width: 100% !important;\n      height: max-content !important;\n    }\n    .tower {\n      .group {\n        margin-left: 30px;\n      }\n    }\n    .left {\n      margin: 30px 0;\n      iframe {\n        width: 100%;\n        margin: 0 auto;\n        height: 300px !important;\n        width: 90% !important;\n      }\n      .info {\n        width: 52% !important;\n        position: absolute;\n        height: 50px;\n        border-radius: 30px;\n        bottom: -7% !important;\n        left: 50%;\n        transform: translateX(-50%);\n        border: 1px solid #413634;\n        background-color: #fcf2ec;\n        font-size: 20px;\n        font-weight: bold;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n      }\n    }\n    .section {\n      height: max-content !important;\n\n      .section-container {\n        width: 100%;\n        display: flex;\n        height: max-content !important;\n\n        justify-content: space-between;\n        flex-direction: column;\n        .anthor-title {\n          .title {\n            margin-right: 40px;\n            margin-top: 20px;\n          }\n          .info {\n            width: max-content;\n            font-size: 12px;\n          }\n        }\n\n        .location {\n          width: 100%;\n        }\n      }\n      .container {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 30px;\n        flex-wrap: wrap;\n        gap: 10px;\n        .contact {\n          width: calc(48% - 20px);\n          height: 185px;\n          margin-left: 10px;\n          margin-bottom: 10px;\n          .title {\n            font-size: 18px !important;\n            &::before {\n              display: none;\n            }\n          }\n          .value {\n            font-size: 16px !important;\n          }\n        }\n      }\n    }\n  }\n}\n",".services {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 100dvh;\n  padding-top: 50px;\n  position: relative;\n  padding-bottom: 50px;\n  .background {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    top: 0;\n    opacity: 0.1;\n    background: #fdf8f2;\n    background-repeat: no-repeat;\n    z-index: 0;\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n\n  .head-title {\n    font-size: 40px;\n    font-weight: bold;\n    width: max-content;\n    position: relative;\n    margin: 0 auto;\n    margin-bottom: 40px;\n    margin-top: 20px;\n    z-index: 2;\n    span {\n      position: relative;\n      z-index: 2;\n      color: #413634;\n    }\n    &::before {\n      content: \"\";\n      bottom: 5px;\n      position: absolute;\n      left: 50%;\n      height: 30px;\n      width: 104%;\n      transform: translateX(-50%);\n      z-index: 1;\n      background-color: #ffdead;\n    }\n  }\n\n  .services-container {\n    width: 90%;\n    margin: 0 auto;\n    height: calc(100% - 240px);\n    position: relative;\n    z-index: 2;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 30px;\n    .service {\n      display: flex;\n      background-color: #fdf8f2;\n      width: 350px;\n      height: 520px;\n      border-radius: 10px;\n      flex-direction: column;\n      align-items: center;\n      transition: 0.5s;\n      border: 1px solid transparent;\n\n      &:hover {\n        transition: 0.5s;\n        box-shadow: rgb(0 0 0 / 0%) 0px 1px 20px 8px,\n          rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n        border: 1px solid #413634;\n      }\n\n      .content {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 90%;\n        flex-direction: column;\n        margin-bottom: 40px;\n        position: relative;\n        &::before {\n          content: \"\";\n          bottom: -20px;\n          position: absolute;\n          left: 0;\n          width: 100%;\n          height: 1px;\n          border-radius: 10px;\n          background-color: #413634;\n        }\n        .icon {\n          width: 140px;\n          height: 140px;\n          margin-top: 20px;\n          margin-bottom: 20px;\n        }\n        .title {\n          font-size: 24px;\n          margin-top: 10px;\n          font-weight: bold;\n          color: #413634;\n        }\n      }\n\n      .grouping {\n        display: flex;\n        width: 90%;\n\n        flex-direction: column;\n        align-items: center;\n        gap: 15px;\n        margin-bottom: 30px;\n        .info {\n          font-size: 16px;\n          line-height: 2;\n          text-align: center;\n          color: #525252;\n        }\n        .images {\n          width: 50px;\n          height: 50px;\n          cursor: pointer;\n        }\n      }\n\n      &.spic {\n        background-color: transparent;\n        &:hover {\n          transition: 0.5s;\n          box-shadow: none;\n          border: 1px solid transparent;\n        }\n        .content {\n          height: 150px;\n          background-color: #413634;\n          width: 100%;\n          margin-bottom: 10px;\n          &::before {\n            display: none;\n          }\n          .title {\n            color: #fff;\n            margin-bottom: 10px;\n          }\n          border-radius: 10px;\n        }\n      }\n      .service-container {\n        display: flex;\n        height: 100%;\n        flex-direction: column;\n        gap: 20px;\n        height: calc(100% - 150px);\n        width: 100%;\n        .service-d {\n          width: 100%;\n          background-color: #fdf8f2;\n          border: 1px solid #413634;\n          border-radius: 10px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          height: auto;\n          padding: 15px 0;\n          color: #000;\n          font-weight: bold;\n          cursor: pointer;\n          overflow: hidden;\n          transition: 0.5s;\n          span {\n            width: 100%;\n            text-align: center;\n          }\n          .icon {\n            width: 30px;\n            height: 30px;\n            position: relative;\n            left: -100%;\n            transition: 0.5s;\n          }\n\n          &:hover {\n            transition: 0.5s;\n            box-shadow: rgb(0 0 0 / 0%) 0px 1px 20px 8px,\n              rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n            border: 1px solid #413634;\n            width: 100%;\n\n            .icon {\n              left: 20px;\n              transition: 0.5s;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n@media (max-width: 768px) {\n  .services {\n    height: max-content;\n    .background {\n      width: 100%;\n      height: 121px;\n      position: absolute;\n      right: 0;\n      top: 0;\n      opacity: 0.2;\n      background: #fdf8f2;\n      background-repeat: no-repeat;\n      z-index: 0;\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n    .head-title {\n      margin-bottom: 30px;\n      .title {\n        margin-top: 10px;\n        margin-bottom: 30px;\n      }\n    }\n    .services-container {\n      height: max-content;\n      width: 100%;\n      flex-direction: column;\n      padding-bottom: 50px;\n      gap: 40px;\n    }\n    .service {\n      width: 350px !important;\n      height: 450px !important;\n      &.spic {\n        .content {\n          height: max-content;\n          .icon {\n            width: 70px;\n            height: 70px;\n          }\n        }\n      }\n      .info {\n        font-size: 13px !important;\n      }\n    }\n  }\n}\n",".cases {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 600px;\n  padding-top: 50px;\n  position: relative;\n\n  .head-title {\n    font-size: 40px;\n    font-weight: bold;\n    width: max-content;\n    position: relative;\n    margin: 0 auto;\n    margin-bottom: 40px;\n    margin-top: 20px;\n    z-index: 2;\n    span {\n      position: relative;\n      z-index: 2;\n      color: #413634;\n    }\n    &::before {\n      content: \"\";\n      bottom: 5px;\n      position: absolute;\n      left: 50%;\n      height: 30px;\n      width: 104%;\n      transform: translateX(-50%);\n      z-index: 1;\n      background-color: #ffdead;\n    }\n  }\n  .boxes {\n    width: 90%;\n    margin: 0 auto;\n    height: 100%;\n    position: relative;\n    z-index: 2;\n    display: flex;\n    justify-content: center;\n    gap: 40px;\n    margin-top: 100px;\n    .box {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      background-color: #fdf8f2;\n      border: 1px solid transparent;\n      border-radius: 10px;\n      width: 300px;\n      height: 300px;\n      gap: 30px;\n      cursor: pointer;\n      transition: 0.5s;\n      transform: scale(1);\n\n      &:hover {\n        box-shadow: rgb(0 0 0 / 0%) 0px 1px 20px 8px,\n          rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n        border: 1px solid #413634;\n        transform: scale(1.1);\n        transition: 0.5s;\n      }\n      .icon {\n        width: 150px;\n        height: 150px;\n      }\n      .title {\n        font-size: 18px;\n        font-weight: bold;\n      }\n    }\n  }\n}\n@media (max-width: 768px) {\n  .cases {\n    height: max-content;\n    .background {\n      width: 100%;\n      height: 121px;\n      position: absolute;\n      right: 0;\n      top: 0;\n      opacity: 0.2;\n      background: #fdf8f2;\n      background-repeat: no-repeat;\n      z-index: 0;\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n    .head-title {\n      margin-bottom: 30px;\n      .title {\n        margin-top: 10px;\n        margin-bottom: 30px;\n      }\n    }\n    .boxes {\n      height: max-content;\n      width: 100%;\n      flex-direction: column;\n      padding-bottom: 50px;\n      gap: 40px;\n      align-items: center;\n      .box {\n        width: 250px;\n        height: 250px;\n      }\n    }\n  }\n}\n",".home-admin {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 100dvh;\n  height: 100%;\n  padding-top: 50px;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  @import \"./styles/landing\";\n  @import \"./styles/aboutClinic\";\n  @import \"./styles/aboutDR\";\n  @import \"./styles/certificates\";\n  @import \"./styles/directions\";\n}\n",".landing-home {\n  width: 100%;\n  height: 600px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 10px;\n  padding-top: 50px;\n\n  &.activeAnm {\n    .data {\n      .data-background {\n        img {\n          transition: 1s;\n          transform: scale(1.1);\n        }\n      }\n      .back-box {\n        top: -20px;\n        transition: 1s;\n      }\n      .content {\n        .logo {\n          margin-bottom: 0;\n          margin-right: 30px;\n        }\n        .grouping {\n          transition: 1s;\n          top: -31px;\n        }\n      }\n    }\n    .effects {\n      width: 450px;\n      transition: 1s;\n    }\n    .about-clinic {\n      span {\n        width: 250px;\n        transition: 1s;\n      }\n      .arrow {\n        opacity: 1;\n\n        #Path_7 {\n          animation: dashrev 2s linear forwards;\n        }\n        #Path_8 {\n          opacity: 1;\n          transition: 4s;\n        }\n      }\n    }\n  }\n\n  .background {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    opacity: 0.1;\n    background: #fdf8f2;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n  .data {\n    position: relative;\n    width: 80%;\n    height: 80%;\n    background: #413634;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    gap: 21px;\n    position: relative;\n    .data-background {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      left: 0;\n      top: 0;\n\n      border-radius: 10px;\n      z-index: 2;\n      overflow: hidden;\n      .image {\n        width: 100%;\n        height: 100%;\n        z-index: 1;\n        opacity: 0.3;\n        background: #413634;\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          border-radius: 10px;\n          transition: 1s;\n        }\n      }\n      .add-icon {\n        position: absolute;\n        top: 0;\n        left: 0;\n        background-color: #ffff;\n        z-index: 2;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 60px;\n        width: 60px;\n        &:hover {\n          .img {\n            transition: 0.5s;\n            opacity: 1;\n          }\n        }\n      }\n    }\n    .back-box {\n      position: absolute;\n      top: -40px;\n      width: 90%;\n      height: 90%;\n      left: 50%;\n      transform: translateX(-50%);\n      transition: 1s;\n\n      background-color: #413634;\n    }\n    .content {\n      width: 100%;\n      height: 64%;\n      position: relative;\n      z-index: 2;\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      gap: 24px;\n      .logo {\n        width: 300px;\n        height: 300px;\n        margin-right: 60px;\n        margin-bottom: 20px;\n        transition: 1s;\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: contain;\n        }\n      }\n      .grouping {\n        font-size: 35px;\n        color: #fff;\n        position: relative;\n        top: 50px;\n        transition: 1s;\n\n        .title {\n          font-weight: bold;\n          font-size: 50px;\n        }\n      }\n    }\n  }\n  .effects {\n    position: absolute;\n    left: 0;\n    bottom: 112px;\n    z-index: 2;\n    width: 350px;\n    height: 100px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    transition: 1s;\n\n    .effect {\n      height: 20px;\n      width: 100%;\n      background-color: #fcf2ec;\n      position: relative;\n      left: 0;\n      &.one {\n        width: 70%;\n        left: -30%;\n      }\n      &.two {\n        width: 90%;\n        left: -10%;\n      }\n      &.three {\n        width: 100%;\n      }\n    }\n  }\n\n  .about-clinic {\n    width: 75%;\n    height: 60px;\n    z-index: 2;\n    position: relative;\n    margin-top: 10px;\n    cursor: pointer;\n    a {\n      background-color: #413634;\n      border-radius: 30px;\n      color: #fff;\n      font-weight: bold;\n      height: 60px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 200px;\n      transition: 1s;\n      text-decoration: none;\n      color: #fff;\n    }\n    .arrow {\n      position: absolute;\n      top: 50%;\n      right: 270px;\n      opacity: 0;\n      transition: 1s;\n\n      #Path_7 {\n        stroke-dasharray: 10;\n        stroke-dashoffset: 0;\n        @keyframes dashrev {\n          0% {\n            stroke-dashoffset: 0;\n          }\n          100% {\n            stroke-dashoffset: -80;\n          }\n        }\n      }\n      #Path_8 {\n        opacity: 0;\n      }\n    }\n  }\n}\n@media (max-width: 768px) {\n  .landing-home {\n    height: 400px;\n    .content {\n      width: 100%;\n      height: 92%;\n      position: relative;\n      z-index: 2;\n\n      display: flex;\n      justify-content: center;\n      gap: 10px;\n      align-items: center;\n      flex-direction: column;\n      .logo {\n        width: 115px !important;\n        height: 115px !important;\n        margin-left: 30px;\n        margin-bottom: 10px;\n      }\n      .grouping {\n        font-size: 20px !important;\n        top: 0 !important;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        .title {\n          font-weight: bold;\n          font-size: 32px !important;\n        }\n      }\n    }\n    .about-clinic {\n      .arrow {\n        width: 111px;\n        height: 124px;\n        position: relative;\n        right: 196px;\n        opacity: 1;\n        top: -55px;\n        transform: rotate(320deg);\n      }\n\n      svg {\n        width: 100%;\n        height: 100%;\n      }\n    }\n    &.activeAnm {\n      .effects {\n        display: none;\n      }\n    }\n    .effects {\n      bottom: 80px !important;\n      width: 100px !important;\n    }\n  }\n}\n",".about-clinic-home {\n  width: calc(100% - 60px);\n  padding: 0 30px;\n  height: 800px;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  flex-direction: column;\n  overflow: hidden;\n  .container {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    height: 100%;\n    .right,\n    .left {\n      width: 48%;\n      height: calc(100% - 100px);\n    }\n  }\n  .head-title {\n    font-size: 50px;\n    font-weight: bold;\n    width: max-content;\n    position: relative;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    span {\n      position: relative;\n      z-index: 2;\n      color: #413634;\n    }\n    &::before {\n      content: \"\";\n      bottom: 5px;\n      position: absolute;\n      left: 50%;\n      height: 30px;\n      width: 117%;\n      z-index: 1;\n      background-color: #ffdead;\n      transform: translateX(-50%);\n    }\n  }\n  .right {\n    display: flex;\n    flex-direction: column;\n\n    .text {\n      width: 100%;\n      height: 100%;\n      line-height: 2.5;\n      font-size: 20px;\n      font-weight: 600;\n      color: #7a7a7a;\n      position: relative;\n\n      textarea {\n        width: 100%;\n        height: 100%;\n        resize: none;\n      }\n      .edit-icon,\n      .save-icon {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        background-color: #d0d0d0;\n        z-index: 2;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 60px;\n        width: 60px;\n      }\n    }\n    .bottom {\n      display: flex;\n      gap: 10px;\n      margin-top: 20px;\n      .one {\n        width: 80px;\n        height: 4px;\n        background-color: #413634;\n        border-radius: 10px;\n      }\n      .two {\n        width: 20px;\n        height: 4px;\n        background-color: #413634;\n        border-radius: 10px;\n      }\n    }\n  }\n  .left {\n    position: relative;\n    .images {\n      position: relative;\n      width: 100%;\n      height: 100%;\n      .image-container {\n        width: 45%;\n        height: 55%;\n        border-radius: 30px;\n        position: absolute;\n        .image {\n          height: 100%;\n          width: 100%;\n        }\n        &.one {\n          top: 35%;\n          left: 44%;\n          z-index: 2;\n          animation: dream 2s infinite alternate; /* Key part */\n        }\n        &.two {\n          bottom: 45%;\n          right: 44%;\n          z-index: 1;\n          animation: dream2 2s infinite alternate; /* Key part */\n        }\n        .add-icon {\n          position: absolute;\n          top: 0;\n          left: 0;\n          background-color: #ededed;\n          z-index: 2;\n          cursor: pointer;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          height: 60px;\n          width: 60px;\n          &:hover {\n            .img {\n              transition: 0.5s;\n              opacity: 1;\n            }\n          }\n        }\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          border-radius: 30px;\n        }\n      }\n    }\n    .effects {\n      position: absolute;\n      left: 0;\n      z-index: 1;\n      width: 100%;\n      height: 100%;\n      bottom: 0;\n\n      .effect {\n        border-radius: 50%;\n        background-color: #413634;\n        position: absolute;\n        &.one {\n          width: 450px;\n          height: 450px;\n          left: -17%;\n          bottom: -15%;\n        }\n        &.two {\n          width: 100px;\n          height: 100px;\n          top: 29%;\n          right: 0%;\n        }\n        &.thee {\n          top: 22%;\n          right: 15%;\n          width: 40px;\n          height: 40px;\n        }\n      }\n    }\n  }\n  @keyframes dream {\n    0% {\n      transform: translateY(0);\n    }\n    100% {\n      transform: translateY(20px);\n    }\n  }\n  @keyframes dream2 {\n    0% {\n      transform: translateY(20px);\n    }\n    100% {\n      transform: translateY(0);\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .about-clinic-home {\n    flex-direction: column;\n    height: max-content;\n    width: calc(100% - 60px);\n    padding-bottom: 0;\n    .head-title {\n      margin: 0 auto;\n      margin-top: 30px;\n    }\n    .container {\n      flex-direction: column-reverse;\n      .right,\n      .left {\n        width: 100%;\n        height: max-content;\n      }\n    }\n    .right {\n      margin-bottom: 0;\n      .text {\n        line-height: 2.3;\n        font-size: 16px;\n      }\n    }\n    .left {\n      height: 500px !important;\n      margin-bottom: 100px;\n      .images {\n        .image {\n          width: 200px;\n        }\n      }\n      .effects {\n        width: 100%;\n        .effect.one {\n          width: 350px;\n          height: 350px;\n          left: 3px !important;\n        }\n      }\n      .images {\n        margin-top: 37px;\n      }\n    }\n  }\n}\n",".about-dr-home {\n  width: calc(100% - 60px);\n  padding: 0 30px;\n  height: 600px;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  .background {\n    width: 59%;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    top: 0;\n    opacity: 1;\n    background: #fdf8f2;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n    }\n  }\n  .right,\n  .left {\n    height: calc(100% - 100px);\n    position: relative;\n    z-index: 2;\n  }\n\n  .right {\n    position: relative;\n    width: 40%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .image {\n      width: max-content;\n      height: 100%;\n      border-radius: 30px;\n      animation: dream 2s infinite alternate; /* Key part */\n      position: relative;\n      &:hover {\n        .data {\n          opacity: 1;\n          transition: opacity 0.5s;\n          top: -12px;\n          left: 7px;\n          border-radius: 10px;\n        }\n      }\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        border-radius: 30px;\n      }\n      .add-icon {\n        position: absolute;\n        top: 0;\n        left: 0;\n        background-color: #ffff;\n        z-index: 2;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 60px;\n        width: 60px;\n        z-index: 55555;\n        &:hover {\n          .img {\n            transition: 0.5s;\n            opacity: 1;\n          }\n        }\n      }\n      .data {\n        position: absolute;\n        z-index: 2;\n        top: 1%;\n        left: 200%;\n        width: 97%;\n\n        height: 100%;\n        cursor: pointer;\n        opacity: 0;\n        transition: opacity 0.5s;\n\n        .layout {\n          width: 100%;\n          height: 100%;\n          background: linear-gradient(#00000000 70%, #413634 98%);\n          border-radius: 30px;\n        }\n        .text {\n          position: absolute;\n          bottom: 25px;\n          font-weight: bold;\n          width: max-content;\n          color: #fff;\n          font-size: 18px;\n          left: 50%;\n          transform: translateX(-50%);\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n          align-items: center;\n          text-transform: capitalize;\n          gap: 5px;\n          .info {\n            text-transform: uppercase;\n          }\n        }\n      }\n    }\n  }\n  .left {\n    display: flex;\n    flex-direction: column;\n    width: 55%;\n\n    .head-title {\n      font-size: 50px;\n      font-weight: bold;\n      width: max-content;\n      position: relative;\n      margin-bottom: 30px;\n      .title {\n        font-size: 50px;\n        font-weight: bold;\n        width: max-content;\n        position: relative;\n        span {\n          position: relative;\n          z-index: 2;\n          color: #413634;\n        }\n        &::before {\n          content: \"\";\n          bottom: 5px;\n          position: absolute;\n          left: 50%;\n          height: 30px;\n          width: 117%;\n          z-index: 1;\n          background-color: #ffdead;\n          transform: translateX(-50%);\n        }\n      }\n      .info {\n        font-size: 21px;\n      }\n    }\n    .skills {\n      width: 80%;\n      height: max-content;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      gap: 30px;\n      font-size: 24px;\n      margin: 20px 0 50px;\n      font-weight: bold;\n\n      .skill {\n        color: #413634;\n        position: relative;\n        margin-right: 30px;\n        &::before {\n          content: \"\";\n          height: 20px;\n          width: 20px;\n          background-color: #ffdead;\n          top: 50%;\n          position: absolute;\n          right: -30px;\n          transform: translateY(-50%);\n          border-radius: 50%;\n        }\n      }\n    }\n    .locations {\n      width: 100%;\n      justify-content: space-between;\n      display: flex;\n      width: 60%;\n      .location {\n        width: max-content;\n        padding: 9px 14px;\n        font-size: 14px;\n        height: 40px;\n        font-weight: bold;\n        color: #000;\n        border: 1px solid #413634;\n        border-radius: 20px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n  }\n\n  @keyframes dream {\n    0% {\n      transform: translateY(0);\n    }\n    100% {\n      transform: translateY(20px);\n    }\n  }\n}\n@media (max-width: 768px) {\n  .about-dr-home {\n    flex-direction: column-reverse;\n    height: max-content;\n    width: calc(100% - 60px);\n    .head-title {\n      margin: 0 auto;\n      margin-top: 30px;\n    }\n    .right,\n    .left {\n      width: 100%;\n      height: max-content;\n      margin-bottom: 20px;\n    }\n    .left {\n      .effects {\n        width: 100%;\n        .effect.one {\n          width: 350px;\n          height: 350px;\n          left: 3px !important;\n        }\n      }\n      .skills {\n        width: 100%;\n\n        .skill {\n          width: 100%;\n          font-size: 20px;\n        }\n      }\n      .locations {\n        display: flex;\n        width: 100%;\n        justify-content: space-between;\n\n        .location {\n          width: calc(48% - 20px) !important;\n          padding: 8px 10px;\n          font-size: 11px !important;\n        }\n      }\n      .images {\n        margin-top: 37px;\n      }\n    }\n  }\n}\n",".certificates-home {\n  width: 100%;\n  padding: 0 0;\n  min-height: 600px;\n  height: max-content;\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 50px;\n  padding-bottom: 50px;\n  .background {\n    width: 100%;\n    height: 88%;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    opacity: 0.04;\n    background: #fdf8f2;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n  .head-title {\n    font-size: 50px;\n    font-weight: bold;\n    width: 100%;\n    position: relative;\n    margin-bottom: 30px;\n    .title {\n      font-size: 50px;\n      font-weight: bold;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: relative;\n      .add-icon {\n        position: absolute;\n        top: 22%;\n        left: 10%;\n        background-color: white;\n        z-index: 2;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 60px;\n        width: 60px;\n        border-radius: -11px;\n        z-index: 55555;\n        &:hover {\n          .img {\n            transition: 0.5s;\n            opacity: 1;\n          }\n        }\n      }\n      span {\n        position: relative;\n        z-index: 2;\n        color: #413634;\n        text-align: center;\n      }\n      &::before {\n        content: \"\";\n        bottom: 5px;\n        position: absolute;\n        left: 50%;\n        height: 30px;\n        width: 80%;\n        z-index: 1;\n        background-color: #ffdead;\n        transform: translateX(-50%);\n      }\n    }\n    .info {\n      font-size: 21px;\n    }\n  }\n  .certificates {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    justify-content: space-between;\n    position: relative;\n    z-index: 2;\n    &.pc {\n      display: flex;\n      padding-bottom: 40px;\n      overflow-x: scroll;\n      overflow-y: hidden;\n      justify-content: space-between;\n      .certificate {\n        width: 300px !important;\n      }\n    }\n    .mySwiper {\n      width: 100%;\n      height: max-content;\n      padding-bottom: 50px;\n\n      .swiper-pagination {\n        bottom: 30px;\n      }\n      .swiper-slide-prev,\n      .swiper-slide-next {\n        opacity: 0.7;\n        transition: 0.5s;\n      }\n    }\n    .certificate {\n      width: 300px !important;\n      height: 400px;\n      transition: 0.5s;\n      border-radius: 15px;\n      box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px,\n        rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;\n      position: relative;\n      margin-top: 30px;\n      margin-left: 12px;\n      margin-right: 12px;\n      .del-icon {\n        position: absolute;\n        top: 0;\n        left: 0;\n        background-color: #d0d0d0;\n        z-index: 555;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 60px;\n        width: 60px;\n        border-radius: 10px 0 0 0;\n      }\n      .image {\n        width: 300px;\n        height: 100%;\n        border-radius: 15px;\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          border-radius: 15px;\n          transition: 0.5s;\n        }\n      }\n      .data {\n        position: absolute;\n        z-index: -2;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        cursor: pointer;\n        opacity: 0;\n        transition: opacity 0.5s;\n        border-radius: 15px;\n\n        .layout {\n          width: 100%;\n          height: 100%;\n          background: linear-gradient(#00000000 70%, #413634 98%);\n          border-radius: 15px;\n        }\n        .text {\n          position: absolute;\n          bottom: 25px;\n          font-weight: bold;\n          width: max-content;\n          color: #fff;\n          font-size: 18px;\n          left: 50%;\n          transform: translateX(-50%);\n        }\n      }\n      &:hover {\n        .image {\n          img {\n            transition: 0.5s;\n            transform: scale(1);\n          }\n        }\n        .data {\n          opacity: 1;\n          transition: opacity 0.5s;\n          top: 0;\n          z-index: 2;\n        }\n      }\n    }\n  }\n  .effects {\n    position: absolute;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n\n    .effect {\n      position: absolute;\n      z-index: 1;\n      background-color: #ffdead;\n      border-radius: 50%;\n      &.middle {\n        width: 400px;\n        height: 400px;\n\n        top: 56%;\n        left: 50%;\n        transform: translateX(-50%) translateY(-50%);\n      }\n      &.two {\n        width: 100px;\n        height: 100px;\n        bottom: -16%;\n        right: -32%;\n        transform: translateX(-50%) translateY(-50%);\n      }\n    }\n  }\n}\n",".directions-home {\n  width: calc(100% - 60px);\n  padding: 0 30px;\n  min-height: 650px;\n  height: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding-bottom: 50px;\n  padding-top: 20px;\n  .background {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    opacity: 0.2;\n    background: #fdf8f2;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n  .head-title {\n    font-size: 50px;\n    font-weight: bold;\n    width: 100%;\n    position: relative;\n    margin-bottom: 30px;\n    z-index: 2;\n    .title {\n      font-weight: bold;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: relative;\n      span {\n        position: relative;\n        z-index: 2;\n        color: #413634;\n        text-align: center;\n      }\n      &::before {\n        content: \"\";\n        bottom: 5px;\n        position: absolute;\n        left: 50%;\n        height: 30px;\n        width: 100%;\n        z-index: 1;\n        background-color: #ffdead;\n        transform: translateX(-50%);\n      }\n    }\n    .add-icon {\n      position: absolute;\n      top: 22%;\n      left: 10%;\n      background-color: white;\n      z-index: 2;\n      cursor: pointer;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 60px;\n      width: 60px;\n      border-radius: -11px;\n      z-index: 55555;\n      &:hover {\n        .img {\n          transition: 0.5s;\n          opacity: 1;\n        }\n      }\n    }\n    .info {\n      font-size: 21px;\n    }\n  }\n  .box {\n    position: relative;\n    z-index: 2;\n    width: 95%;\n    height: 86%;\n    background-color: #fff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-top: 40px;\n    box-shadow: rgb(99 99 99 / 39%) 0px 2px 13px 3px;\n\n    .direction {\n      display: flex;\n      flex-direction: column;\n      width: 230px;\n      height: 230px;\n      margin: 10px;\n      justify-content: center;\n      gap: 20px;\n      align-items: center;\n      font-weight: bold;\n      font-size: 18px;\n      position: relative;\n      transition: 0.5s;\n      background-color: #fff;\n      &:not(:last-of-type):after {\n        content: \"\";\n        left: 0;\n        position: absolute;\n        top: 50%;\n        width: 1px;\n        height: 80%;\n        background-color: #413634;\n        transform: translateY(-50%);\n        transition: 0.1s;\n      }\n      &:hover {\n        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 10px 4px,\n          rgba(60, 64, 67, 0.15) 0px 1px 9px 4px;\n        transform: scale(1.05);\n        transition: 0.5s;\n        z-index: 3;\n        &::after {\n          width: 0;\n          height: 0;\n          transition: 0.1s;\n        }\n      }\n      .edit-icon,\n      .save-icon {\n        position: absolute;\n        top: 0;\n        left: 0;\n        background-color: #d0d0d0;\n        z-index: 2;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 60px;\n        width: 60px;\n      }\n      .image {\n        width: 130px;\n        height: 130px;\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: contain;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .directions-home {\n    flex-direction: column;\n    height: max-content;\n    width: calc(100% - 60px);\n    .head-title {\n      margin: 0 auto;\n      margin-top: 30px;\n      font-size: 20px;\n    }\n    .right,\n    .left {\n      width: 100%;\n      height: max-content;\n    }\n    .left {\n      height: 500px !important;\n      .effects {\n        width: 100%;\n        .effect.one {\n          width: 350px;\n          height: 350px;\n          left: 3px !important;\n        }\n      }\n      .images {\n        margin-top: 37px;\n      }\n    }\n\n    .box {\n      width: 100%;\n      justify-content: space-between;\n      align-items: start;\n\n      &:first-of-type {\n        .direction {\n          &:before {\n            content: \"\";\n            left: -10px;\n            position: absolute;\n            top: 50%;\n            width: 1px;\n            height: 80%;\n            background-color: #413634;\n            transform: translateY(-50%);\n            transition: 0.1s;\n          }\n        }\n      }\n      .direction {\n        width: 48% !important;\n        margin: 0;\n\n        &::after {\n          display: none;\n        }\n      }\n    }\n  }\n}\n",".social-admin {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 100dvh;\n  padding-top: 50px;\n  position: relative;\n  overflow-x: hidden;\n  .background {\n    width: 100%;\n    height: 321px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    opacity: 0.2;\n    background: #fdf8f2;\n    background-repeat: no-repeat;\n    z-index: 0;\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n  .section {\n    display: flex;\n    width: 100%;\n    height: 700px;\n    position: relative;\n    z-index: 2;\n    flex-direction: column;\n    color: #000;\n    text-decoration: none;\n    &.spic {\n      background-color: #fcf2ec;\n    }\n    .head-title {\n      font-size: 40px;\n      font-weight: bold;\n      width: max-content;\n      position: relative;\n      margin: 0 auto;\n      margin-bottom: 40px;\n      margin-top: 20px;\n      span {\n        position: relative;\n        z-index: 2;\n        color: #413634;\n      }\n      &::before {\n        content: \"\";\n        bottom: 5px;\n        position: absolute;\n        left: 50%;\n        height: 30px;\n        width: 104%;\n        transform: translateX(-50%);\n        z-index: 1;\n        background-color: #ffdead;\n      }\n    }\n    .section-container {\n      width: 100%;\n      display: flex;\n      height: 100%;\n      justify-content: space-between;\n      color: #000;\n      text-decoration: none;\n      .right {\n        width: calc(40% - 40px);\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        .anthor-title {\n          font-weight: bold;\n          width: 100%;\n          position: relative;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          .title {\n            font-size: 40px;\n            position: relative;\n            width: max-content;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            margin-right: 0 !important;\n            span {\n              position: relative;\n              z-index: 2;\n              width: max-content;\n              color: #413634;\n            }\n            &::before {\n              content: \"\";\n              bottom: 5px;\n              position: absolute;\n              left: 50%;\n              height: 30px;\n              width: 104%;\n              transform: translateX(-50%);\n              z-index: 1;\n              background-color: #ffdead;\n            }\n          }\n          .info {\n            color: #413634;\n            font-weight: bold;\n            margin: 5px 0;\n            width: 83%;\n            text-align: center;\n          }\n        }\n        .location {\n          height: calc(100% - 100px);\n          width: calc(100% - 40px);\n          padding: 0 20px;\n          display: flex;\n          flex-direction: column;\n          position: relative;\n          margin-top: 20px;\n          .location {\n            width: 80%;\n            height: 80%;\n            img {\n              width: 100%;\n              height: 100%;\n              object-fit: contain;\n            }\n          }\n          // .city,\n          // .cinema {\n          //   display: flex;\n          //   flex-direction: column;\n          //   .group {\n          //     position: relative;\n          //     display: flex;\n          //     flex-direction: column;\n          //     align-items: center;\n          //     width: max-content;\n          //     font-weight: bold;\n          //     color: #413634;\n          //     font-size: 18px;\n          //   }\n          // }\n          // .cinema {\n          //   align-items: flex-end;\n          // }\n          // .tower {\n          //   position: relative;\n\n          //   padding-top: 10px;\n          //   display: flex;\n          //   width: 100%;\n          //   align-items: center;\n          //   justify-content: center;\n          //   position: relative;\n\n          //   .group {\n          //     display: flex;\n          //     height: 100px;\n          //     justify-content: space-between;\n          //     align-items: center;\n          //     position: relative;\n          //     left: 31px;\n\n          //     .grouping {\n          //       display: flex;\n          //       flex-direction: column;\n          //       color: #413634;\n          //       .group-title {\n          //         font-size: 18px;\n          //         font-weight: bold;\n          //       }\n          //       .group-desc {\n          //         font-size: 14px;\n          //         font-weight: 600;\n          //       }\n          //       .group-info {\n          //         font-size: 12px;\n          //         font-weight: normal;\n          //       }\n          //     }\n          //   }\n          // }\n          // .num {\n          //   position: absolute;\n          //   top: 0;\n          //   left: 0;\n          //   border: 1px solid #e94434;\n          //   width: 20px;\n          //   height: 20px;\n          //   display: flex;\n          //   align-items: center;\n          //   justify-content: center;\n          //   border-radius: 50%;\n          //   color: #e94434;\n          //   font-size: 12px;\n          //   font-weight: bold;\n          // }\n          // .icon {\n          //   width: 100px !important;\n          //   height: 100px !important;\n          // }\n        }\n      }\n      .left {\n        width: calc(55% - 40px);\n        padding-left: 40px;\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: center;\n        gap: 10px;\n        position: relative;\n        iframe {\n          width: 100%;\n          height: 80%;\n          border-radius: 10px;\n          box-shadow: rgb(0 0 0 / 0%) 0px 1px 20px 8px,\n            rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n        }\n        .info {\n          width: 30%;\n          position: absolute;\n          height: 50px;\n          border-radius: 30px;\n          bottom: 15%;\n          left: 50%;\n          transform: translateX(-45%);\n          border: 1px solid #413634;\n          background-color: #fcf2ec;\n          font-size: 20px;\n          font-weight: bold;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          cursor: pointer;\n          color: #000;\n          text-decoration: none;\n          a {\n            color: #000;\n            text-decoration: none;\n          }\n          .icon {\n            position: absolute;\n            right: 10px;\n            width: 30px;\n            height: 30px;\n            top: 50%;\n            transform: translateY(-50%);\n            color: #000;\n            text-decoration: none;\n          }\n        }\n      }\n    }\n    .simple-title {\n      font-size: 40px;\n      font-weight: bold;\n      width: max-content;\n      position: relative;\n      margin: 0 auto;\n      margin-bottom: 40px;\n      margin-top: 80px;\n      span {\n        position: relative;\n        z-index: 2;\n        color: #413634;\n      }\n      &::before {\n        content: \"\";\n        bottom: 5px;\n        position: absolute;\n        left: 50%;\n        height: 30px;\n        width: 104%;\n        transform: translateX(-50%);\n        z-index: 1;\n        background-color: #ffdead;\n      }\n    }\n    .container {\n      display: flex;\n      width: 90%;\n      margin: 0 auto;\n      display: flex;\n      justify-content: space-between;\n      color: #000;\n      text-decoration: none;\n      .contact {\n        width: 280px;\n        height: 280px;\n        display: flex;\n        flex-direction: column;\n        background-color: #fcf2ec;\n        justify-content: space-between;\n        align-items: center;\n        padding: 10px 0;\n        border-radius: 20px;\n        border: 1px solid transparent;\n        transition: 0.5s;\n        transform: scale(1);\n        color: #000;\n        text-decoration: none;\n        &:hover {\n          box-shadow: rgb(0 0 0 / 0%) 0px 1px 20px 8px,\n            rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n          border: 1px solid #413634;\n          transform: scale(1.1);\n          transition: 0.5s;\n        }\n        .icon {\n          width: 100px;\n          height: 100px;\n          margin-top: 20px;\n        }\n        .title {\n          font-size: 24px;\n          font-weight: bold;\n          margin-bottom: 40px;\n          width: 90%;\n          position: relative;\n          margin: 0 auto;\n          text-align: center;\n          color: #000;\n          text-decoration: none;\n          &::before {\n            content: \"\";\n            bottom: -20px;\n            position: absolute;\n            left: 0;\n            width: 100%;\n            height: 1px;\n            border-radius: 10px;\n            background-color: #413634;\n          }\n        }\n        .value {\n          font-weight: normal;\n          font-size: 18px;\n          margin: 0 auto;\n          text-align: center;\n          color: #000;\n          text-decoration: none;\n        }\n      }\n    }\n  }\n}\n@media (max-width: 768px) {\n  .social-admin {\n    height: max-content;\n    .background {\n      width: 100%;\n      height: 121px;\n      position: absolute;\n      right: 0;\n      top: 0;\n      opacity: 0.2;\n      background: #fdf8f2;\n      background-repeat: no-repeat;\n      z-index: 0;\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n    .head-title {\n      display: none;\n      margin-bottom: 30px;\n      .title {\n        margin-top: 10px;\n        margin-bottom: 30px;\n      }\n    }\n    .right,\n    .left {\n      width: 100% !important;\n      height: max-content !important;\n    }\n    .tower {\n      .group {\n        margin-left: 30px;\n      }\n    }\n    .left {\n      margin: 30px 0;\n      iframe {\n        width: 100%;\n        margin: 0 auto;\n        height: 300px !important;\n        width: 90% !important;\n      }\n      .info {\n        width: 52% !important;\n        position: absolute;\n        height: 50px;\n        border-radius: 30px;\n        bottom: -7% !important;\n        left: 50%;\n        transform: translateX(-50%);\n        border: 1px solid #413634;\n        background-color: #fcf2ec;\n        font-size: 20px;\n        font-weight: bold;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n      }\n    }\n    .section {\n      height: max-content !important;\n\n      .section-container {\n        width: 100%;\n        display: flex;\n        height: max-content !important;\n\n        justify-content: space-between;\n        flex-direction: column;\n        .anthor-title {\n          .title {\n            margin-right: 40px;\n            margin-top: 20px;\n          }\n          .info {\n            width: max-content;\n            font-size: 12px;\n          }\n        }\n\n        .location {\n          width: 100%;\n        }\n      }\n      .container {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 30px;\n        flex-wrap: wrap;\n        gap: 10px;\n        .contact {\n          width: calc(48% - 20px);\n          height: 185px;\n          margin-left: 10px;\n          margin-bottom: 10px;\n          .title {\n            font-size: 18px !important;\n            &::before {\n              display: none;\n            }\n          }\n          .value {\n            font-size: 16px !important;\n          }\n        }\n      }\n    }\n  }\n}\n",".services-admin {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 100dvh;\n  padding-top: 50px;\n  position: relative;\n  padding-bottom: 50px;\n\n  .background {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    top: 0;\n    opacity: 0.1;\n    background: #fdf8f2;\n    background-repeat: no-repeat;\n    z-index: 0;\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n\n  .head-title {\n    font-size: 40px;\n    font-weight: bold;\n    width: max-content;\n    position: relative;\n    margin: 0 auto;\n    margin-bottom: 40px;\n    margin-top: 20px;\n    z-index: 2;\n    span {\n      position: relative;\n      z-index: 2;\n      color: #413634;\n    }\n    .add-icon {\n      position: absolute;\n      top: 0%;\n      left: -35%;\n      background-color: rgb(255 255 255);\n      z-index: 2;\n      cursor: pointer;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 60px;\n      width: 60px;\n      border-radius: -11px;\n      z-index: 55555;\n      &:hover {\n        .img {\n          transition: 0.5s;\n          opacity: 1;\n        }\n      }\n    }\n    &::before {\n      content: \"\";\n      bottom: 5px;\n      position: absolute;\n      left: 50%;\n      height: 30px;\n      width: 104%;\n      transform: translateX(-50%);\n      z-index: 1;\n      background-color: #ffdead;\n    }\n  }\n\n  .services-container {\n    width: 90%;\n    margin: 0 auto;\n    height: calc(100% - 240px);\n    position: relative;\n    z-index: 2;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 30px;\n    .service {\n      display: flex;\n      background-color: #fdf8f2;\n      width: 350px;\n      height: 520px;\n      border-radius: 10px;\n      flex-direction: column;\n      align-items: center;\n      transition: 0.5s;\n      border: 1px solid transparent;\n      position: relative;\n      &:hover {\n        transition: 0.5s;\n        box-shadow: rgb(0 0 0 / 0%) 0px 1px 20px 8px,\n          rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n        border: 1px solid #413634;\n      }\n      .edit-icon,\n      .save-icon {\n        position: absolute;\n        top: 0;\n        left: 0;\n        background-color: #d0d0d0;\n        z-index: 2;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 60px;\n        width: 60px;\n        border-radius: 10px 0 0 0;\n      }\n      .del-icon {\n        position: absolute;\n        top: 0;\n        right: 0;\n        background-color: #d0d0d0;\n        z-index: 2;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 60px;\n        width: 60px;\n        border-radius: 10px 0 0 0;\n      }\n      .content {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 90%;\n        flex-direction: column;\n        margin-bottom: 40px;\n        position: relative;\n        &::before {\n          content: \"\";\n          bottom: -20px;\n          position: absolute;\n          left: 0;\n          width: 100%;\n          height: 1px;\n          border-radius: 10px;\n          background-color: #413634;\n        }\n        .icon {\n          width: 140px;\n          height: 140px;\n          margin-top: 20px;\n          margin-bottom: 20px;\n        }\n        .title {\n          font-size: 24px;\n          margin-top: 10px;\n          font-weight: bold;\n          color: #413634;\n        }\n      }\n\n      .grouping {\n        display: flex;\n        width: 90%;\n\n        flex-direction: column;\n        align-items: center;\n        gap: 15px;\n        margin-bottom: 30px;\n        .info {\n          font-size: 16px;\n          line-height: 2;\n          text-align: center;\n          color: #525252;\n        }\n        .images {\n          width: 50px;\n          height: 50px;\n          cursor: pointer;\n        }\n      }\n\n      &.spic {\n        background-color: transparent;\n        &:hover {\n          transition: 0.5s;\n          box-shadow: none;\n          border: 1px solid transparent;\n        }\n        .content {\n          height: 150px;\n          background-color: #413634;\n          width: 100%;\n          margin-bottom: 10px;\n          &::before {\n            display: none;\n          }\n          .title {\n            color: #fff;\n            margin-bottom: 10px;\n          }\n          border-radius: 10px;\n        }\n      }\n      .service-container {\n        display: flex;\n        height: 100%;\n        flex-direction: column;\n        gap: 20px;\n        height: calc(100% - 150px);\n        width: 100%;\n        .service-d {\n          width: 100%;\n          background-color: #fdf8f2;\n          border: 1px solid #413634;\n          border-radius: 10px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          height: auto;\n          padding: 15px 0;\n          color: #000;\n          font-weight: bold;\n          cursor: pointer;\n          overflow: hidden;\n          transition: 0.5s;\n          span {\n            width: 100%;\n            text-align: center;\n          }\n          .icon {\n            width: 30px;\n            height: 30px;\n            position: relative;\n            left: -100%;\n            transition: 0.5s;\n          }\n\n          &:hover {\n            transition: 0.5s;\n            box-shadow: rgb(0 0 0 / 0%) 0px 1px 20px 8px,\n              rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n            border: 1px solid #413634;\n            width: 105%;\n\n            .icon {\n              left: 20px;\n              transition: 0.5s;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n@media (max-width: 768px) {\n  .services-admin {\n    height: max-content;\n    .background {\n      width: 100%;\n      height: 121px;\n      position: absolute;\n      right: 0;\n      top: 0;\n      opacity: 0.2;\n      background: #fdf8f2;\n      background-repeat: no-repeat;\n      z-index: 0;\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n    .head-title {\n      margin-bottom: 30px;\n      .title {\n        margin-top: 10px;\n        margin-bottom: 30px;\n      }\n    }\n    .services-container {\n      height: max-content;\n      width: 100%;\n      flex-direction: column;\n      padding-bottom: 50px;\n      gap: 40px;\n    }\n    .service {\n      width: 350px !important;\n      height: 450px !important;\n      &.spic {\n        .content {\n          height: max-content;\n          .icon {\n            width: 70px;\n            height: 70px;\n          }\n        }\n      }\n      .info {\n        font-size: 13px !important;\n      }\n    }\n  }\n}\n",".cases-admin {\n  background-color: #fdf8f2;\n  height: 100%;\n  width: 100%;\n  min-height: 600px;\n  padding-top: 50px;\n  position: relative;\n\n  .head-title {\n    font-size: 40px;\n    font-weight: bold;\n    width: max-content;\n    position: relative;\n    margin: 0 auto;\n    margin-bottom: 40px;\n    margin-top: 20px;\n    z-index: 2;\n    span {\n      position: relative;\n      z-index: 2;\n      color: #413634;\n    }\n    &::before {\n      content: \"\";\n      bottom: 5px;\n      position: absolute;\n      left: 50%;\n      height: 30px;\n      width: 104%;\n      transform: translateX(-50%);\n      z-index: 1;\n      background-color: #ffdead;\n    }\n  }\n  .boxes {\n    width: 90%;\n    margin: 0 auto;\n    height: 100%;\n    position: relative;\n    z-index: 2;\n    display: flex;\n    justify-content: center;\n    gap: 40px;\n    margin-top: 100px;\n    .box {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      background-color: #fdf8f2;\n      border: 1px solid transparent;\n      border-radius: 10px;\n      width: 300px;\n      height: 300px;\n      gap: 30px;\n      cursor: pointer;\n      transition: 0.5s;\n      transform: scale(1);\n\n      &:hover {\n        box-shadow: rgb(0 0 0 / 0%) 0px 1px 20px 8px,\n          rgba(0, 0, 0, 0.24) 0px 1px 20px 0px;\n        border: 1px solid #413634;\n        transform: scale(1.1);\n        transition: 0.5s;\n      }\n      .icon {\n        width: 150px;\n        height: 150px;\n      }\n      .title {\n        font-size: 18px;\n        font-weight: bold;\n      }\n    }\n  }\n}\n@media (max-width: 768px) {\n  .cases-admin {\n    height: max-content;\n    .background {\n      width: 100%;\n      height: 121px;\n      position: absolute;\n      right: 0;\n      top: 0;\n      opacity: 0.2;\n      background: #fdf8f2;\n      background-repeat: no-repeat;\n      z-index: 0;\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n    .head-title {\n      margin-bottom: 30px;\n      .title {\n        margin-top: 10px;\n        margin-bottom: 30px;\n      }\n    }\n    .boxes {\n      height: max-content;\n      width: 100%;\n      flex-direction: column;\n      padding-bottom: 50px;\n      gap: 40px;\n      align-items: center;\n      .box {\n        width: 250px;\n        height: 250px;\n      }\n    }\n  }\n}\n",".login-page {\n  width: 100%;\n  min-height: 100dvb;\n  height: 100dvb;\n  max-height: 100dvb;\n  overflow: hidden;\n  background-color: #3e3e3e !important;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  .background {\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    left: 0;\n    z-index: 1;\n    bottom: 0;\n    cursor: pointer;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      cursor: pointer;\n    }\n  }\n  .container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    position: relative;\n    z-index: 4;\n    height: 70%;\n    .login-box {\n      height: 100%;\n      width: 400px;\n      display: flex;\n      justify-content: space-between;\n      flex-direction: column;\n      gap: 10px;\n      &.loading {\n        .head-box {\n          height: 80%;\n          flex-direction: column;\n          background-color: rgba(99, 255, 219, 0.444);\n          transition: 0.5s;\n          .image {\n            width: 280px;\n            height: 280px;\n            margin-top: 20px;\n            transition: 0.5s;\n          }\n        }\n        .box {\n          min-height: 10%;\n          padding-top: 10px;\n          transition: 0.5s;\n\n          .group {\n            display: none;\n          }\n          .head-title {\n            display: none;\n          }\n        }\n      }\n      .head-box {\n        height: 150px;\n        background: rgba(179, 179, 179, 0.25);\n        border-radius: 16px;\n        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n        backdrop-filter: blur(6.3px);\n        -webkit-backdrop-filter: blur(6.3px);\n        border: 1px solid rgba(179, 179, 179, 0.42);\n        display: flex;\n        width: calc(100% - 40px);\n        justify-content: space-between;\n        padding: 0 20px;\n        align-items: center;\n        transition: 0.5s;\n\n        .image {\n          width: 120px;\n          height: 120px;\n          transition: 0.5s;\n\n          img {\n            width: 100%;\n            height: 100%;\n          }\n        }\n        .group {\n          width: calc(100% - 150px);\n          height: 85%;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          flex-direction: column;\n          .title {\n            font-weight: bold;\n            position: relative;\n            font-size: 18px;\n            width: 100%;\n            text-align: center;\n            margin-bottom: 10px;\n\n            &::after {\n              content: \"\";\n              bottom: -10px;\n              left: 0;\n              height: 1px;\n              background-color: #fff;\n              width: 100%;\n              position: absolute;\n            }\n          }\n        }\n        .info {\n          width: 100%;\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          margin-top: 15px;\n          .grouping {\n            display: flex;\n            justify-content: start;\n            align-items: center;\n            gap: 2px;\n            width: 48%;\n            height: 20px;\n            &.spic {\n              justify-content: end;\n              .value {\n                direction: ltr;\n              }\n            }\n            .icon {\n              width: 20px;\n              height: 20px;\n            }\n            .title {\n              font-size: 14px;\n              width: calc(100% - 20px);\n            }\n          }\n        }\n      }\n      .box {\n        min-height: calc(96% - 180px);\n        height: max-content;\n        background: rgba(179, 179, 179, 0.25);\n        border-radius: 16px;\n        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n        backdrop-filter: blur(6.3px);\n        -webkit-backdrop-filter: blur(6.3px);\n        border: 1px solid rgba(179, 179, 179, 0.42);\n        width: calc(100% - 40px);\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        padding: 0 20px;\n        gap: 40px;\n        align-items: center;\n        padding-bottom: 20px;\n        transition: 0.5s;\n\n        .head-title {\n          font-size: 24px;\n          font-weight: bold;\n          margin: 20px 0 10px;\n        }\n        .group {\n          height: 40%;\n          width: 90%;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          gap: 20px;\n          flex-direction: column;\n          input {\n            width: 100%;\n            outline: none;\n            border: 1px solid #3e3e3e;\n            background-color: #fff;\n            height: 50px;\n            border-radius: 10px;\n            text-align: center;\n          }\n        }\n        .login-btn {\n          width: 90%;\n          height: 40px;\n          border-radius: 20px;\n          display: flex;\n          justify-content: center;\n          padding: 10px 0;\n          align-items: center;\n          background-color: #ffc73d;\n          color: #000;\n          font-weight: bold;\n          font-size: 18px;\n          cursor: pointer;\n          margin-bottom: 6px;\n        }\n      }\n    }\n    .left {\n      height: 100%;\n      width: 280px;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      flex-direction: column;\n      .group {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        width: 100%;\n        .company-name {\n          height: 80px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          font-weight: bold;\n          text-transform: uppercase;\n          color: #fff;\n          font-size: 24px;\n          direction: ltr;\n        }\n        .logo {\n          width: 100%;\n          height: 200px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          img {\n            width: 90%;\n            height: 90%;\n            object-fit: contain;\n          }\n        }\n      }\n      .copyright {\n        height: 80px;\n        display: flex;\n        justify-content: center;\n        align-items: start;\n        gap: 10px;\n        padding-left: 10px;\n        font-weight: bold;\n        text-transform: uppercase;\n        flex-direction: column;\n        width: 379px;\n        position: relative;\n        left: 50px;\n        direction: ltr;\n        .title {\n          font-size: 24px;\n          margin-bottom: -10px;\n        }\n        .info {\n          font-size: 14px;\n          font-weight: 600;\n        }\n      }\n      .box {\n        background: rgba(179, 179, 179, 0.25);\n        border-radius: 16px;\n        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n        backdrop-filter: blur(6.3px);\n        -webkit-backdrop-filter: blur(6.3px);\n        border: 1px solid rgba(179, 179, 179, 0.42);\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .login-page {\n    align-items: start;\n    gap: 40px;\n    .container {\n      margin-top: 50px;\n      display: flex;\n      flex-direction: column;\n      width: 90%;\n      justify-content: space-between;\n      gap: 40px;\n      height: 100%;\n      .head-box {\n        .value {\n          font-size: 10px;\n          font-weight: bold;\n        }\n      }\n      .login-box {\n        width: 100%;\n        gap: 10px;\n        height: 67%;\n        .box {\n          height: calc(100% - 90px);\n        }\n      }\n      .left {\n        width: 100%;\n        height: 27%;\n        .group {\n          flex-direction: row;\n          width: 100%;\n          align-items: flex-end;\n          justify-content: flex-end;\n          .copyright {\n            width: calc(100% - 120px);\n            left: 0;\n            height: 60px;\n            .title {\n              font-size: 18px;\n            }\n            .info {\n              font-size: 12px;\n            }\n          }\n          .logo {\n            width: 120px;\n            height: 120px;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
